// IMPORTANT - DO NOT USE JQUERY IN FILE
// TODO - should .style.display = "" be changed to adding/removing hide class?
// TODO - #reviews (etc) url hash needs to click on the tab once it is scrolled to
(function () {
    // Localized variables kept in localizeddetails file
    var localizedJS = new localizedDetails(),
        glide = new Glide4imprint(),
        prodScrollerJS = new prodScroller(),
        animate = new animations4i(),
        restrictedPricingDialog = new dialog4i(),
        guaranteeDialog = new dialog4i(),
        threeSixtyDialog = new dialog4i(),
        artInstDialog = new dialog4i(),
        prop65Dialog = new dialog4i(),
        zoomDialog = new dialog4i(),
        tooltips = new toolTips(),
        copyTabs = new tabs4i(),
        detailTabs = new tabs4i(),
        scrollerTabs = new tabs4i(),
        forms = new forms4i(),
        steppingQty = document.getElementById('litSteppingQty') ? parseInt(document.getElementById('litSteppingQty').value) : "",
        antiForgeryToken = { "__RequestVerificationToken": document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value },
        selBaseTrim = document.getElementById('selectedColorID'),
        catAlias = document.getElementById('CatalogAlias').value,
        isSuspended = document.getElementById("isSuspended") ? document.getElementById("isSuspended").value == 'True' : false,
        isApparelItem = document.getElementsByClassName('isApparelItem')[0].value == "True",
        isGFeed = window.location.search.indexOf("gfeed=1") != -1 ? true : false,
        currencySymbol = document.getElementById('tdCurrencySymbol').value,
        nibInkInput = document.getElementById('nibInkSelection'),
        adhesiveInput = document.getElementById('adhesiveSelection'),
        recolorAvailable = document.getElementById("isRecolorable"),
        reportSKU = document.getElementById('ReportSKU').value,
        ukShippingCost = document.getElementById('UKShippingCost').value, // is this used? 
        ukTaxRate = document.getElementById('UKTaxRate').value,
        baseExtra = document.getElementById('BaseExtra').value, //is this used?
        restrict24hrMaxQty = document.getElementById('restrict24hrMaxQty') ? document.getElementById('restrict24hrMaxQty').value === 'True' : false,
        standardProdTimeProductUrl = document.getElementById('standardProdTimeProductUrl').value,
        standardProdTimeCatalogueAlias = document.getElementById('standardProdTimeCatalogueAlias').value,
        twentyFourHrLabel = document.getElementById('twentyFourHrLabel').value,
        txtTimer = null,
        isMobile = getComputedStyle(document.getElementsByClassName('contactPanel')[0]).display == 'none',
        isDesktop = getComputedStyle(document.getElementsByClassName('prodNumber')[0]).cssFloat == 'none',
        isTabMobile = getComputedStyle(document.getElementsByClassName('prodNumber')[0]).cssFloat == 'left',
        isGlide = document.getElementsByClassName("glide")[0] ? true : false,
        hasNonSizingAttributes = document.getElementById("hasNonSizingAttributes").value == "True" ? true : false,
        hasOptionalExtras = document.getElementById("hasOptionalExtras").value == "True" ? true : false,
        colorCapitalized = localizedJS.Color[0].toUpperCase() + localizedJS.Color.substring(1),
        colorDropdownPlaceholder = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + "...</span>",
        bypassImpConfig = document.querySelector(".bypassImpConfigAddToCart") ? true : false,
        processing = false,
        selectedProdColor,
        lastFocus,
        configSectionLoading = false,
        configSectionLoadingExtraChg = false,
        zoomSlider,
        prevQty = isApparelItem ? document.getElementById("txtQty") ? document.getElementById("txtQty").value : "0" : document.getElementById("txtQty") ? document.getElementById("txtQty").innerHTML : "0",
        errorMessageBox = '<div id="ErrorBox" class="ErrorMsgPanel" role="alert" aria-atomic="true">' +
        '<h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3><ul class="ErrorMsgBox"><li></li></ul></div>',
        glideRunCharge = document.getElementById("RunCharge") ? document.getElementById("RunCharge").value : 0,
        glideBaseExtras = document.getElementById("lblBaseExtras") ? document.getElementById("lblBaseExtras").innerHTML : 0,
        mainImgSlider = new tns({
            container: document.getElementById('main-slider'),
            rewind: true,
            lazyload: true,
            prevButton: document.getElementById('leftArrowClick'),
            nextButton: document.getElementById('rightArrowClick'),
            speed: 500,
            nav: true,
            navPosition: "bottom"
        });

    glide.Init(arrBreak, arrPrice, steppingQty);

    var sliderGlide = (function(){
            var glidePrice,
                glideTotal,
                glideQuantity,
                glideAmountSaved,
                glideDiscountDiv,
                glideTotalDiv,
                glideQtyDiv,
                glideToolTip,
                glideWrapper,
                glideSlider,
                step2Btn,
                glideMinPoint,
                glideMaxPoint,
                singleBreak,

                initVariables = function(){
                    glidePrice = document.getElementById('lblPrice'),
                        glideTotal = document.getElementById("lblTotal"),
                        glideSubTotal = document.getElementById("lblSubtotal") ? document.getElementById("lblSubtotal") : null,
                        glideSummaryShown = document.getElementById("lblBaseExtras") ? true : false,
                        glideQuantity = document.getElementById("txtQty"),
                        glideAmountSaved = document.getElementById("YouSaveBox"),
                        glideDiscountDiv = document.getElementById("divYouSave"),
                        glideTotalDiv = document.getElementById("litGlideTotal"),
                        glideQtyDiv = document.getElementById("lblQuantityTxtCaption"),
                        glideToolTip = document.querySelector(".glideToolTip"),
                        glideWrapper = document.querySelector(".glide"),
                        glideSlider = document.querySelector(".glideSlider"),
                        step2Btn = document.querySelector(".step1"),
                        glideMinPoint = glide.MinPoint(),
                        glideMaxPoint = glide.MaxPoint(),
                        singleBreak = arrBreak[2] <= 0;
                },
                init = function(){
                    if(isGlide){
                        initVariables();

                        glideToolTip.classList.add("invisible"); // adding to prevent visual jump before styling - can be removed after next release 11/1

                        glideSlider.setAttribute("min", glideMinPoint);
                        glideSlider.setAttribute("max", glideMaxPoint);

                        /* IE11 does not support input event on ranges - boo
                         ** aka we'd have to use just the on change event but this
                         ** will not update the tooltip qty and price as you slide, only when you finish sliding
                         */
                        // https://www.impressivewebs.com/onchange-vs-oninput-for-range-sliders/
                        // internet explorer
                        glideSlider.addEventListener("change", function(e){
                            e.preventDefault();
                            updatePrice(glideSlider.value.toString());
                        });

                        // firefox and chrome
                        glideSlider.addEventListener("input", function(e){
                            e.preventDefault();
                            updatePrice(glideSlider.value.toString());
                        });

                        window.addEventListener("resize", function(){
                            if(window.innerWidth >= 800){
                                updateToolTip(); //recalculate the tooltip position
                            }
                        });

                        glideQuantity.addEventListener('keyup', function (e) {
                            if (isGFeed) {
                                document.getElementById('GFeedPanel').parentNode.removeChild(document.getElementById('GFeedPanel'));
                                glideTotalDiv.classList.remove("hide");
                                glideQtyDiv.classList.remove("hide");
                                glideWrapper.lastElementChild.classList.remove("hide"); //unit price
                            }
                            if ((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) { //enter key
                                textUpdateSliderFinish(glideQuantity.value, true);
                            } else {
                                textUpdateSlider(glideQuantity.value, true);
                            }
                            return false;
                        });

                        // when using up/down arrows on right side of input
                        glideQuantity.addEventListener('change', function () {
                            textUpdateSliderFinish(glideQuantity.value, true);
                        });

                        // If editing update the slider with the appropriate qty
                        if (editQty > 0) {
                            if (!isApparelItem) {
                                textUpdateSliderFinish(editQty, false);
                            } else {
                                CalcPrice();
                            }
                        }
                        // updates the tooltip after everything on page has loaded and is in correct position
                        setTimeout(function () {
                            updateToolTip();
                            glideToolTip.classList.remove("invisible"); //show tooltip after set correctly - prevents the visual jump
                        }, 600);
                    }
                },
                updateToolTip = function(){
                    // position
                    var val = parseInt(glideSlider.value, 10);
                    var pos = (val - glideMinPoint)/(glideMaxPoint - glideMinPoint);
                    var glideThumbWidth = 34;
                    var thumbCorrect = glideThumbWidth * (pos - 0.5) * -1;
                    var titlepos = Math.round(( pos * glideSlider.offsetWidth ) - glideThumbWidth/4 + thumbCorrect );
                    glideToolTip.style.left = (titlepos + 20) + "px";

                    // content
                    var qty = glideSlider.value;
                    var firstDigit = glide.GetBreakSegment(qty);
                    var quantity = glide.GetSlideQty(firstDigit, qty);
                    glideToolTip.textContent = quantity;
                    
                    glideSlider.setAttribute("aria-valuetext", "Quantity selected is " + quantity);
			glideSlider.setAttribute("aria-valuenow", quantity);
                },
                textUpdateSlider = function(qty, focus) {
                    if (txtTimer != null) {
                        clearTimeout(txtTimer);
                    }
                    var updateTime = 750;
                    if (qty > lowestQty) updateTime = 750;
                    txtTimer = setTimeout(function () {
                        textUpdateSliderFinish(qty, focus);
                    }, updateTime);
                },
                checkForSingleQtyBreak = function() {
                    // The glide slider will be disabled if there is only one break, so need to fill the price each in with the one price
                    if (singleBreak) {
                        var price = arrPrice[1];
                        var qty = arrBreak[1];
                        glideQuantity.value = qty;
                        glidePrice.value = currencySymbol + price.toFixed(2);
                        glideTotal.innerHTML = currencySymbol + (price * qty).toFixed(2);
                        if (glideSummaryShown) {
                            glideSubTotal.innerHTML = currencySymbol + (price * qty).toFixed(2);
                        }
                        document.querySelector('.glideWrapper').classList.add('hide');
                        document.querySelector("#litGlideInstructions").querySelector(".showOnSmall").innerHTML = "Enter the quantity you'd like.";
                        document.querySelector("#litGlideInstructions").querySelector(".hideOnSmall").innerHTML = "Enter the quantity you'd like.";
                        if (document.getElementById("litGlidePatent")) {
                            document.getElementById("litGlidePatent").classList.add("hide");
                            document.getElementById("litGlidePatent").classList.remove("hideOnSmall");
                        }
                    }
                },
                updatePrice = function(qty) {
                    var firstDigit = glide.GetBreakSegment(qty);
                    var quantity = glide.GetSlideQty(firstDigit, qty);

                    if (isGFeed) {
                        var oldquant = isApparelItem ? parseInt(glideQuantity.innerHTML) : parseInt(glideQuantity.value);
                        if (oldquant !== quantity) {
                            if(document.getElementById('GFeedPanel')){
                                document.getElementById('GFeedPanel').style.display = "none";
                            }
                            glideTotalDiv.classList.remove("hide");
                            glideQtyDiv.classList.remove("hide");
                            glideWrapper.lastElementChild.classList.remove("hide"); //unit price
                        }
                    }
                    if (glide.MinBreakQty() <= quantity) {
                        if (firstDigit != null) {
                            var newPrice = glide.GetPriceEstimate(firstDigit, quantity, qty);
                            var startPrice = arrPrice[1]; // pricing always starts at index 1

                            updateToolTip();

                            glidePrice.value = currencySymbol + newPrice.toFixed(2);
                            if (glideSummaryShown && glideSubTotal) {
                                glideSubTotal.innerHTML = currencySymbol + (newPrice * quantity).toFixed(2);
                                var extrasTotal = parseFloat(parseFloat(glideBaseExtras) + (quantity * glideRunCharge));
                                document.getElementById("lblBaseExtras").innerHTML = currencySymbol + extrasTotal.toFixed(2);;
                                glideTotal.innerHTML = currencySymbol + ((newPrice * quantity) + parseFloat(extrasTotal)).toFixed(2);
                            } else {
                                glideTotal.innerHTML = currencySymbol + (newPrice * quantity).toFixed(2);
                            }
                            glideQuantity.value = quantity;

                            if (Math.round(newPrice * 100) >= Math.round(startPrice * 100)) {
                                if (!glideAmountSaved.classList.contains("invisible")) {
                                    glideAmountSaved.classList.add("invisible");
                                }
                            } else {
                                if (glideAmountSaved.classList.contains("invisible")) {
                                    glideAmountSaved.classList.remove("invisible");
                                }
                                glideDiscountDiv.innerHTML = (currencySymbol + ((startPrice * quantity) - (newPrice * quantity)).toFixed(2));
                            }
                            if (isMobile) {
				     if (document.getElementsByClassName("quantitySummary")[0]) {
				         document.getElementsByClassName("quantitySummary")[0].innerHTML = GetQty();
				     }
				     if (document.getElementsByClassName("prodColor")[0] && document.getElementsByClassName("prodColor")[0].innerHTML != "") {
				     	  ajaxActions.GetExtrasAmount();
				     }
				 }
                            //enableBtn();
                        }
                    }
                },
                triggerChange = function(){
                    var event = document.createEvent("Event");
                    event.initEvent("change", true, true);
                    glideSlider.dispatchEvent(event);
                },
                enableBtn = function(){
                    if (step2Btn) {
                        step2Btn.classList.remove('disabledBtn');
                        step2Btn.classList.add('bkgdBlue');
                        step2Btn.classList.add('whiteLink');
                    } else if (bypassImpConfig) {
                        document.querySelector('.btnAddToCart').classList.remove('disabledBtn');
                        document.querySelector('.btnAddToCart').classList.remove('bkgdMdGray');
                        document.querySelector('.btnAddToCart').classList.add('bkgdRed');
                        document.querySelector('.btnAddToCart').classList.add('whiteLink');
                    }
                },

                textUpdateSliderFinish = function(quantity, focus) {
                    quantity = Math.round(quantity); // if decimals are used in the input box
                    if(quantity == "" || quantity < 0){ //enforce min quantity
                        glideQuantity.value = lowestQty;
                        glideSlider.value = glide.SetSlideQty(lowestQty);
                        triggerChange();
                    }
                    if (glide.IsNumeric(quantity)) {
                        //enableBtn();
                        qty = parseInt(quantity);
                        var SlideQty = qty;
                        var quantBoxValue = glideQuantity.value;
                        var price;
                        if (lowestQty > qty) qty = lowestQty;  //enforce min quantity   	

                        //enforce max quantity
                        if (restrict24hrMaxQty && qty != glide.MaxBreakQty() && document.getElementById("twentyFourAlert")) {
                            document.getElementById("twentyFourAlert").parentNode.removeChild(document.getElementById("twentyFourAlert"));
                        }

                        if (restrict24hrMaxQty && qty > glide.MaxBreakQty()) {
                            const maxBreak = glide.MaxBreakQty();
                            qty = maxBreak;
                            glideQuantity.value = maxBreak;
                            quantBoxValue = maxBreak;

                            var quantityErrorHtml =
                                '<div class=\"alertBox alertWarning\" id="twentyFourAlert"><div class="alertInner"><svg class="alertBulb" height="25px" width="25px" aria-hidden="true"><use xlink: href="#svgIcon-hint"></use></svg><div class="alertText c-md-12">We\'re sorry, the ' + twentyFourHrLabel + ' service quantity limit is ' + glide.MaxBreakQty() + ' for this item. The amount you entered has been adjusted. <a href="' + standardProdTimeProductUrl + '">Shop item #' + standardProdTimeCatalogueAlias + ' with a standard production time</a> for higher quantities<br/></div></div></div>';
                            document.querySelector('.glideWrapper').insertAdjacentHTML('beforebegin', quantityErrorHtml);
                        }

                        // Only update the slider if there are multiple qty breaks
                        if (singleBreak) { // example: /product/6289/Soft-Carrying-Case
                            price = glidePrice.value.trim().substring(1); // Trims the currency symbol
                            glideTotal.innerHTML = (currencySymbol + (price * qty).toFixed(2));
                        }else{
                            var lastBreakQty = glide.MaxBreakQty();
                            // glideMaxPoint contains the maximum slide val and not quantity, cannot accurately compare the two - requires a conversion
                            if (qty > lastBreakQty) { // If the qty is greater than the end of the slider, need to set the value to slide to to the last break
                                glideSlider.value = glide.SetSlideQty(lastBreakQty);
                                triggerChange();
                            }else{
                                //glideSlider.dispatchEvent(new Event('change')); // does not work in IE 11
                                glideSlider.value = glide.SetSlideQty(quantBoxValue);
                                triggerChange();
                            }
                        }
                        // The slider doesn't deal in qtys, just percentages, so sometimes it will adjust the qty when it does
                        // its percentage calculation if the user typed a qty. This will reset it to the user entered value.
                        if (qty > SlideQty) {
                            glideQuantity.value = qty;
                            glideToolTip.textContent = qty;
                            price = glidePrice.value.trim().substring(1); // Trims the currency symbol
                            glideTotal.innerHTML = (currencySymbol + (price * qty).toFixed(2));
                            if (glideSummaryShown) {
                                glideSubTotal.innerHTML = currencySymbol + (price * qty).toFixed(2);
                            }
                        } else {
                            if (parseInt(glideQuantity.value) != qty) {
                                const enforcedStepQty = glide.EnforceSteppingQty(qty, steppingQty);
                                if (enforcedStepQty == qty) {
                                    glideQuantity.value = qty;
                                    glideToolTip.textContent = qty;
                                    price = glidePrice.value.trim().substring(1);
                                    glideTotal.innerHTML = (currencySymbol + (price * qty).toFixed(2));
                                    if (glideSummaryShown) {
                                        glideSubTotal.innerHTML = currencySymbol + (price * qty).toFixed(2);
                                    }
                                } else {
                                    glideSlider.value = glide.SetSlideQty(enforcedStepQty);
                                    triggerChange();
                                }
                            }
                        }
                    }
                };
            return{
                Init: init,
                CheckForSingleQtyBreak: checkForSingleQtyBreak,
                UpdateToolTip: updateToolTip
            };
        })(),

        ajaxActions = (function () {
            var serialize = function (form) {
                    /*!
                     * Serialize all form data into a query string
                     * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
                     * @param  {Node}   form The form to serialize
                     * @return {String}      The serialized form data
                     */
                    // Setup our serialized data
                    var serialized = [];
                    // Loop through each field in the form
                    for (var i = 0; i < form.elements.length; i++) {
                        var field = form.elements[i];
                        // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
                        if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;
                        // If a multi-select, get all selections
                        if (field.type === 'select-multiple') {
                            for (var n = 0; n < field.options.length; n++) {
                                if (!field.options[n].selected) continue;
                                serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
                            }
                        }
                        // Convert field data to a query string
                        else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                            serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
                        }
                    }
                    return serialized.join('&');
                },
                getCustomerImagePage = function (e) {
                    e.preventDefault();
                    var vals = this.id.split('_');
                    var page = vals[1];
                    loadingPage(document.getElementById('CustomerImagesContainer'));
                    var getImagesRequest = ajax({
                        url: removeTrailingSlash("/productmvc/customerimages/" + prodID + "/" + page),
                        method: "GET"
                    });
                    getImagesRequest.then(function (response, xhr) {
                        document.getElementById('customerImagesTSTab').innerHTML = '';
                        document.getElementById('customerImagesTSTab').innerHTML = response;
                        initCustomerImagesPages();
                        lazyloadImages.update();
                        document.getElementById("detailTabs").scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                        hideLoading(document.getElementById('CustomerImagesContainer'));
                    });
                    getImagesRequest.catch(function (response, xhr) {
                        hideLoading(document.getElementById('CustomerImagesContainer'));
                    });
                },
                getQAPage = function (e) {
                    e.preventDefault();
                    var vals = this.id.split('_');
                    var page = vals[1];
                    loadingPage(document.getElementById('QandAContainer'));
                    var getQuestionsPages = ajax({
                        url: removeTrailingSlash("/productmvc/qandapage/" + prodID + "/" + page),
                        method: "GET"
                    });
                    getQuestionsPages.then(function (response, xhr) {
                        document.getElementById('QandAPage').innerHTML = '';
                        document.getElementById('QandAPage').innerHTML = response;
                        initQAPages();
                        document.getElementById("QandAContainer").scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                        hideLoading(document.getElementById('QandAContainer'));
                        questionEvents();
                    });
                    getQuestionsPages.catch(function (response, xhr) {
                        hideLoading(document.getElementById('QandAContainer'));
                    });
                },
                getStoryPage = function (e) {
                    e.preventDefault();
                    var vals = this.id.split('_');
                    var page = vals[1];
                    loadingPage(document.getElementById('SuccessStoriesContainer'));
                    var getStories = ajax({
                        url: removeTrailingSlash("/productmvc/successstories/" + prodID + "/" + page),
                        method: "GET"
                    });
                    getStories.then(function (response, xhr) {
                        document.getElementById('successStoriesTSTab').innerHTML = '';
                        document.getElementById('successStoriesTSTab').innerHTML = response;
                        initSuccessPages();
                        document.getElementById("detailTabs").scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                        hideLoading(document.getElementById('SuccessStoriesContainer'));
                    });
                    getStories.catch(function (response, xhr) {
                        hideLoading(document.getElementById('SuccessStoriesContainer'));
                    });
                },
                getReviewPage = function (e) {
                    e.preventDefault();
                    var vals = this.id.split('_');
                    var page = vals[1];
                    loadingPage(document.getElementById('ReviewsContainer'));
                    var getReviewsRequest = ajax({
                        url: removeTrailingSlash("/productmvc/reviews/" + prodID + "/" + page + "/" + document.getElementById('reviewsPerPage').value + "/" + document.getElementById('reviewsOrderBy').value + "/" + document.getElementById('reviewsFilter').value),
                        method: "GET"
                    });
                    getReviewsRequest.then(function (response, xhr) {
                        document.getElementById('reviewsTSTab').innerHTML = '';
                        document.getElementById('reviewsTSTab').innerHTML = response;

                        initReviewPages();
                        initReviewFilters();
                        reviewEvents();
                        document.getElementById("reviewFilters").scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                        hideLoading(document.getElementById('ReviewsContainer'));
                    });
                    getReviewsRequest.catch(function (response, xhr) {
                        hideLoading(document.getElementById('ReviewsContainer'));
                    });
                },
                getFitRatingPage = function (e) {
                    e.preventDefault();
                    var vals = this.id.split('_');
                    var page = vals[1];
                    loadingPage(document.getElementById('FitRatingContainer'));
                    var getFitRating = ajax({
                        url: removeTrailingSlash("/productmvc/customerfitrating/" + prodID + "/" + page + "/" + document.getElementById('fitRatingFilter').value),
                        method: "GET"
                    });
                    getFitRating.then(function (response, xhr) {
                        document.getElementById('customerfitcomments').innerHTML = '';
                        document.getElementById('customerfitcomments').innerHTML = response;
                        initFitRatingPages();
                        document.getElementById("detailTabs").scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                        hideLoading(document.getElementById('FitRatingContainer'));
                    });
                },
                getAddlImpConfigPage = function (selectedLocationIds) {
                    document.getElementsByClassName("addImpLocLoadingImg")[selectedLocationIds.length - 1].classList.remove("hide");
                    var getAddlImpConfig = ajax({
                        url: "/product/addlimpconfig",
                        method: 'GET',
                        data: {
                            'selectedLocIDs': selectedLocationIds,
                            'EditID': editID,
                            'catalogAlias': catAlias
                        },
                    });
                    getAddlImpConfig.then(function (response, xhr) {
                        var impLocCount = selectedLocationIds.length;
                        document.getElementsByClassName("imprintConfiguration")[impLocCount - 1].insertAdjacentHTML('afterend', response);
                        var currentImpConfigSection = document.getElementsByClassName("imprintConfiguration")[impLocCount];
                        var firstColorSection = currentImpConfigSection.getElementsByClassName("imprint-color-section")[0];
                        document.getElementsByClassName("addImpLocLoadingImg")[impLocCount - 1].classList.add("hide");
                        var impLocCounts = [].slice.call(currentImpConfigSection.getElementsByClassName("impLocCount"));
                        impLocCounts.forEach(function (el) {
                            el.innerHTML = getLocationCountText(impLocCount);
                        });
                        if (firstColorSection) {
                            firstColorSection.getElementsByClassName("imprintClearColor")[0].classList.add("hide");
                        }
                        if (impLocCount > 1 && firstColorSection && !firstColorSection.querySelector(".prodColorOptions").classList.contains("disabledColorSelect")) {
                            firstColorSection.getElementsByClassName("colorList")[0].getElementsByClassName('imprintColorID')[0].value = '';
                        }
                        if (impLocCount >= 1) {
                            currentImpConfigSection.getElementsByClassName("impLocationCountHeader")[0].classList.remove("hide");
                        }
                        if (currentImpConfigSection.getElementsByClassName("imprint-color-section").length > 1) {
                            var imprintColorSections = [].slice.call(currentImpConfigSection.getElementsByClassName("imprint-color-section"));
                            imprintColorSections.forEach(function (el, index) {
                                if (index != 0) {
                                    el.getElementsByClassName("colorList")[0].getElementsByClassName('imprintColorID')[0].value = '';
                                    el.classList.add("hide");
                                }
                            });
                        }
                        setLocationCounts();
                        setUpColorDropDownEventListeners();
                        setUpImprintConfigEventListeners();
                        step2ScrollBehavior(currentImpConfigSection, false);
                        ValidateCustomizeSections();
                        ajaxActions.GetExtrasAmount();
                    });
                    getAddlImpConfig.catch(function (response, xhr) {
                        document.querySelector('.formHeading').insertAdjacentHTML('afterend', errorMessageBox);
                    });
                },
                loadSizing = function (basetrim, noPrice) {
                    document.getElementsByClassName('sizeGridLoadingImg')[0].classList.remove('hide');
                    var loadSizesRequest = ajax({
                        url: '/productmvc/loadsizeoptions',
                        method: 'POST',
                        data: {
                            'ProductID': prodID,
                            'Color': basetrim,
                            'EditID': editID,
                            'HidePricing': noPrice
                        },
                        timeout: 20000
                    });
                    loadSizesRequest.then(function (response, xhr) {
                        document.getElementById('SizingGrid').innerHTML = response;
                        
                        if (editID < 0 && isGFeed) {
                            document.getElementsByClassName('txtApparelQty')[0].value = lowestQty;
                        }
                        CalcPrice();
                        if (noPrice) {
                            document.getElementsByClassName('showp')[0].classList.add('hide');
                            document.getElementsByClassName('showpm')[0].classList.remove('hide');
                        }

                        if (document.getElementsByClassName("addMoreSizes")[0]) {
                            addSizesEvent();
                        } else if (document.getElementsByClassName('clearAllSizes')[0]) { // occurs when editing
                            clearSizesEvent();
                        }

                        var sizingInputs = [].slice.call(document.getElementsByClassName('txtApparelQty'));
                        sizingInputs.forEach(function (el, index, array) {
                            el.addEventListener("focusout", sizeInputsEvent);
                            el.addEventListener("keyup", sizeInputsEvent);
                        });

                        CheckQueryString();

                        if (document.getElementById("GFeedPanel")) {
                            document.getElementById('GFeedPanel').style.display = "block";
                            if (document.getElementById("GFeedPanel").style.display == "block") {
                                // apparel pricing is repeated, should be hidden until gfeed is hidden, then shown
                                document.getElementById("pricingarea").classList.add("hide");
                            } else {
                                document.getElementById("pricingarea").classList.remove("hide");
                            }
                        }
                        pricingHandlers();
                        document.getElementsByClassName('sizeGridLoadingImg')[0].classList.add('hide');
                    });
                    loadSizesRequest.catch(function (response, xhr) {
                        document.getElementById('SizingGrid').innerHTML = ('<div role="alert"aria-atomic="true" class="margin10 padding10 borderDkRed textDkRed clear">An error occured when looking up the available sizes. Please select ' + localizedJS.Color + ' again, or call us toll free at ' + localizedJS.PhoneNumber + ' for further assistance.</div>');
                        document.getElementsByClassName('sizeGridLoadingImg')[0].classList.add('hide');
                    });
                },
                loadOptionalExtras = function () {
                    var qty = GetQty();
                    if (!isNaN(qty)) {
                        var optExtrasRequest = ajax({
                            method: "POST",
                            url: "/productattribute/optionalextras",
                            data: {
                                'ProductID': prodID,
                                'Quantity': qty
                            },
                            timeout: 15000
                        }).then(function (response, xhr) {
                            document.getElementsByClassName("optExtrasLoadingImg")[0].classList.add("hide");
                            optionalExtras = response;

                            if (response != null && response.extras.length > 0) {
                                var ExtrasText = "<div class='extrasSection'>";

                                for (var i = 0; i < response.extras.length; i++) {
                                    var checkit = "";
                                    if (editID > 0) {
                                        if (document.querySelector('.SelectedOptionalExtras').value.indexOf('*' + response.extras[i].id + ',') != -1) {
                                            checkit = " checked = 'checked'";
                                        }
                                    }

                                    var unitprice = response.extras[i].unitprice;
                                    //var qty = document.querySelector(".selectedQty") ? document.querySelector(".selectedQty").innerHTML : "";
                                    var totalprice;
                                    if (!isNaN(unitprice) && qty != "") {
                                        totalprice = (unitprice * qty).toFixed(2);
                                    }
                                    ExtrasText += "<div class='imprintLocCheck clear'>";
                                    ExtrasText += "<input class='inlineMiddle optionalExtra' type='checkbox' value='" + response.extras[i].id + "' id='opt" + response.extras[i].id + "' name='opt" + response.extras[i].id + "'" + checkit + " />";
                                    ExtrasText += "<label class='inlineMiddle' for='opt" + response.extras[i].id + "'>" + response.extras[i].displayname;
                                    if (!isNaN(totalprice)) {
                                        ExtrasText += "<span> (" + response.extras[i].displaydesc + " Add " + currencySymbol + formatMoney(response.extras[i].unitprice) + " ea.)</span>";
                                    }
                                    ExtrasText += "</div>";
                                }
                                ExtrasText += "</div>";
                                if (document.getElementById("addlFeatureSelect")) {
                                    document.getElementById("addlFeatureSelect").parentNode.removeChild(document.getElementById("addlFeatureSelect"))
                                }
                                if (document.getElementsByClassName("extrasSection").length == 0) {
                                    document.getElementsByClassName('addlFeatSelect')[0].insertAdjacentHTML('afterend', ExtrasText);
                                }
                                var optionalExtrasChks = [].slice.call(document.getElementsByClassName("optionalExtra"));
                                optionalExtrasChks.forEach(function (elem) {
                                    elem.removeEventListener("change", AddSelectedExtra);
                                    elem.addEventListener("change", AddSelectedExtra);
                                });
                                document.getElementById('PD_OptionalExtra').style.display = "block";
                            }
                        }).catch(function (response, xhr) {
                            document.getElementById('PD_OptionalExtra').style.display = "none";
                        });
                    }
                },
                reviewChange = function () {
                    loadingPage(document.getElementById('ReviewsContainer'));
                    var reviewChange = ajax({
                        url: removeTrailingSlash("/productmvc/reviews/" + prodID + "/1/" + document.getElementById('reviewsPerPage').value + "/" + document.getElementById('reviewsOrderBy').value + "/" + document.getElementById('reviewsFilter').value),
                        method: "GET"
                    });
                    reviewChange.then(function (response, xhr) {
                        document.getElementById('reviewsTSTab').innerHTML = '';
                        document.getElementById('reviewsTSTab').innerHTML = response;
                        initReviewPages();
                        initReviewFilters();
                        hideLoading(document.getElementById('ReviewsContainer'));
                    });
                },
                loadAllReviews = function () {
                    loadingPage(document.getElementById('ReviewsContainer'));
                    var getAllReviews = ajax({
                        url: "/productmvc/reviews/" + prodID + "/1",
                        method: "GET"
                    });
                    getAllReviews.then(function (response, xhr) {
                        hideLoading(document.getElementById('ReviewsContainer'));
                        document.getElementById('reviewsTSTab').innerHTML = '';
                        document.getElementById('reviewsTSTab').innerHTML = response;
                        initReviewPages();
                        initReviewFilters();
                    });
                },
                reviewFilterChange = function (chosenFilter) {
                    loadingPage(document.getElementById('ReviewsContainer'));
                    var getReviews = ajax({
                        url: removeTrailingSlash("/productmvc/reviews/" + prodID + "/1/" + document.getElementById('reviewsPerPage').value + "/" + document.getElementById('reviewsOrderBy').value + "/" + chosenFilter),
                        method: "GET"
                    });
                    getReviews.then(function (response, xhr) {
                        document.getElementById('reviewsTSTab').innerHTML = '';
                        document.getElementById('reviewsTSTab').innerHTML = response;
                        initReviewPages();
                        initReviewFilters();
                        document.getElementById('reviewsOrderBy').focus();
                        document.getElementById('readAllReviews').addEventListener("click", loadAllReviews);
                    });
                },
                deleteRestrictedCart = function (cart) {
                    var dcid = document.getElementById('restrictedPricingProduct').getAttribute('data-cart-delete');
                    var deleteItem = ajax({
                        method: "POST",
                        url: "/cart/deleteitem",
                        data: {
                            cartId: cart,
                            cartItemId: dcid
                        },
                        headers: antiForgeryToken
                    });
                    deleteItem.then(function (response, xhr) {
                        //not sure what to do if they remove from cart, I think take them to the cart page for now
                        //window.location.href = cartUrl;
                        restrictedPricingDialog.close();
                        RestrictedPricing.Close(); // page was broken if this wasnt done - quick fix
                    });
                },
                getJumpToColors = function (color) {
                    var getColorOptions = ajax({
                        url: '/product/productcoloroptions',
                        method: 'post',
                        data: serialize(document.getElementById('productColors').getElementsByTagName('form')[0]) + '&chosenColorID=' + color
                    });
                    getColorOptions.then(function (response, xhr) {
                        colorOptionsClicksOff();
                        document.getElementById('productColors').innerHTML = response;
                        initProductColorScroller();
                        if (document.getElementById('removeColorFilter')) {
                            document.getElementById('removeColorFilter').focus();
                        } else {
                            document.getElementById('jumpToColor').focus();
                        }
                        colorOptionsClicks();
                        SaveProdColor(document.getElementsByClassName('imgBox')[0]);
                        document.getElementsByClassName('imgBox')[0].classList.add("imgActive");
                        tooltips.init(); // color tooltip
                    });
                },
                updateLocationDetails = function (selectedLocationIds, elem) {
                    var getImpLocationDetails = ajax({
                        url: '/product/getimplocationdetails',
                        method: 'post',
                        data: {
                            selectedLocIDs: selectedLocationIds,
                            impLocID: elem.value,
                            EditID: editID,
                            catalogAlias: catAlias
                        },
                        headers: antiForgeryToken
                    });
                    getImpLocationDetails.then(function (response, xhr) {
                        if (response.success != undefined && response.maxColors != undefined && response.imprintLocations != undefined && response.identicalColorPalettes != undefined) {
                            var imprintColorsCount = [].slice.call(elem.parentNode.parentNode.getElementsByClassName("imprintColorsCount"));
                            if (elem.parentNode.parentNode.querySelector(".imprint-color-section")) {
                                elem.parentNode.parentNode.getElementsByClassName("imprint-color-section")[0].classList.remove("hide");
                            }
                            imprintColorsCount.forEach(function (el) {
                                el.innerHTML = response.maxColors;
                                if (response.maxColors > 1) {
                                    el.parentNode.classList.remove("hide");
                                } else {
                                    el.parentNode.classList.add("hide");
                                }
                            });
                            if (response.maxColors == 1 || response.maxColors == (elem.parentNode.parentNode.getElementsByClassName("imprint-color-section").length - elem.parentNode.parentNode.querySelectorAll(".imprint-color-section.hide").length)) {
                                if (elem.parentNode.parentNode.getElementsByClassName("addImpColor")[0]) {
                                    elem.parentNode.parentNode.getElementsByClassName("addImpColor")[0].classList.add("hide");
                                }
                                if (response.numColorsOptionsAvailable == 1) {
                                    elem.parentNode.parentNode.querySelector(".spnColorChip").dispatchEvent(new MouseEvent('mousedown'));
                                }
                            } else if (response.maxColors == 0) {
                                elem.parentNode.parentNode.getElementsByClassName("imprint-color-section")[0].classList.add("hide");
                            } else {
                                elem.parentNode.parentNode.getElementsByClassName("addImpColor")[0].classList.remove("hide");
                            }
                            if (response.isExcl) {
                                if (elem.parentNode.parentNode.parentNode.getElementsByClassName("imprintConfiguration").length > 1) {
                                    var impConfigs = [].slice.call(document.getElementsByClassName("imprintConfiguration"));
                                    impConfigs.forEach(function(elem, index, array) {
                                    	if (elem != document.getElementsByClassName("imprintConfiguration")[0]) {
                                    		elem.parentNode.removeChild(elem);
                                		}
                                    });
                                }
                                if (elem.parentNode.parentNode.getElementsByClassName("addImpLocation")[0]) {
                                    elem.parentNode.parentNode.getElementsByClassName("addImpLocation")[0].classList.add("hide");
                                }
                                elem.parentNode.parentNode.getElementsByClassName("inputIsExcl")[0].value = "true";
                            } else {
                                if (document.getElementsByClassName("imprintConfiguration")[document.getElementsByClassName("imprintConfiguration").length - 1].getElementsByClassName("addImpLocation")[0] && response.addlImpLocs) {
                                    document.getElementsByClassName("imprintConfiguration")[document.getElementsByClassName("imprintConfiguration").length - 1].getElementsByClassName("addImpLocation")[0].classList.remove("hide");
                                }
                                elem.parentNode.parentNode.getElementsByClassName("inputIsExcl")[0].value = "false";
                            }
                            if (!response.identicalColorPalettes) {
                                elem.parentNode.parentNode.getElementsByClassName("input_active")[0].innerHTML = colorDropdownPlaceholder;
                                if (elem.parentNode.parentNode.getElementsByClassName("colorOptions")[0]) {
                                    var imprintLocationID = elem.parentNode.parentNode.getElementsByClassName("colorOptions")[0].querySelector(".imprintLocationID").value;
                                    var productImprintLocationID = elem.parentNode.parentNode.getElementsByClassName("colorOptions")[0].querySelector(".productImprintLocationID").value;
                                    var colorOptionContainers = [].slice.call(elem.parentNode.parentNode.getElementsByClassName("colorOptionsContainer"));
                                    colorOptionContainers.forEach(function (el) {
                                        el.parentNode.removeChild(el);
                                    });
                                    var newDiv = "";
                                    for (var i = 0; i < response.colorPalette.length; i++) {
                                        newDiv += '<div class="colorOptionsContainer colorId_' + response.colorPalette[i].ImprintColorID + '"><button role="option" aria-selected="false" class="spnColorChip marginTop5 darkestLink text14 textLeft c-xs-full floatLeft" title="' + response.colorPalette[i].ImprintColorDescription + '">';
                                        if (response.colorPalette[i].ImprintColorHex != "") {
                                            newDiv += '<span class="borderDkGray inlineMiddle colorOptionBox" style="background-color: #' + response.colorPalette[i].ImprintColorHex + '"></span>';
                                        }
                                        newDiv += '<span class="colorOptionText paddingLeft10 inlineMiddle"><span class="colorOptionDesc"> ' + response.colorPalette[i].ImprintColorDescription +
                                            '</span><span class="colorOptionId visually-hidden">' + response.colorPalette[i].ImprintColorID + '</span></span></button>';
                                        newDiv += '<input class="imprintLocationID" type="hidden" value="' + imprintLocationID + '" />';
                                        newDiv += '<input class="imprintColorID" type="hidden" value="' + response.colorPalette[i].ImprintColorID + '" />';
                                        newDiv += '<input class="productImprintLocationID" type="hidden" value="' + productImprintLocationID + '" /></div>';
                                    }
                                    var colorOptions = [].slice.call(elem.parentNode.parentNode.getElementsByClassName("colorOptions"));
                                    colorOptions.forEach(function (el) {
                                        el.insertAdjacentHTML('afterbegin', newDiv);
                                    });
                                    setUpColorDropDownEventListeners();
                                    var colorOptions2 = [].slice.call(elem.parentNode.parentNode.getElementsByClassName("colorOptions"));
                                    colorOptions2.forEach(function (el) {
                                        if (el.querySelectorAll(".colorOptionsContainer").length == 1) {
                                            el.parentNode.classList.add("disabledColorSelect");
                                            el.querySelector(".spnColorChip").dispatchEvent(new MouseEvent('mousedown'));
                                            el.parentNode.parentNode.getElementsByClassName("imprintClearColor")[0].classList.add("hide");
                                        } else {
                                            el.parentNode.classList.remove("disabledColorSelect");
                                        }
                                    });
                                }
                            }
                            var originalDropDown = [].slice.call(document.getElementsByClassName("selImprintLocation")[0].options);
                            var originalIndex = 0;
                            for (var i = 0; i < document.getElementsByClassName("selImprintLocation").length; i++) {
                                var currentImpLocSelect = document.getElementsByClassName("selImprintLocation")[i];
                                // Don't make any changes to the first select box or the one that was just changed 
                                if (currentImpLocSelect != elem && currentImpLocSelect != document.getElementsByClassName("selImprintLocation")[0]) {
                                    var indexStart = [].slice.call(document.getElementsByClassName("selImprintLocation")).indexOf(elem);
                                    // Remove the option that was just selected from the other select boxes (but only any after it) 
                                    var oneJustSelected = elem[elem.selectedIndex];
                                    for (var j = 0; j < currentImpLocSelect.options.length; j++) {
                                        if (currentImpLocSelect.options[j].value == oneJustSelected.value) {
                                            if (i > indexStart) { // only remove the option that was just selected from the select boxes after the one you are changing 
                                                currentImpLocSelect.options.remove(currentImpLocSelect.options[j].index);
                                            }
                                        }
                                    }
                                    // Add the option that was deselected to the other select boxes 
                                    var listOfCurrent = [].slice.call(currentImpLocSelect.options);
                                    var valuesArr = [];
                                    listOfCurrent.forEach(function (el) {
                                        valuesArr.push(el.value);
                                    });
                                    var listOfNotSelected = [].slice.call(response.imprintLocations);
                                    var valuesArr2 = [];
                                    listOfNotSelected.forEach(function (el2) {
                                        var newObject = {};
                                        newObject.text = el2.ImprintLocationDescription;
                                        newObject.value = el2.ImprintLocationID.toString();
                                        valuesArr2.push(newObject);
                                    });
                                    valuesArr2.forEach(function (el3) {
                                        if (!valuesArr.includes(el3.value)) {
                                            var newElem = document.createElement("option");
                                            newElem.text = el3.text;
                                            newElem.value = el3.value;
                                            originalDropDown.forEach(function (el, index, array) {
                                                if (el.value == el3.value) {
                                                    originalIndex = index;
                                                }
                                            });
                                            currentImpLocSelect.options.add(newElem, originalIndex);
                                        }
                                    });
                                    if (currentImpLocSelect.options.length > 1) {
                                        currentImpLocSelect.disabled = false;
                                    }
                                }
                            }
                        } else { // error 
                            if (document.getElementsByClassName('ErrorMsgPanel')[0]) {
                                document.getElementsByClassName('ErrorMsgPanel')[0].parentNode.removeChild(document.getElementsByClassName('ErrorMsgPanel')[0]);
                            }
                            var loadingConfigSectionError = '<div id="ErrorBox" class="ErrorMsgPanel clear" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>' +
                                '<ul class="ErrorMsgBox"><li><div id="loadingError" class="textLeft text16 textLeft">An error has occurred.  Please refresh the page and try again.</div></li></ul></div>';
                            document.querySelector('.formHeading').insertAdjacentHTML('afterend', loadingConfigSectionError);
                        }
                        if (elem.parentNode.parentNode.querySelector(".impLocLoadingImg")) {
                            elem.parentNode.parentNode.querySelector(".impLocLoadingImg").classList.add("hide");
                            elem.parentNode.parentNode.querySelector(".impLocLoadingOverlay").classList.add("hide");
                        }
                    });
                },
                getImpConfigSummary = function (editID, catAlias) {
                    if (document.getElementsByClassName("goToStep1")[0]) {
                        document.getElementsByClassName("goToStep1")[0].focus();
	                 document.getElementsByClassName('goToStep1')[0].scrollIntoView({
	                      behavior: "smooth"
	                  });
                    }
                    var getImpConfigSummary = ajax({
                        url: '/productmvc/impconfigsummary',
                        method: 'GET',
                        data: {
                            'EditID': document.getElementById('editID').value,
                            'catalogAlias': document.getElementById('CatalogAlias').value
                        },
                        headers: antiForgeryToken
                    });
                    getImpConfigSummary.then(function (response, xhr) {
                        if (document.getElementById("imprintLocations") || document.getElementsByClassName("bypassImpConfigAddToCart")[0]) {
                            if (document.getElementsByClassName("impConfigLoadingImg")[0]) {
                            	document.getElementsByClassName("impConfigLoadingImg")[0].classList.add("hide");
                        	 }
                            if (document.getElementById("imprintLocations")) {
                            	document.getElementById("imprintLocations").insertAdjacentHTML("afterend", response);
                            } else {
                            	document.getElementsByClassName("attributesLoadingImg")[0].parentNode.getElementsByClassName("formHeading")[0].insertAdjacentHTML("afterend", response);
                            }
                            forms.ClearValidation();
                            setUpImprintConfigEventListeners();
                            setUpColorDropDownEventListeners();
                            colorSelectorKeyboardFunctions();
                            setLocationCounts();
                            ValidateCustomizeSections();
                            CheckQueryString();
                            step2ScrollBehavior(document, true);
                            getAttributes();
                            if (configSectionLoading) {
                                configSectionLoading = false;
                                document.getElementsByClassName("btnAddToCart")[0].click();
                            }
                            if (configSectionLoadingExtraChg) {
                            	configSectionLoadingExtraChg = false;
					document.getElementsByClassName("setupTooltip")[0].click();
                            }
                        }
                    }).catch(function (response, xhr) {
                        if (document.getElementsByClassName('ErrorMsgPanel')[0]) {
                            document.getElementsByClassName('ErrorMsgPanel')[0].parentNode.removeChild(document.getElementsByClassName('ErrorMsgPanel')[0]);
                        }
                        document.querySelector(".impConfigLoadingImg").classList.add("hide");
                        var loadingConfigSectionError = '<div id="ErrorBox" class="ErrorMsgPanel clear" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>' +
                            '<ul class="ErrorMsgBox"><li><div id="loadingError" class="textLeft text16 textLeft">There was an error loading the page.  Please refresh and try again.</div></li></ul></div>';
                        document.querySelector('.formHeading').insertAdjacentHTML('afterend', loadingConfigSectionError);
                    });
                },

                loadAdhesiveOptions = function () {
                    var baseTrim = selBaseTrim.value;
                    if (baseTrim != undefined && baseTrim != "" && typeof prodID != 'undefined') {
                        var adhesiveRequest = ajax({
                            method: "POST",
                            url: "/productattribute/adhesive",
                            data: {
                                'ProductID': prodID,
                                'Color': baseTrim
                            },
                            timeout: 15000
                        }).then(function (response, xhr) {
                            document.getElementsByClassName("attributesLoadingImg")[0].classList.add("hide");
                            adhSidesOptions = response;
                            if (response != null && response.adhesive.length > 0) {
                                adhSidesOptions = response; // Set to the global object for use when the user is making selections
                                var AdhesiveOptions = [];
                                var AdhSideOptions = [];
                                var AdhesiveOptionIDs = [];
                                var AdhesiveSideIDs = [];
                                var EditAdhesiveValue = '';
                                var EditAdhSideValue = '';

                                for (var i = 0; i < response.adhesive.length; i++) {
                                    var optionFound = false;
                                    // Look to see if the option has already been added to the adhesive option array
                                    for (var j = 0; j < AdhesiveOptions.length; j++) {
                                        if (!optionFound && AdhesiveOptions[j] == response.adhesive[i].adh) {
                                            optionFound = true;
                                        }
                                    }
                                    // if the adhesive option was not found, add the option to the array for display
                                    if (!optionFound) {
                                        AdhesiveOptions[AdhesiveOptions.length] = response.adhesive[i].adh;
                                        AdhesiveOptionIDs[AdhesiveOptionIDs.length] = response.adhesive[i].id;
                                    } else {
                                        optionFound = false; // Reset the variable for the color check
                                    }
                                    // Look to see if the option has already been added to the side option array
                                    for (var k = 0; k < AdhSideOptions.length; k++) {
                                        if (!optionFound && AdhSideOptions[k] == response.adhesive[i].side) {
                                            optionFound = true;
                                        }
                                    }
                                    // if the side option was not found, add the option to the array for display
                                    if (!optionFound) {
                                        AdhSideOptions[AdhSideOptions.length] = response.adhesive[i].side;
                                        AdhesiveSideIDs[AdhesiveSideIDs.length] = response.adhesive[i].id;
                                    }
                                    if (editID > 0) {
                                        if (response.adhesive[i].id == adhesiveInput.value) {
                                            EditAdhSideValue = response.adhesive[i].side;
                                            EditAdhesiveValue = response.adhesive[i].adh;
                                        }
                                    }
                                }

                                // All adhesive and side options have been located, now display them
                                if (AdhesiveOptions.length >= 1) {
                                    AdhesiveOptions.sort();

                                    if (document.getElementById("adhOptions")) {
                                        document.querySelector("#adhOptions").removeEventListener("change", adhesiveOptionChanged); // Bind the handler to the new dropdowns
                                        for (var i = document.getElementById("adhOptions").options.length - 1; i >= 0; i--) {
                                            document.getElementById("adhOptions").remove(i);
                                        } // Remove any previously displayed options
                                    }
                                    var selectAdhOpt = '';
                                    if (AdhesiveOptions.length > 1) {
                                        selectAdhOpt += '<option id="defaultAdhOption" name="adhesive" value="">Select Adhesive Type...</option>';
                                    }
                                    for (var x = 0; x < AdhesiveOptions.length; x++) {
                                        var inputId = "adhesive" + x;
                                        selectAdhOpt += '<option id="' + inputId + '" name="adhesive" tabindex="0" value="' + AdhesiveOptions[x] + '"';
                                        // Set up the selected option, the first option by default if the item is not being edited
                                        if ((editID > 0 && AdhesiveOptions[x] == EditAdhesiveValue)) {
                                            selectAdhOpt += ' selected="selected"';
                                        }

                                        selectAdhOpt += '>' + AdhesiveOptions[x] + '</option>';
                                    }
                                    document.getElementById("adhOptions").insertAdjacentHTML('afterbegin', selectAdhOpt);
                                    document.getElementById("adhOptions").classList.add("txtReq");
                                    if (editID < 0 && AdhesiveOptions.length > 1) {
                                        document.getElementById("defaultAdhOption").setAttribute("selected", "selected");
                                    }

                                    if (AdhesiveOptions.length == 1) {
                                        document.getElementById("adhOptions").setAttribute("disabled", "disabled");
                                    } else {
                                        document.getElementById("adhOptions").disabled = false;
                                    }

                                    document.querySelector('.PD_Adhesive').style.display = "block";
                                    document.querySelector("#adhOptions").addEventListener("change", adhesiveOptionChanged); // Bind the handler to the new dropdowns
                                } else {
                                    document.querySelector('.PD_Adhesive').style.display = "none";
                                }
                                
                                if (AdhSideOptions.length >= 1) {
                                    AdhSideOptions.sort();

                                    if (document.getElementById("adhSideOptions")) {
                                        document.querySelector("#adhSideOptions").removeEventListener("change", adhesiveOptionChanged); // Bind the handler to the new dropdowns
                                        for (var i = document.getElementById("adhSideOptions").options.length - 1; i >= 0; i--) {
                                            document.getElementById("adhSideOptions").remove(i);
                                        } // Remove any previously displayed options
                                    }
                                    var selectAdhSideOpt = '';
                                    if (AdhSideOptions.length > 1) {
                                        selectAdhSideOpt += '<option id="defaultAdhSideOption" name="adhSide" value="">Select Adhesive Side...</option>';
                                    }
                                    for (var i = 0; i < AdhSideOptions.length; i++) {
                                        var adhesiveSide = "adhesiveSide" + i;
                                        selectAdhSideOpt += '<option id="' + inputId + '" name="adhSide" tabindex="0" value="' + AdhSideOptions[i] + '"';
                                        // Set up the selected option, the first option by default if the item is not being edited
                                        if ((editID > 0 && AdhSideOptions[i] == EditAdhSideValue)) {
                                            selectAdhSideOpt += ' selected="selected"';
                                        }

                                        selectAdhSideOpt += '>' + AdhSideOptions[i] + '</option>';
                                    }

                                    document.getElementById("adhSideOptions").insertAdjacentHTML('afterbegin', selectAdhSideOpt);
                                    if (!document.getElementsByClassName("hasNonSizingAttrBorder")[0]) {
                                		var addBorderHTML = '<div class="tinySpace"></div><div class="borderMdGray hasNonSizingAttrBorder"></div>'
						document.getElementsByClassName("attributesLoadingImg")[0].insertAdjacentHTML('beforebegin', addBorderHTML);
                                    }
                                    document.getElementById("adhSideOptions").classList.add("txtReq");
                                    if (editID < 0 & document.getElementById("defaultAdhSideOption")) {
                                        document.getElementById("defaultAdhSideOption").setAttribute("selected", "selected");
                                    }

                                    if (AdhSideOptions.length == 1) {
                                        document.getElementById("adhSideOptions").setAttribute("disabled", "disabled");
                                    } else {
                                        document.getElementById('adhSideOptions').disabled = false;
                                    }
                                    document.querySelector('.PD_AdhesiveSide').style.display = "block";
                                    document.querySelector("#adhSideOptions").addEventListener("change", adhesiveOptionChanged); // Bind the handler to the new dropdown
                                } else {
                                    document.querySelector('.PD_AdhesiveSide').style.display = "none";
                                }

                                if (adhSidesOptions.adhesive.length > 0 && (AdhesiveOptions.length >= 1 || AdhSideOptions.length >= 1)) {
                                    // If there is a nib or color selection to be made, set the default selections into the hidden input
                                    adhesiveOptionChanged();
                                    // Do the initial pass on the ink colors to make sure only the available ones are displayed
                                    toggleAvailableAdhesiveSides();
                                }

                            } else {
                                var ad = document.querySelector('.PD_Adhesive');
                                if(ad !== null){
                                    ad.style.display = "none";
                                }
                                var ads = document.querySelector('.PD_AdhesiveSide');
                                if(ads !== null){
                                    ads.style.display = "none";
                                }
                            }
                            if (isGFeed) {
                                if (document.getElementById("adhOptions").options.length > 1) {
                                    document.getElementById("adhOptions").selectedIndex = 1;
                                } else {
                                    document.getElementById("adhOptions").selectedIndex = 0;
                                }
                                if (document.getElementById("adhSideOptions").options.length > 1) {
                                    document.getElementById("adhSideOptions").selectedIndex = 1;
                                } else {
                                    document.getElementById("adhSideOptions").selectedIndex = 0;
                                }
                            }
                        }).catch(function (response, xhr) {
                            document.querySelector('.PD_Adhesive').style.display = "none";
                            document.querySelector('.PD_AdhesiveSide').style.display = "none";
                        });
                    }
                },
                loadNibInkColor = function () {
                    var selectedColorID = selBaseTrim.value;
                    if (selectedColorID != undefined && selectedColorID != "" && typeof prodID != 'undefined') {
                        var nibinkRequest = ajax({
                            method: "POST",
                            url: "/productattribute/nibink",
                            data: {
                                'ProductID': prodID,
                                'Color': selectedColorID,
                                'EditID': editID
                            },
                            timeout: 15000
                        }).then(function (response, xhr) {
                            document.getElementsByClassName("attributesLoadingImg")[0].classList.add("hide");
                            nibInkOptions = response;
                            if (response != null && response.inknib.length > 0) {
                                nibInkOptions = response; // Set to the global object for use when the user is making selections
                                
                                var NibOptions = [];
                                var ColorOptions = [];
                                var ProductColorAttributeIDs = [];
                                var EditNibValue = '';
                                var EditInkColorValue = '';
                                
                                for (var i = 0; i < response.inknib.length; i++) {
                                    var optionFound = false;
                                    // Look to see if the option has already been added to the nib option array
                                    for (var j = 0; j < NibOptions.length; j++) {
                                        if (!optionFound && NibOptions[j] == response.inknib[i].nib) {
                                            optionFound = true;
                                        }
                                    }
                                    // if the nib option was not found, add the option to the array for display
                                    if (!optionFound) {
                                        NibOptions[NibOptions.length] = response.inknib[i].nib;
                                    } else {
                                        optionFound = false; // Reset the variable for the color check
                                    }
                                    // Look to see if the option has already been added to the color option array
                                    for (var j = 0; j < ColorOptions.length; j++) {
                                        if (!optionFound && ColorOptions[j] == response.inknib[i].ink) {
                                            optionFound = true;
                                        }
                                    }
                                    // if the nib option was not found, add the option to the array for display
                                    if (!optionFound) {
                                        ColorOptions[ColorOptions.length] = response.inknib[i].ink;
                                        ProductColorAttributeIDs[ProductColorAttributeIDs.length] = response.inknib[i].id;
                                    }
                                    if (editID > 0) {
                                        if (response.inknib[i].id == nibInkInput.value) {
                                            EditInkColorValue = response.inknib[i].ink;
                                            EditNibValue = response.inknib[i].nib;
                                        }
                                    }
                                }
                                // All color and nib options have been located, now display them
                                if (NibOptions.length > 0) {
                                    if (document.getElementById('NibOptions')) {
                                        document.querySelector("#NibOptions").removeEventListener("change", NibInkOptionChanged); // Bind the handler to the new dropdown
                                        for (var i = document.getElementById("NibOptions").options.length - 1; i >= 0; i--) {
                                            document.getElementById("NibOptions").remove(i);
                                        }
                                    }
                                    var selectNib = '';
                                    if (NibOptions.length > 1) {
                                        selectNib += '<option id="defaultNibOption" name="nib" value="">Select Pen Tip Size...</option>';
                                    }
                                    for (var i = 0; i < NibOptions.length; i++) {
                                        var inputId = "nib" + i;
                                        selectNib += '<option id="' + inputId + '" name="nib" tabindex="0" value="' + NibOptions[i] + '"';
                                        // Set up the selected option, the first option by default if the item is not being edited
                                        if ((editID > 0 && NibOptions[i] == EditNibValue)) {
                                            selectNib += ' selected="selected"';
                                        }
                                        selectNib += '>' + NibOptions[i] + '</option>';
                                    }
                                    document.getElementById("NibOptions").insertAdjacentHTML('afterbegin', selectNib);
                                    document.getElementById("NibOptions").classList.add("txtReq");
                                    if (editID < 0 && NibOptions.length > 1) {
                                        document.getElementById("defaultNibOption").setAttribute("selected", "selected");
                                    }
                                    if (NibOptions.length == 1) {
                                        document.getElementById("NibOptions").setAttribute("disabled", "disabled");
                                    } else {
                                        document.getElementById("NibOptions").disabled = false;
                                    }
                                    document.querySelector('.PD_NibSize').style.display = "block";
                                    document.querySelector("#NibOptions").addEventListener("change", NibInkOptionChanged); // Bind the handler to the new dropdown
                                } else {
                                    document.querySelector('.PD_NibSize').style.display = "none";
                                }
                                if (ColorOptions.length > 0) {
                                    if (document.getElementById('inkColorOptions')) {
                                        document.querySelector("#inkColorOptions").removeEventListener("change", NibInkOptionChanged); // Bind the handler to the new dropdown
                                        for (var i = document.getElementById("inkColorOptions").options.length - 1; i >= 0; i--) {
                                            document.getElementById("inkColorOptions").remove(i);
                                        } // Remove any previously displayed options
                                    }
                                    var selectInk = '';
                                    if (ColorOptions.length > 1) {
                                        selectInk += '<option id="defaultInkColorOption" name="ink" value="">Select Writing Ink ' + colorCapitalized + '...</option>';
                                    }
                                    for (i = 0; i < ColorOptions.length; i++) {
                                        var inkId = "ink" + i;
                                        selectInk += '<option id="' + inkId + '" value="' + ColorOptions[i] + '"';
                                        // Set up the selected option, the first option by default if the item is not being edited
                                        if ((editID > 0 && ColorOptions[i] == EditInkColorValue)) {
                                            selectInk += ' selected="selected"';
                                        }
                                        selectInk += '>' + ColorOptions[i] + '</option>';
                                    }
                                    document.getElementById("inkColorOptions").insertAdjacentHTML('afterbegin', selectInk);
                                    document.getElementById("inkColorOptions").classList.add("txtReq");
                                    if (editID < 0 && ColorOptions.length > 1) {
                                        document.getElementById("defaultInkColorOption").setAttribute("selected", "selected");
                                    }
                                    if (ColorOptions.length == 1) {
                                        document.getElementById("inkColorOptions").setAttribute("disabled", "disabled");
                                    } else {
                                        document.getElementById("inkColorOptions").disabled = false;
                                    }
                                    var inputInk = "";
                                    for (var i = 0; i < ColorOptions.length; i++) {
                                        //Allows the hidden input to be assigned a class so the value can be updated via javascript
                                        var colorName = "colorName" + ColorOptions[i].replace(/\s/g, "");
                                        inputInk += '<input class="' + colorName + ' inkColorValue" type="hidden" tabindex="0" value="' + ProductColorAttributeIDs[i] + '" />';
                                    }
                                    document.getElementById("inkColorOptions").insertAdjacentHTML('afterend', inputInk);
                                    if (!document.getElementsByClassName("hasNonSizingAttrBorder")[0]) {
                                		var addBorderHTML = '<div class="tinySpace"></div><div class="borderMdGray hasNonSizingAttrBorder"></div>'
						document.getElementsByClassName("attributesLoadingImg")[0].insertAdjacentHTML('beforebegin', addBorderHTML);
                                    }
                                    document.querySelector('.PD_InkColor').style.display = "block";
                                    document.querySelector("#inkColorOptions").addEventListener("change", NibInkOptionChanged); // Bind the handler to the new dropdown
                                } else {
                                    document.querySelector('.PD_InkColor').style.display = "none";
                                }
                                if (nibInkOptions.inknib.length > 0 && (NibOptions.length >= 1 || ColorOptions.length >= 1)) {
                                    // If there is a nib or color selection to be made, set the default selections into the hidden input
                                    NibInkOptionChanged();
                                    // Do the initial pass on the ink colors to make sure only the available ones are displayed
                                    toggleAvailableInkColors();
                                }
                            } else {
                                var nz = document.querySelector('.PD_NibSize');
                                if(nz !== null){
                                    nz.style.display = "none";
                                }
                                var ic =document.querySelector('.PD_InkColor');
                                if(ic !== null){
                                    ic.style.display = "none";
                                }
                            }
                            if (isGFeed) {
                                if (document.getElementById("NibOptions").options.length > 1) {
                                    document.getElementById("NibOptions").selectedIndex = 1;
                                } else {
                                    document.getElementById("NibOptions").selectedIndex = 0;
                                }
                                if (document.getElementById("inkColorOptions").options.length > 1) {
                                    document.getElementById("inkColorOptions").selectedIndex = 1;
                                } else {
                                    document.getElementById("inkColorOptions").selectedIndex = 0;
                                }
                            }
                        }).catch(function (response, xhr) {
                            document.querySelector('.PD_NibSize').style.display = "none";
                            document.querySelector('.PD_InkColor').style.display = "none";
                        });
                    }
                },
                sampleRequest = function () {
                    if (document.getElementsByClassName('sampleError')[0]) {
                        document.getElementsByClassName('sampleError')[0].parentNode.removeChild(document.getElementsByClassName('sampleError')[0]);
                    }
                    if (document.getElementsByClassName('sampleCancel')[0]) {
                        document.getElementsByClassName('sampleCancel')[0].parentNode.removeChild(document.getElementsByClassName('sampleCancel')[0]);
                    }
			document.getElementById('imgSampleReq1Loading').classList.remove('hide');
                    var getSampleRequest = ajax({
                        url: removeTrailingSlash('/productmvc/samplerequest/' + catAlias),
                        method: 'GET'
                    });
                    getSampleRequest.then(function (response, xhr) {
                        document.getElementById('imgSampleReq1Loading').classList.add('hide');
                        document.getElementsByClassName('sampleBtnContainer')[0].style.display = "none";
                        document.querySelector(".sampleRequest1").setAttribute("aria-expanded", "true");

                        //If the user is able to place a sample request display the sample request form otherwise let them know when they are not able to.
                        if (response.Status == 'success') {
                            document.getElementById('samplePanel').classList.add('hide');
                            document.getElementById('samplePanel').innerHTML = response.HtmlString;
                            animate.slideDown(document.getElementById('samplePanel'));
                            document.getElementById('SampleRequestForm').scrollIntoView({
                                behavior: "smooth"
                            });
                            document.getElementById('FirstName').focus();

                            var loadSample = new samplePage(s, s_account);
                            loadSample.init(); //load event handlers on buttons loaded in ajax

                            document.getElementById("cancelSampleRequest").addEventListener("click", function(e){
                                e.preventDefault();
                                document.querySelector(".sampleRequest1").setAttribute("aria-expanded", "false");
                            });
                        } else {
                            document.getElementsByClassName('sampleRequestPanel')[0].insertAdjacentHTML('afterend', response.HtmlString);
                        }
                    });
                },
                fitRatingChange = function (fitFilter) {
                    loadingPage(document.getElementById('FitRatingContainer'));
                    var getFitRatings = ajax({
                        url: removeTrailingSlash("/productmvc/customerfitrating/" + prodID + "/1/" + fitFilter),
                        method: "GET"
                    });
                    getFitRatings.then(function (response, xhr) {
                        document.getElementById('customerfitcomments').innerHTML = '';
                        document.getElementById('customerfitcomments').innerHTML = response;
                        initFitRatingPages();
                    });
                    hideLoading(document.getElementById('FitRatingContainer'));
                },
                submitQuestion = function () {
                    var data = {
                        catalogAlias: catAlias,
                        productQuestion: document.getElementById('prodQstn').value
                    };
                    var postQuestion = ajax({
                        url: "/productmvc/saveproductquestion",
                        method: "POST",
                        data: data
                    });
                    postQuestion.then(function (response, xhr) {
                        if (response.success == "true") {
                            document.getElementsByClassName('btnSubmitProdQuestion')[0].parentNode.parentNode.insertAdjacentHTML('afterend', '<p class="prodQuestionMsg clear textsemibold textBlue" role="status">' + response.message + '</p>');
                            document.getElementById('prodQstn').value = '';
                            document.getElementsByClassName("btnSubmitProdQuestion")[0].focus();
                        } else {
                            document.getElementsByClassName('btnSubmitProdQuestion')[0].parentNode.parentNode.insertAdjacentHTML('afterend', '<p class="prodQuestionMsg clear textsemibold textDkRed" role="status">' + response.message + '</p>');
                            document.getElementById('prodQstn').focus();
                        }
                    });
                },
                positiveReview = function (e) {
                    e.preventDefault();
                    var el = e.currentTarget;
                    if (el.parentNode.getElementsByClassName('reviewRemarkMsg')[0]) {
                        el.parentNode.getElementsByClassName('reviewRemarkMsg')[0].parentNode.removeChild(el.parentNode.getElementsByClassName('reviewRemarkMsg')[0]);
                    }
                    var reviewID = el.parentNode.getElementsByClassName('reviewID')[0].value;
                    var data = {
                        reportSKU: reportSKU,
                        reviewID: reviewID,
                        positiveReview: true,
                        negativeReview: false,
                        catalogAlias: catAlias
                    };
                    var postPosReview = ajax({
                        url: "/productmvc/reviewremark",
                        method: "POST",
                        data: data
                    });
                    postPosReview.then(function (response, xhr) {
                        if (response.success == "true") {
                            el.nextElementSibling.insertAdjacentHTML('afterend', '<p class="clear textBlue textsemibold reviewRemarkMsg paddingTop10" role="status">' + response.message + '</p>');
                        } else {
                            el.nextElementSibling.insertAdjacentHTML('afterend', '<p class="clear textDkRed textsemibold reviewRemarkMsg paddingTop10" role="status">' + response.message + '</p>');
                        }
                    });
                },
                negativeReview = function (e) {
                    e.preventDefault();
                    var el = e.currentTarget;
                    if (el.parentNode.getElementsByClassName('reviewRemarkMsg')[0]) {
                        el.parentNode.getElementsByClassName('reviewRemarkMsg')[0].parentNode.removeChild(el.parentNode.getElementsByClassName('reviewRemarkMsg')[0]);
                    }
                    var reviewID = el.parentNode.getElementsByClassName('reviewID')[0].value;
                    var data = {
                        reportSKU: reportSKU,
                        reviewID: reviewID,
                        positiveReview: false,
                        negativeReview: true,
                        catalogAlias: catAlias
                    };
                    var postReview = ajax({
                        url: "/productmvc/reviewremark",
                        method: "POST",
                        data: data
                    });
                    postReview.then(function (response, xhr) {
                        if (response.success == "true") {
                            el.insertAdjacentHTML('afterend', '<p class="clear textBlue textsemibold reviewRemarkMsg paddingTop10" role="status">' + response.message + '</p>');
                        } else {
                            el.insertAdjacentHTML('afterend', '<p class="clear textDkRed textsemibold reviewRemarkMsg paddingTop10" role="status">' + response.message + '</p>');
                        }
                    });
                },
                positiveAnswer = function (e) {
                    e.preventDefault();
                    var el = e.currentTarget;
                    var reviewID = el.parentNode.parentNode.getElementsByClassName('QA_ID')[0].value;
                    var data = {
                        answerID: reviewID,
                        answerHelful: true,
                        catalogAlias: catAlias
                    };
                    if (el.parentNode.getElementsByClassName('reviewRemarkMsg')[0]) {
                        el.parentNode.getElementsByClassName('reviewRemarkMsg')[0].parentNode.removeChild(el.parentNode.getElementsByClassName('reviewRemarkMsg')[0]);
                    }
                    var answerHelpful = ajax({
                        url: "/product/answerhelpful",
                        method: "POST",
                        data: data
                    });
                    answerHelpful.then(function (response, xhr) {
                        if (response.success == "true") {
                            el.nextElementSibling.insertAdjacentHTML('afterend', '<p class="clear textBlue textsemibold reviewRemarkMsg paddingBtm10" role="status">' + response.message + '</p>');
                        } else {
                            el.nextElementSibling.insertAdjacentHTML('afterend', '<p class="clear textDkRed textsemibold reviewRemarkMsg paddingBtm10" role="status">' + response.message + '</p>');
                        }
                    });
                },
                negativeAnswer = function (e) {
                    e.preventDefault();
                    var el = e.currentTarget;
                    var reviewID = el.parentNode.parentNode.getElementsByClassName('QA_ID')[0].value;
                    if (el.parentNode.getElementsByClassName('reviewRemarkMsg')[0]) {
                        el.parentNode.getElementsByClassName('reviewRemarkMsg')[0].parentNode.removeChild(el.parentNode.getElementsByClassName('reviewRemarkMsg')[0]);
                    }
                    var data = {
                        answerID: reviewID,
                        answerHelful: false,
                        catalogAlias: catAlias
                    };
                    var answerHelpful = ajax({
                        url: "/product/answerhelpful",
                        method: "POST",
                        data: data
                    });
                    answerHelpful.then(function (response, xhr) {
                        if (response.success == "true") {
                            el.insertAdjacentHTML('afterend', '<p class="clear textBlue textsemibold reviewRemarkMsg paddingBtm10" role="status">' + response.message + '</p>');
                        } else {
                            el.insertAdjacentHTML('afterend', '<p class="clear textDkRed textsemibold reviewRemarkMsg paddingBtm10" role="status">' + response.message + '</p>');
                        }
                    });
                },
                submitAnswer = function (element, data) {
                    var submitAnswerRequest = ajax({
                        url: "/product/submitquickanswer",
                        method: "POST",
                        data: data
                    });
                    submitAnswerRequest.then(function (response, xhr) {
                        if (response.success == "true") {
                            animate.slideUp(element.parentNode.parentNode);
                            element.parentNode.parentNode.previousElementSibling.setAttribute("aria-expanded", "false");
                            element.parentNode.parentNode.previousElementSibling.getElementsByTagName("svg")[0].setAttribute("class", "textDkGray rotate180");
                            element.parentNode.parentNode.previousElementSibling.focus();
                            element.parentNode.parentNode.previousElementSibling.insertAdjacentHTML('afterend', '<p class="clear textBlue textsemibold prodAnswerMsg" role="alert" aria-atomic="true">' + response.message + '</p>');
                        } else {
                            animate.slideUp(element.parentNode.parentNode);
                            element.parentNode.parentNode.previousElementSibling.setAttribute("aria-expanded", "false");
                            element.parentNode.parentNode.previousElementSibling.getElementsByTagName("svg")[0].setAttribute("class", "textDkGray rotate180");
                            element.parentNode.parentNode.previousElementSibling.focus();
                            element.parentNode.parentNode.previousElementSibling.insertAdjacentHTML('afterend', '<p class="clear textDkRed textsemibold prodAnswerMsg" role="alert" aria-atomic="true">' + response.message + '</p>');
                        }
                    });
                },
                submitQuickAnswer = function (data) {
                    var submitQuestion = ajax({
                        url: "/productmvc/submitquickanswer",
                        method: "POST",
                        data: data
                    });
                    submitQuestion.then(function (response, xhr) {
                        document.getElementsByClassName('quickAnswerContent')[0].innerHTML = '';
                        if (response.success == "true") {
                            document.getElementsByClassName('addQuickAnswer')[0].style.display = "block";
                            document.getElementsByClassName('quickAnswerContent')[0].insertAdjacentHTML('afterend', '<span class=\"quickAnswSubmitMsg textBlue\" role=\"status\">' + response.message + '</span>');
                        } else {
                            document.getElementsByClassName('addQuickAnswer')[0].style.display = "block";
                            document.getElementsByClassName('quickAnswerContent')[0].insertAdjacentHTML('afterend', '<span class=\"quickAnswSubmitMsg textDkRed\" role=\"status\">' + response.message + '</span>');
                        }
                    });
                },
                loadMiniRating = function () {
                    var getMiniRating = ajax({
                        url: '/productmvc/minirating',
                        method: 'POST',
                        data: {
                            'catalias': catAlias
                        }
                    });
                    getMiniRating.then(function (response, xhr) {
                        var newDiv = document.createElement('div');
                        newDiv.innerHTML = response;
                        if (document.getElementById('ratingSpot')) {
                            document.getElementById('ratingSpot').appendChild(newDiv);
                        }
                        if (document.getElementById("minirating")) {
                            if (isMobile) {
                                document.getElementById("ratingSpot").classList.remove("Rating");
                                document.getElementById("ratingSpot").classList.add("marginLeft15");
                                /*var stars = [].slice.call(document.getElementById("minirating").getElementsByClassName("ratingStarBase")[0].getElementsByTagName("svg"));
                                stars.forEach(function (el, index, array) {
                                    el.height = "15";
                                    el.width = "15";
                                });
                                var starBkgd = [].slice.call(document.getElementById("minirating").getElementsByClassName("starBackground"));
                                starBkgd.forEach(function (el, index, array) {
                                    el.width = "80";
                                });
                                var starFrgd = [].slice.call(document.getElementById("minirating").getElementsByClassName("starForeground"));
                                starFrgd.forEach(function (el, index, array) {
                                    el.width = "76";
                                });*/
                            }
                            document.getElementsByClassName('allReviews')[0].addEventListener('click', function (e) {
                                if (document.getElementsByTagName('a.anchor[name="reivews"]')[0]) {
                                    return;
                                }
                                e.preventDefault();
                                document.getElementById('detailTabs').scrollIntoView({
                                    behavior: "smooth",
                                    block: "start"
                                });
                                animate.slideUp(document.getElementById('ministars'), 100);
                                //allow the tabs to 'appear'
                                setTimeout(function () {
                                    document.getElementById('reviewsTS').getElementsByClassName('tabLink')[0].click();
                                }, 2500);
                            });
                            document.getElementById('miniReviewLink').addEventListener('click', function (e) {
                                e.preventDefault();
                                if (document.getElementById('ministars').classList.contains('hide')) {
                                    animate.slideDown(document.getElementById('ministars'), 50);
                                    document.getElementById('miniReviewLink').setAttribute("aria-expanded", "true");
                                    document.getElementById('ministars').setAttribute("aria-hidden", "false");
                                    document.getElementsByClassName('allReviews')[0].focus();
                                    document.getElementById('ministars').addEventListener('keydown', function (e) {
                                        if (e.which == 27) {
                                            animate.slideUp(document.getElementById('ministars'), 100);
                                            document.getElementById('miniReviewLink').focus();
                                        }
                                    });
                                } else {
                                    animate.slideUp(document.getElementById('ministars'), 100);
                                    document.getElementById('miniReviewLink').setAttribute("aria-expanded", "false");
                                    document.getElementById('ministars').setAttribute("aria-hidden", "true");
                                    this.focus();
                                }
                            });
                            FixIE11SVG();
                        }
                    });
                },
                getRelatedProducts = function () {
                    var getRelatedScroller = ajax({
                        url: '/productmvc/GetRelatedProductsScrollerAsync',
                        method: 'POST',
                        data: {
                            'productID': prodID
                        }
                    });
                    getRelatedScroller.then(function (response, xhr) {
                        var newDiv = document.createElement('div');
                        newDiv.innerHTML = response;
                        document.getElementById('relatedProductsContainer').appendChild(newDiv);
                        document.getElementById('relatedProductsContainer').getElementsByClassName('spinner')[0].classList.add('hide');
                        prodScrollerJS.InitSliderLessItems("RelatedItems");
                    });
                },
                getDetailTabs = function () {
                    var page = 1;
                    if (window.location.href.match(/\/page\/(\d*)/) != null) {
                        page = window.location.href.match(/\/page\/(\d*)/)[1];
                    }
                    var detailsTabs = ajax({
                        url: '/productmvc/GetDetailsTabAsync',
                        method: 'POST',
                        data: {
                            'productID': prodID,
                            'infoType': document.getElementById('InfoType').value,
                            'qID': document.getElementById('QuestionID').value,
                            'rFilter': document.getElementById('ReviewFilter').value,
                            'fitRatingFilter': document.getElementById('FitCommentFilter').value,
                            page: page
                        }
                    });
                    detailsTabs.then(function (response, xhr) {
                        var newDiv = document.createElement('div');
                        newDiv.innerHTML = response;
                        document.getElementById('detailTabs').appendChild(newDiv);
                        showHideTabs();
                        window.addEventListener("resize", showHideTabs);
                        detailTabs.init(document.getElementById("detailTabs"));
                        setDetailTabEvents();
                        document.getElementById('detailTabs').getElementsByClassName('spinner')[0].classList.add('hide');
                        FixIE11SVG();
                    });
                },
                getItemCategories = function () {
                    var getItemCats = ajax({
                        url: '/productmvc/GetItemCategoriesAsync',
                        method: 'POST',
                        data: {
                            'productID': prodID
                        }
                    });
                    getItemCats.then(function (response, xhr) {
                        var newDiv = document.createElement('div');
                        newDiv.innerHTML = response;
                        document.getElementsByClassName('itemCats')[0].appendChild(newDiv);
                        document.getElementsByClassName('itemCats')[0].getElementsByClassName('spinner')[0].classList.add('hide');
                    });
                },
                getTabbedScroller = function () {
                    var getTabProducts = ajax({
                        url: '/productmvc/GetTabProductScrollerAsync',
                        method: 'POST',
                        data: {
                            'productID': prodID
                        }
                    });
                    getTabProducts.then(function (response, xhr) {
                        var newDiv = document.createElement('div');
                        newDiv.innerHTML = response;
                        document.getElementById('tabProd').appendChild(newDiv);
                        if (document.getElementById("SimilarItemsPanel")) {
                            prodScrollerJS.InitSliderLessItems("SimilarItems");
                        }
                        if (document.getElementById("MoreUpscaleItemsPanel")) {
                            prodScrollerJS.InitSliderLessItems("MoreUpscaleItems");
                        }
                        if (document.getElementById("MoreUpscaleItemsPanel")) {
                            prodScrollerJS.InitSliderLessItems("MoreUpscaleItems");
                        }
                        if (document.getElementById("LowerpriceItemsPanel")) {
                            prodScrollerJS.InitSliderLessItems("LowerpriceItems");
                        }
                        if (document.getElementById("LowerMinQtyItemsPanel")) {
                            prodScrollerJS.InitSliderLessItems("LowerMinQtyItems");
                        }
                        if (document.getElementById("FasterItemsPanel")) {
                            prodScrollerJS.InitSliderLessItems("FasterItems");
                        }
                        if (isMobile) {
                            document.getElementById("MoreUpscaleItemsTab").parentNode.parentNode.removeChild(document.getElementById("MoreUpscaleItemsTab").parentNode);
                            document.getElementById("MoreUpscaleItemsPanel").parentNode.removeChild(document.getElementById("MoreUpscaleItemsPanel"));
                        }
                        document.getElementById('tabProd').getElementsByClassName('spinner')[0].classList.add('hide');
                        scrollerTabs.init(document.getElementById("prodScrollerTabs"));
                        scrollerTabs.initTab(document.getElementById("SimilarItemsTab"));
                    });
                },
                getAlternativeItems = function () {
                    var getAltRelated = ajax({
                        url: '/productmvc/GetAltRelProductsAsync',
                        method: 'POST',
                        data: {
                            'productID': prodID
                        }
                    });
                    getAltRelated.then(function (response, xhr) {
                        var newDiv = document.createElement('div');
                        newDiv.innerHTML = response;
                        document.getElementById('altrelated').appendChild(newDiv);
                        prodScrollerJS.InitSliderLessItems("altrelated");
                        document.getElementById('altrelated').getElementsByClassName('spinner')[0].classList.add('hide');
                    });
                    getAltRelated.catch(function (response, xhr) {
                        document.getElementById('altrelated').innerHTML = '';
                    });
                },
                getAlternativeItemsList = function () {
                    var getAltItems = ajax({
                        url: '/productmvc/GetAltItemsAsync',
                        method: 'POST',
                        data: {
                            'productID': prodID
                        }, timeout: 20000
                    });

                    var timer = setTimeout(function () {
                        getAltItems.abort()
                    }, 3000)
                    getAltItems.then(function (response, xhr) {
                        var newDiv = document.createElement('div');
                        newDiv.innerHTML = response;
                        document.getElementById('altitemslist').appendChild(newDiv);
                        prodScrollerJS.InitSliderLessItems("altitemslist");
                        document.getElementById('altitemslist').getElementsByClassName('spinner')[0].classList.add('hide');
                        FixIE11SVG();
                    });
                    getAltItems.catch(function (response, xhr) {
                        document.getElementById('altitemslist').innerHTML = '';
                    });
                },
                getPropSixtyFive = function (e) {
                    e.preventDefault();
                    var getProp65 = ajax({
                        url: '/product/prop65',
                        method: 'post',
                        data: {
                            'ProductID': prodID
                        }
                    });
                    getProp65.then(function (response, xhr) {
                        document.getElementById('prop65content').innerHTML = response;
                        if (document.getElementsByClassName('loadingModal')[0]) {
                            document.getElementsByClassName('loadingModal')[0].style.display = "none";
                        }
                    });
                    getProp65.catch(function (response, xhr) {
                        document.getElementById('prop65content').innerHTML = "There was an issue loading the warnings, please refresh the page and try again.";
                        if (document.getElementsByClassName('loadingModal')[0]) {
                            document.getElementsByClassName('loadingModal')[0].style.display = "none";
                        }
                    });
                },
                getExtras = function (triggerElement) {
                    var ExtrasTotal = 0.00;
                    var qty = GetQty();
                    if (!isNaN(qty)) {
                        GetSelectedImprintColors();
                        GetSelectedImprintLocations();
                        if (listImprintLocationIDs.length == 0 || listProductImprintLocationIDs.length == 0 || listSelectedColors.length == 0) {
                            forms.ClearValidation();
                            if (totalImprintColors > 0) {
                                if (bypassImpConfig) {
                                    document.querySelector('.stepOneHdr').insertAdjacentHTML('afterend', errorMessageBox);
                                } else {
                                    document.querySelector('.imprintConfiguration').insertAdjacentHTML('beforebegin', errorMessageBox);
                                }
                                document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<button id="imprintError" class="btnToHyp text16 underline textLeft">Please select at least one imprint location and one imprint ' + localizedJS.Color + '.</button>';
                                document.getElementById("imprintError").focus();
                                document.getElementById("imprintError").addEventListener("click", function (e) {
                                    e.preventDefault();
                                    document.querySelector(".selImprintLocation").focus();
                                });
                                return false;
                            }
                        }
                        var baseTrimColor = selBaseTrim.value.split('/');
                        var OrderSummary = {
                            ProductID: prodID,
                            Quantity: qty,
                            ImprintColors: listSelectedColors,
                            ImprintLocations: listImprintLocationIDs,
                            BaseColorID: baseTrimColor[0],
                            TrimColorID: baseTrimColor[1],
                            EditID: editID,
                            ProductImprintLocations: listImprintLocationIDs,
                            NibColorAttributeID: GetNibColorAttributeID(),
                            AdhesiveAttributeID: GetAdhesiveAttributeID(),
                            IsReorder: document.getElementById("isReorder").value.toLowerCase() === 'true' // jag
                        };
                        var calcExtraRequest = ajax({
                            method: "POST",
                            url: "/productmvc/calculateextras",
                            data: OrderSummary,
                            headers: antiForgeryToken // jag
                        }).then(function (response, xhr) {
                            if (response.indexOf('extrasError') < 0) {
                                document.getElementById('setupChrgSummary').innerHTML = response;
                            } else {
                                document.getElementById('setupChrgSummary').innerHTML = '<p class="textsemibold" role="alert" aria-atomic="true">Add To Cart To View Any Imprint Charges</p>';
                            }
                        }).catch(function (response, xhr) {
                            if (!isGFeed) {
                                extraChargesLoadError();
                            }
                        });
                    }
                },

                getItemDetails = function (line) {
                    var origFocus = line;
                    var chkdImprintLoc = 0;
                    var ExtrasTotal = 0.00;
                    var qty = GetQty();
                    GetSelectedImprintColors();
                    GetSelectedImprintLocations();
                    if (listImprintLocationIDs.length == 0 || listProductImprintLocationIDs.length == 0 || listSelectedColors.length == 0 && parseInt(document.getElementsByClassName("extrasResult")[0].innerHTML) == 0) {
                        forms.ClearValidation();
                        if (totalImprintColors > 0) {
                            if (bypassImpConfig) {
                                document.querySelector('.stepOneHdr').insertAdjacentHTML('afterend', errorMessageBox);
                            } else {
                                document.querySelector('.imprintConfiguration').insertAdjacentHTML('beforebegin', errorMessageBox);
                            }
                            document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<button id="imprintError" class="btnToHyp text16 underline textLeft">Please select at least one imprint location and one imprint ' + localizedJS.Color + '.</button>';
                            document.getElementById("imprintError").focus();
                            document.getElementById("imprintError").addEventListener("click", function (e) {
                                e.preventDefault();
                                document.querySelector(".selImprintLocation").focus();
                            });
                            return false;
                        }
                    }
                    if (listSelectedColors.length == 0 && !bypassImpConfig && parseInt(document.getElementsByClassName("extrasResult")[0].innerHTML) != 0) {
                        listSelectedColors.push(document.getElementsByClassName("imprintColorID")[0].value);
                    }

                    var includeOptionalExtras = "";
                    if (document.getElementById('SelectedOptionalExtras').value != "") {
                        includeOptionalExtras = document.getElementById('SelectedOptionalExtras').value;
                    }

                    var baseTrimColor = selBaseTrim.value.split('/');
                    var OrderSummary = {
                        ProductID: prodID,
                        Quantity: qty,
                        ImprintColors: listSelectedColors,
                        ImprintLocations: listImprintLocationIDs,
                        BaseColorID: baseTrimColor[0],
                        TrimColorID: baseTrimColor[1],
                        EditID: editID,
                        ProductImprintLocations: listProductImprintLocationIDs,
                        NibColorAttributeID: GetNibColorAttributeID(),
                        AdhesiveAttributeID: GetAdhesiveAttributeID(),
                        SelectedOptionalExtras: document.getElementById('SelectedOptionalExtras').value,
                        IsReorder: document.getElementById("isReorder").value.toLowerCase() === 'true' // jag
                    };
                    var getDetails = ajax({
                        url: '/product/itemextracharges',
                        method: 'POST',
                        data: {
                            summary: OrderSummary,
                            includeOptionalExtras: includeOptionalExtras
                        },
                        headers: antiForgeryToken
                    });
                    getDetails.then(function (response, xhr) {
                        document.getElementById("loading").classList.add("hide");
                        if (response.success != false && response.indexOf("divItemDetails") != -1) {
                            var popup = document.getElementById('itemExtraChgsPopup');
                            response = response.replace("##PRODUCTNAME##", document.getElementsByClassName("prodNumber")[0].innerHTML.replace("Item ", ""));
                            popup.innerHTML = response;
                            if (!bypassImpConfig) {
                                getExtrasAmount();
                            }
                            var itemDetailsDialog = dialog4i();
                            itemDetailsDialog.init(document.getElementById('divItemDetails'));
                            itemDetailsDialog.open();
                            document.getElementById("divItemDetails").getElementsByClassName("close4iDialog")[0].addEventListener("click", function (e) {
                                if (popup) {
                                    popup.previousElementSibling.setAttribute("aria-expanded", "false");
                                    origFocus.focus();
                                }
                            });
                            document.getElementById("divItemDetails").addEventListener("keydown", function (e) {
                                if (e.which === 27) {
                                    if (popup) {
                                        popup.previousElementSibling.setAttribute("aria-expanded", "false");
                                        origFocus.focus();
                                    }
                                }
                            });
                        } else { // error
                            extraChargesLoadError();
                        }
                    }).catch(function (response, xhr) {
                        extraChargesLoadError();
                    });
                },

                getExtrasAmount = function (setDefaultColor) {
                    if (document.getElementsByClassName("extrasRow")[0] && document.getElementsByClassName("extrasRow")[0].classList.contains("hide")) {
                        document.getElementsByClassName("extrasLoadingRow")[0].classList.remove("hide");
                    }
                    if (setDefaultColor === undefined) {
                        setDefaultColor = false;
                    }
                    if (document.getElementsByClassName("extraChargesLoading")[0]) {
                        document.getElementsByClassName("extraChargesLoading")[0].classList.remove("hide");
                    }
                    if (document.getElementsByClassName("extrasResultLine")[0]) {
                        document.getElementsByClassName("extrasResultLine")[0].classList.add("hide");
                    }

                    var ExtrasTotal = 0.00;
                    var qty = GetQty();
                    if (!isNaN(qty)) {
                        GetSelectedImprintColors();
                        GetSelectedImprintLocations();
                        if (setDefaultColor && listSelectedColors.length == 0) {
                            listSelectedColors.push(document.getElementsByClassName("imprintColorID")[0].value);
                        }
                        if (listImprintLocationIDs.length == 0 || listProductImprintLocationIDs.length == 0 || listSelectedColors.length == 0 && parseInt(document.getElementsByClassName("extrasResult")[0].innerHTML) == 0) {
                            if (document.querySelector(".PD_Step_2").querySelector(".errorMsg")) {
                                document.querySelector(".PD_Step_2").querySelector(".errorMsg").parentNode.removeChild(document.querySelector(".PD_Step_2").querySelector(".errorMsg"));
                            }
                            if (totalImprintColors > 0) {
                                if (document.getElementsByClassName('ErrorMsgPanel')[0]) {
                                    document.getElementsByClassName('ErrorMsgPanel')[0].parentNode.removeChild(document.getElementsByClassName('ErrorMsgPanel')[0]);
                                }
                                if (bypassImpConfig) {
                                    document.querySelector('.stepOneHdr').insertAdjacentHTML('afterend', '<div id="ErrorBox" class="clear errorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 class="validationHeading">Please correct the following errors and resubmit:</h3><button id="imprintError" class="btnToHyp text16 underline marginTop10">Please select at least one imprint location and one imprint ' + localizedJS.Color + '.</button></div>');
                                } else if (document.querySelector('.imprintConfiguration')) {
                                    document.querySelector('.imprintConfiguration').insertAdjacentHTML('beforebegin', '<div id="ErrorBox" class="clear errorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 class="validationHeading">Please correct the following errors and resubmit:</h3><button id="imprintError" class="btnToHyp text16 underline marginTop10">Please select at least one imprint location and one imprint ' + localizedJS.Color + '.</button></div>');
                                }
                                document.getElementById("imprintError").focus();
                                document.getElementById("imprintError").addEventListener("click", function (e) {
                                    e.preventDefault();
                                    document.querySelector(".selImprintLocation").focus();
                                });
                                return false;
                            }
                        }

                        if (listSelectedColors.length == 0 && parseInt(document.getElementsByClassName("extrasResult")[0].innerHTML) != 0 && document.getElementsByClassName("imprintColorID")[0]) {
                            listSelectedColors.push(document.getElementsByClassName("imprintColorID")[0].value);
                        }

                        var baseTrimColor = selBaseTrim.value.split('/');
                        var orderSummary = {
                            ProductID: prodID,
                            Quantity: qty,
                            ImprintColors: listSelectedColors,
                            ImprintLocations: listImprintLocationIDs,
                            BaseColorID: baseTrimColor[0],
                            TrimColorID: baseTrimColor[1],
                            EditID: editID,
                            ProductImprintLocations: listProductImprintLocationIDs,
                            NibColorAttributeID: GetNibColorAttributeID(),
                            AdhesiveAttributeID: GetAdhesiveAttributeID(),
                            IsReorder: document.getElementById("isReorder").value.toLowerCase() === 'true' // jag
                        };
                        var includeOptionalExtras = "";
                        if (document.getElementById('SelectedOptionalExtras').value != "") {
                            includeOptionalExtras = document.getElementById('SelectedOptionalExtras').value;
                        }
                        var calcExtraRequest = ajax({
                            method: "POST",
                            url: "/productmvc/calcextrasamt",
                            data: {
                                summary: orderSummary,
                                includeOptionalExtras: includeOptionalExtras
                            },
                            headers: antiForgeryToken // jag
                        }).then(function (response, xhr) {
                            if (document.getElementsByClassName("extrasLoadingRow")[0]) {
                        	     document.getElementsByClassName("extrasLoadingRow")[0].classList.add("hide");
                    		 }                           
                            if (document.getElementsByClassName("extraChargesLoading")[0]) {
                                document.getElementsByClassName("extraChargesLoading")[0].classList.add("hide");
                            }
                            if (document.getElementsByClassName("extrasResultLine")[0]) {
                                document.getElementsByClassName("extrasResultLine")[0].classList.remove("hide");
                            }
                            if (document.getElementsByClassName("extrasRow")[0]) {
                                if (response != 0) {
                                    document.getElementsByClassName("extrasRow")[0].classList.remove("hide");
                                } else if (parseFloat(response) == 0) {
                                    document.getElementsByClassName("extrasRow")[0].classList.add("hide");
                                }
                            }
                            if (document.getElementsByClassName("extrasResult")[0]) {
                                document.getElementsByClassName("extrasResult")[0].innerHTML = formatMoney(parseFloat(response));
                                var extrasResult = document.getElementsByClassName("extrasResult")[0].innerHTML;
                                if (extrasResult != undefined && extrasResult != "") {
                                    ExtrasTotal = parseFloat(extrasResult);
                                }
                            }

                            tooltips.init(); // extras tooltips
                            if (isGFeed) {
                                if (document.getElementById("GFeedData")) {
                                    tooltips.init(); //gfeed tooltip
                                }
                            }

                            var total, totalDisplayed;
                            currencySymbol = currencySymbol.replace(/\s+/g, '');
                            if (document.getElementById("lblTotal")) {
                                totalDisplayed = document.getElementById('lblTotal').innerHTML;
                                totalDisplayed = totalDisplayed.replace(/\s+/g, '');
                                total = (ExtrasTotal + parseFloat(totalDisplayed.replace(totalDisplayed.substring(0, 1), ''))).toFixed(2);
                            }
                            if (document.getElementById("lblBaseExtras")) {
                                document.getElementById('lblBaseExtras').innerHTML = currencySymbol + formatMoney(parseFloat(response));
                            }

                            if (isGFeed && typeof total !== 'undefined' && !isNaN(total) && !isNaN(ExtrasTotal)) {
                                document.getElementById('currencySymbol').innerHTML = currencySymbol;
                                document.getElementById('grandTotal').innerHTML = total;
                                var gfeedtotal;
                                if (ukTaxRate != '0') {
                                    //UK locale, add VAT
                                    var vat = currencySymbol + localizedJS.VatTax(ExtrasTotal, totalDisplayed.replace(currencySymbol, ''), ukTaxRate);
                                    gfeedtotal = currencySymbol + localizedJS.TotalWithVat(ExtrasTotal, totalDisplayed.replace(currencySymbol, ''), ukTaxRate);
                                    document.getElementById('VatTax').innerHTML = vat;
                                    document.getElementById('GFeedFinalPrice').innerHTML = gfeedtotal;
                                    document.getElementById('GFeedQty').innerHTML = qty;
                                    if(document.querySelector(".glidePanel")){ //glide
                                        document.getElementById('GFeedUnitPrice').innerHTML = document.getElementById('lblPrice').value;
                                    }else{ //apparel
                                        document.getElementById('GFeedUnitPrice').innerHTML = document.getElementById('lblPrice').innerHTML;
                                    }
                                    document.getElementById('GFeedTotalPrice').innerHTML = document.getElementById('lblTotal').innerHTML;
                                    if (document.getElementById('GFeedPanel').display != 'none') {
                                        document.getElementById('lblTotal').innerHTML = gfeedtotal;

                                        if(document.querySelector(".glidePanel")){ //glide
                                            document.getElementById('lblPrice').value = '';
                                        }else{ //apparel
                                            document.getElementById('lblPrice').innerHTML = '';
                                        }
                                    }
                                } else {
                                    //Not UK
                                    gfeedtotal = currencySymbol + total;
                                    if (document.getElementById('GFeedPanel').display != 'none') {
                                        //document.getElementById('lblTotal').innerHTML = gfeedtotal;
                                        if(document.querySelector(".glidePanel")){ //glide
                                            document.getElementById('lblPrice').value = '';
                                        }else{ //apparel
                                            document.getElementById('lblPrice').innerHTML = '';
                                        }
                                    }
                                    document.getElementById('GFeedFinalPrice').innerHTML = gfeedtotal;

                                }
                            }
                            return ExtrasTotal;
                        }).catch(function (response, xhr) {
                            if (!isGFeed) { // to do - what if it is gfeed?
                                extraChargesLoadError();
                            }
                        });
                    }
                },

                addToCart = function (e) {
                    GetSelectedImprintLocations();
                    GetSelectedImprintColors();
                    forms.ClearValidation();
                    ajaxActions.GetExtras();
                    var selectedOptionalExtras = document.getElementById('SelectedOptionalExtras').value;
                    var selectedSizes = GetSelectedSizes();
                    var baseTrimColor = selBaseTrim.value.split('/');
                    var arrImprintLocationIDs = listImprintLocationIDs;
                    var arrProductImprintLocationIDs = listProductImprintLocationIDs;
                    var arrImprintColorsIDs = listSelectedColors;
                    var colorSelected = document.getElementById('colorSelected').value;
                    var selectedColorID = selBaseTrim.value;
                    var qty = GetQty();
                    document.getElementById('qtySummary').innerHTML = qty;
                    document.getElementById('colorSummary').innerHTML = colorSelected;

                    if (isApparelItem && document.getElementById('SizingGrid').innerHTML.length > 0) {
                        CalcPrice();
                    }
                    if (selectedColorID == undefined || selectedColorID == "") {
                        if (recolorAvailable.value == 'True') {
                            document.querySelector('#productColorScroller').insertAdjacentHTML('beforebegin', errorMessageBox);
                            document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<button id="colorScrollerError" class="btnToHyp text16 underline textLeft">Please select a product ' + localizedJS.Color + '.</button>';
                            document.getElementById("colorScrollerError").focus();
                            document.getElementById("colorScrollerError").addEventListener("click", function (e) {
                                e.preventDefault();
                                document.getElementById('productColorScroller').querySelectorAll('.imgBox')[0].focus();
                            });
                        } else {
                            document.querySelector('.PD_ColorList').insertAdjacentHTML('beforebegin', errorMessageBox);
                            document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<button id="colorListError" class="btnToHyp text16 underline textLeft">Please select a product ' + localizedJS.Color + '.</button>';
                            document.getElementById("colorListError").focus();
                            document.getElementById("colorListError").addEventListener("click", function (e) {
                                e.preventDefault();
                                document.getElementById('listView').querySelectorAll('.selectedImgDesc')[0].focus();
                            });
                        }
                        return false;
                    }

                    var quantityErrorHtml = '<div id="ErrorBox" class="qtyErrorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>' +
                        '<ul id="ErrorMsgBox"><li><button id="quantityError" class="btnToHyp text16 underline textLeft">Minimum quantity for this item is ' + lowestQty + '.</button></li></ul></div>';
                    if (qty == isNaN || qty == undefined || qty == '0' || !IsNumeric(qty)) {
                        if (document.querySelector(".qtyErrorMsg")) document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));
                        if (isApparelItem) {
                            document.getElementById('PD_SizeGrid').insertAdjacentHTML('beforebegin', quantityErrorHtml);
                            var allQtyInputs = document.getElementsByClassName("txtApparelQty");
                            for (var x = 0; x < allQtyInputs.length; x++) {
                                allQtyInputs[x].classList.add("input-validation-error");
                                allQtyInputs[x].setAttribute('aria-invalid', 'true');
                            }
                            document.getElementById("quantityError").focus();
                            document.getElementById("quantityError").addEventListener("click", function (e) {
                                e.preventDefault();
                                allQtyInputs[0].focus();
                            });
                        } else {
                            document.querySelector('.glidePanel').insertAdjacentHTML('beforebegin', quantityErrorHtml);
                            document.getElementById('txtQty').classList.add("input-validation-error");
                            document.getElementById('txtQty').setAttribute('aria-invalid', 'true');
                            document.getElementById("quantityError").focus();
                            document.getElementById("quantityError").addEventListener("click", function (e) {
                                e.preventDefault();
                                document.getElementById('txtQty').focus();
                            });
                        }
                        return false;
                    }
                    if (qty < lowestQty) {
                        if (document.querySelector(".qtyErrorMsg"))
                            document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));
                        if (isApparelItem) {
                            document.getElementById('PD_SizeGrid').insertAdjacentHTML('beforebegin', quantityErrorHtml);
                            var apparelInputs = document.getElementsByClassName("txtApparelQty");
                            for (var y = 0; y < apparelInputs.length; y++) {
                                if (apparelInputs[y].value != '') {
                                    apparelInputs[y].classList.add("input-validation-error");
                                    apparelInputs[y].setAttribute('aria-invalid', 'true');
                                    document.getElementById("quantityError").focus();
                                    document.getElementById("quantityError").addEventListener("click", function (e) {
                                        e.preventDefault();
                                        apparelInputs[0].focus();
                                    });
                                }
                            }
                        } else {
                            document.querySelector('.glidePanel').insertAdjacentHTML('afterend', quantityErrorHtml);
                            document.getElementById('txtQty').classList.add("input-validation-error");
                            document.getElementById('txtQty').setAttribute('aria-invalid', 'true');
                            document.getElementById("quantityError").focus();
                            document.getElementById("quantityError").addEventListener("click", function (e) {
                                e.preventDefault();
                                document.getElementById('txtQty').focus();
                            });
                        }
                        return false;
                    }

                    SetSummaryImprintColors();

                    //get adhesive side selected
                    if (document.querySelector(".PD_adhSideOptions")) {
                        document.querySelector(".PD_adhSideOptions").parentNode.removeChild(document.querySelector(".PD_adhSideOptions"));
                    }
                    if (document.getElementById("adhSideOptions").selectedIndex != -1) {
                        var adhesiveSideSelected = document.getElementById("adhSideOptions")[document.getElementById("adhSideOptions").selectedIndex].text;
                        document.getElementById('colorSummary').parentNode.insertAdjacentHTML('afterend', '<div class="clear tinySpace"></div><div class="PD_adhSideOptions c-sm-quarter-2 c-xs-full floatLeft"><p class="textsemibold">Adhesive Side</p></div><div class="c-sm-quarter-2 c-xs-full floatLeft"><p class="floatRightOnMedium" id="adhesiveSideSummary">' + adhesiveSideSelected + '</p></div>');
                    }

                    //get adhesive type selected
                    if (document.querySelector(".PD_adhesiveOptions")) {
                        document.querySelector(".PD_adhesiveOptions").parentNode.removeChild(document.querySelector(".PD_adhesiveOptions"));
                    }

                    if (document.getElementById('adhOptions').selectedIndex != -1) {
                        var adhesiveTypeSelected = document.getElementById("adhOptions")[document.getElementById("adhOptions").selectedIndex].text;
                        var adhesiveSideSelected = document.getElementById("adhSideOptions")[document.getElementById("adhSideOptions").selectedIndex].text;
                        document.getElementById('colorSummary').parentNode.insertAdjacentHTML('afterend', '<div class="clear tinySpace"></div><div class="PD_adhesiveOptions c-sm-quarter-2 c-xs-full floatLeft"><p class="textsemibold">Adhesive Type</p></div><div class="c-sm-quarter-2 c-xs-full floatLeft"><p class="floatRightOnMedium" id="adhesiveTypeSummary">' + adhesiveTypeSelected + ' : ' + adhesiveSideSelected + '</p></div>');
                    }

                    //get nib type selected
                    if (document.querySelector(".PD_NibTypeSummary")) {
                        document.querySelector(".PD_NibTypeSummary").parentNode.removeChild(document.querySelector(".PD_NibTypeSummary"));
                    }
                    if (document.getElementById("NibOptions").selectedIndex != -1) {
                        var nibTypeSelected = document.getElementById("NibOptions")[document.getElementById("NibOptions").selectedIndex].text;
                        document.getElementById('colorSummary').parentNode.insertAdjacentHTML('afterend', '<div class="clear tinySpace"></div><div class="PD_NibTypeSummary c-sm-quarter-2 c-xs-full floatLeft"><p class="textsemibold">Tip Size</p></div><div class="c-sm-quarter-2 c-xs-full floatLeft"><p class="floatRightOnMedium" id="nibTypeSummary">' + nibTypeSelected + '</p></div>');
                    }

                    //get ink color selected
                    if (document.querySelector(".PD_inkColorSummary")) {
                        document.querySelector(".PD_inkColorSummary").parentNode.removeChild(document.querySelector(".PD_inkColorSummary"));
                    }
                    if (document.getElementById("inkColorOptions").selectedIndex != -1) {
                        var inkColorSelected = document.getElementById("inkColorOptions")[document.getElementById("inkColorOptions").selectedIndex].text;
                        document.getElementById('colorSummary').parentNode.insertAdjacentHTML('afterend', '<div class="clear tinySpace"></div><div class="PD_inkColorSummary c-sm-quarter-2 c-xs-full floatLeft"><p class="textsemibold">Writing Ink ' + localizedJS.ColorCap + '</p></div><div class="c-sm-quarter-2 c-xs-full floatLeft"><p class="floatRightOnMedium" id="inkColorSummary">' + inkColorSelected + '</p></div>');
                    }

                    var OrderSummary = {
                        ProductID: prodID,
                        Quantity: qty,
                        ImprintColors: arrImprintColorsIDs,
                        ImprintLocations: arrImprintLocationIDs,
                        SelectedSizes: selectedSizes,
                        BaseColorID: baseTrimColor[0],
                        TrimColorID: baseTrimColor[1],
                        EditID: editID,
                        ProductImprintLocations: arrProductImprintLocationIDs,
                        NibColorAttributeID: GetNibColorAttributeID(),
                        AdhesiveAttributeID: GetAdhesiveAttributeID(),
                        SelectedOptionalExtras: selectedOptionalExtras,
                        IsReorder: document.getElementById("isReorder").value.toLowerCase() === 'true'  // jag
                    };

                    document.querySelector('.cartLoadingImg').style.display = "block";
                    document.querySelector('.cartError').innerHTML = '';
                    var addToCartRequest = ajax({
                        url: "/productmvc/addtocart",
                        method: "POST",
                        headers: antiForgeryToken,
                        data: OrderSummary
                    }).then(function (response, xhr) {
                        if (response.success == "true") {
                            OmniLogCartAdd(response.newCart == undefined ? true : response.newCart);
                            //Item Summary will be disabled for now.
                            //$('.PD_Step_2').fadeOut('slow', function () {
                            //    $('.PD_Summary').fadeIn('100', function () {
                            //        $('.PD_Summary').removeClass('hide');
                            //        ScrollToElement('.PD_Summary', 500);
                            //    });
                            //});
                            //This might be added back in the future. JWW 10/24
                            cartUrl = response.redirectUrl;
                            if (document.getElementById('HideAdvertisedPrice').value == 'True') {
                                if (editID < 0) {
                                    editID = response.cartItemID;

                                    //cart MS uses Sequence instead of CartItemID
                                    // removing as of 10/29/19 as restricted items weren't being deleted from cart
                                    // readded 1/17/2020 as the go to cart is broken without this
                                    // editId needs to be an int or it fails modelstate, cartItemId is a guid
                                    if (response.sequence > 0) {
                                        editID = response.sequence;
                                    }
                                    document.querySelector('.cartLoadingImg').style.display = "none";
                                    RestrictedPricing.Open(response.cartID, editID, response.cartItemID);
                                } else {
                                    window.location.href = response.redirectUrl;
                                }
                            } else {
                                window.location.href = response.redirectUrl;
                            }
                        } else {
                            document.querySelector('.cartLoadingImg').style.display = "none";
                            document.querySelector('.cartError').innerHTML = '<div aria-live="polite" role="status">There was an error adding item to Cart. Please try again!</div>';
                        }
                        processing = false;
                    }).catch(function (response, xhr) {
                        document.querySelector('.cartError').innerHTML = '<div aria-live="polite" role="status">There was an error adding item to Cart. Please try again!</div>';
                        document.querySelector('.cartLoadingImg').style.display = "none";
                        processing = false;
                    });
                },
                // remove any trailing slash in URL to prevent 301 redirect to HTTP protocol which causes ASE to block request
                removeTrailingSlash = function (url) {
                    if (url.charAt(url.length - 1) === "/") {
                        url = url.substring(0, url.length - 1);
                    }
                    return url;
                };
            return {
                GetCustomerImagePage: getCustomerImagePage,
                GetQAPage: getQAPage,
                GetStoryPage: getStoryPage,
                GetReviewPage: getReviewPage,
                GetFitRatingPage: getFitRatingPage,
                LoadSizing: loadSizing,
                GetAddlImpConfigPage: getAddlImpConfigPage,
                LoadOptionalExtras: loadOptionalExtras,
                ReviewChange: reviewChange,
                ReviewFilterChange: reviewFilterChange,
                GetImpConfigSummary: getImpConfigSummary,
                DeleteRestrictedCart: deleteRestrictedCart,
                GetJumpToColors: getJumpToColors,
                UpdateLocationDetails: updateLocationDetails,
                LoadAdhesiveOptions: loadAdhesiveOptions,
                LoadNibInkColor: loadNibInkColor,
                SampleRequest: sampleRequest,
                FitRatingChange: fitRatingChange,
                SubmitQuestion: submitQuestion,
                PositiveReview: positiveReview,
                NegativeReview: negativeReview,
                PositiveAnswer: positiveAnswer,
                NegativeAnswer: negativeAnswer,
                SubmitAnswer: submitAnswer,
                SubmitQuickAnswer: submitQuickAnswer,
                LoadMiniRating: loadMiniRating,
                GetRelatedProducts: getRelatedProducts,
                GetDetailTabs: getDetailTabs,
                GetItemCategories: getItemCategories,
                GetTabbedScroller: getTabbedScroller,
                GetAlternativeItems: getAlternativeItems,
                GetAlternativeItemsList: getAlternativeItemsList,
                GetPropSixtyFive: getPropSixtyFive,
                GetExtras: getExtras,
                GetExtrasAmount: getExtrasAmount,
                GetItemDetails: getItemDetails,
                AddToCart: addToCart,
            };
        })();

    ajaxActions.GetImpConfigSummary(); // call this as early as possible

    var extraChargesTooltip = [].slice.call(document.getElementsByClassName("setupTooltip"));
    extraChargesTooltip.forEach(function (el) {
        el.addEventListener("click", function (e) {
            document.getElementById("loading").classList.remove("hide");
            if (selBaseTrim == undefined || selBaseTrim.value == "") {
                selBaseTrim.value = document.querySelector('.selectedColorID').value;
            }
            e.preventDefault();
            if (document.getElementById('itemExtraChgsPopup')) {
                document.getElementById('itemExtraChgsPopup').previousElementSibling.setAttribute("aria-expanded", "false");
                document.getElementById('itemExtraChgsPopup').parentNode.removeChild(document.getElementById('itemExtraChgsPopup'));
            }
            el.setAttribute("aria-expanded", "true");
            el.insertAdjacentHTML('afterend', '<div id="itemExtraChgsPopup"></div>');
            if (!document.getElementsByClassName("imprintConfiguration")[0]) {
                configSectionLoadingExtraChg = true;
                return false;
            }
            ajaxActions.GetItemDetails(el);
        });
    });

    function GetAdhesiveAttributeID() {

        var adhesiveAttributeID;

        if (document.getElementById("adhSideOptions").selectedIndex != -1) {
            // example item: 3832-S
            adhesiveAttributeID = adhesiveInput.value;  // holds the real value, need to make sure a side was selected
        }

        if ((adhesiveAttributeID == "" || adhesiveAttributeID == undefined) && document.getElementById("adhOptions").selectedIndex != -1) {
            // example item: 3832-M
            adhesiveAttributeID = adhesiveInput.value; // holds the real value, need to make sure an option was selected
        }

        return adhesiveAttributeID;
    }


    function GetNibColorAttributeID() {
        var checkedNibColor = "";
        if (document.getElementById("inkColorOptions").selectedIndex != -1) {
            checkedNibColor = document.getElementById("inkColorOptions")[document.getElementById("inkColorOptions").selectedIndex].text;
        }
        var nibColorAttributeID;
        if (checkedNibColor != "" && document.getElementById("inkColorOptions").value != "") {
            nibColorAttributeID = document.querySelector(".colorName" + checkedNibColor.replace(/\s/g, "")).value;
        }

        return nibColorAttributeID;
    }

    function clearSizesEvent() {
        document.getElementsByClassName('clearAllSizes')[0].addEventListener('click', function (e) {
            e.preventDefault();
            animate.fadeOut(document.getElementsByClassName('moreSizes')[0]);
            [].forEach.call(document.getElementsByClassName('moreSizes')[0].getElementsByClassName('txtApparelQty'), function (el) {
                el.value = '';
            });
            var newLabel = this.value.replace('Clear All', 'Add');
            this.value = newLabel;
            this.classList.remove('clearAllSizes');
            this.classList.add('addMoreSizes');
            addSizesEvent();
            CalcPrice();
        });
    }

    function addSizesEvent() {
        document.getElementsByClassName("addMoreSizes")[0].addEventListener('click', function (e) {
            e.preventDefault();
            animate.fadeIn(document.getElementsByClassName('moreSizes')[0]);
            var newLabel = this.value.replace('Add', 'Clear All');
            this.value = newLabel;
            this.classList.remove('addMoreSizes');
            this.classList.add('clearAllSizes');
            clearSizesEvent();
        });
    }

    function sizeInputsEvent() {
        var apparelQty = [].slice.call(document.getElementsByClassName('txtApparelQty'));
        apparelQty.forEach(function (el, index, array) {
            el.classList.remove("input-validation-error");
            el.removeAttribute('aria-invalid');
        });

        var thisQty = 0;
        if (isNumeric(this.value)) {
            apparelQty.forEach(function (el, index, array) {
                if (el.value != '') {
                    if (isNumeric(el.value)) {
                        thisQty += parseInt(el.value);
                    }
                }
            });
            thisQty = verifyApparelMaxQty(thisQty);
        } else {
            this.value = '';
            return false;
        }
        var updateDelay = (thisQty < lowestQty) ? 750 : 600;
        txtTimer = setTimeout(function () {
            if (isGFeed) {
                document.getElementById('GFeedPanel').style.display = "none";
                document.getElementById("pricingarea").classList.remove("hide");
            }
            if (document.getElementById('txtQty').parentNode.parentNode.getElementsByTagName('input')[0]) {
                document.getElementById('txtQty').parentNode.parentNode.getElementsByTagName('input')[0].parentNode.removeChild(document.getElementById('txtQty').parentNode.parentNode.getElementsByTagName('input')[0]);
            }
            CalcPrice();
        }, updateDelay);
        return true;
    }

    function verifyApparelMaxQty(thisQty) {
        if (!restrict24hrMaxQty)
            return thisQty;

        //leave the message up if qty == max break so they have a change to click on the link for standard pricing
        if (thisQty != glide.MaxBreakQty() && document.getElementById("sizingBox").parentNode.querySelector(".alertBox.alertWarning")) {
            document.getElementById("sizingBox").parentNode.querySelector(".alertBox.alertWarning").remove();
        }

        if (thisQty > glide.MaxBreakQty()) {
            if (document.activeElement.value != '') {
                var activeVal = document.activeElement.value;
                if (isNumeric(document.activeElement.value)) {
                    document.activeElement.value = glide.MaxBreakQty() - (thisQty - activeVal);
                    thisQty = glide.MaxBreakQty;

                    var quantityErrorHtml =
                        '<div class="alertBox alertWarning"><div class="alertInner"><svg class="alertBulb" height="25px" width="25px" aria-hidden="true"><use xlink: href="#svgIcon-hint"></use></svg><div class="alertText c-md-12">We\'re sorry, the ' + twentyFourHrLabel + ' service quantity limit is ' + glide.MaxBreakQty() + ' for this item. The amount you entered has been adjusted. <a href="' + standardProdTimeProductUrl + '">Shop item #' + standardProdTimeCatalogueAlias + ' with a standard production time</a> for higher quantities<br/></div></div></div>';

                    document.getElementById('sizingBox').insertAdjacentHTML('beforebegin', quantityErrorHtml);
                }
            }
        }

        return thisQty;
    }

    function lazyLoadFix() {
        setTimeout(function () {
            lazyloadImages.update();
        }, 800);
    }

    function initProductColorSlider() {
        prodColorSlider = new tns({
            container: '.prodColorSlider',
            mouseDrag: true,
            prevButton: document.getElementById('prodColorPrev'),
            nextButton: document.getElementById('prodColorNext'),
            items: 2,
            gutter: 10,
            loop: false,
            lazyload: true,
            slideBy: "page",
            nav: false,
            responsive: {
                1024: {
                    items: 5
                },
                700: {
                    items: 4
                },
                480: {
                    items: 3
                }
            }
        });
        return prodColorSlider;
    }

    function rebuildProdColorSlider() {
        initProductColorSlider();
        prodColorSlider.destroy();
        prodColorSlider = prodColorSlider.rebuild();
    }

    function initProductColorScroller() {
        if (document.getElementById("productColorScroller")) {
            initProductColorSlider();
        }
        var imageColorChoices = [].slice.call(document.getElementsByClassName("imgBox"));
        imageColorChoices.forEach(function (el, index, array) {
            el.addEventListener("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                var triggerImg = el;
                SaveProdColor(triggerImg);
            });
        });
    }

    function initHandlers() {
        window.addEventListener("load", function () {
            lazyLoadFix();
        });
        if (!window.addEventListener && window.attachEvent) {
            window.attachEvent('load', lazyLoadFix);
        }

        var extraProdImgs = [].slice.call(document.getElementsByClassName("DetailsProdImg"));
        extraProdImgs.forEach(function (el, index, array) {
            el.addEventListener("click", function (e) {
                e.preventDefault();
            });
        });

        var thumbSelectImgs = [].slice.call(document.getElementsByClassName("otherImagesJS"));
        thumbSelectImgs.forEach(function (el, index, array) {
            var image = el.querySelector("img");
            el.addEventListener("click", function (e) {
                var vals = image.id.split('_');
                mainImgSlider.goTo(vals[1]);
            });
        });

        mainImgSlider.events.on('indexChanged', function () {
            var index = mainImgSlider.getInfo().index;
            setBkgdBorderAndNextImage(index);
        });

        if (document.getElementsByClassName('sampleRequest1')[0]) {
            document.getElementsByClassName('sampleRequest1')[0].addEventListener("click", function (e) {
                e.preventDefault();
                ajaxActions.SampleRequest();
            });
        }

        if (document.getElementsByClassName('btnAddToCart')[0]) {
            document.getElementsByClassName('btnAddToCart')[0].addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (!document.getElementsByClassName("imprintConfiguration")[0]) {
                    document.querySelector('.cartLoadingImg').style.display = "block";
                    configSectionLoading = true;
                    return false;
                }
                if (!processing) {
                    processing = true;
                    //because of design on mobile, make sure they haven't forgotten to select color / quantity
                    if (isMobile || document.getElementsByClassName('bypassImpConfigAddToCart')[0]) {
                        if (document.getElementById('colorSelected').value === '') {
                            document.getElementById("productColors").querySelector(".PD_customizeHead").insertAdjacentHTML('afterend', errorMessageBox);
                            document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<button id="colorError" class="btnToHyp text16 underline textLeft">Please select a product ' + localizedJS.Color + '.</button>'
                            document.getElementsByClassName("ErrorMsgPanel")[0].classList.add("clear");
                            document.getElementById("colorError").focus();
                            document.getElementsByClassName("cartLoadingImg")[0].style.display = "none";
                            document.getElementById("colorError").addEventListener("click", function (e) {
                                e.preventDefault();
                                document.querySelector('.imgBox').focus();
                            });
                            processing = false;
                            return false;
                        }
                        if (GetQty() < lowestQty) {
                            var quantityErrorHtml = '<div id="ErrorBox" class="qtyErrorMsg ErrorMsgPanel clear" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>' +
                                '<ul class="ErrorMsgBox"><li><button id="quantityError" class="btnToHyp textLeft text16 underline textLeft">Minimum quantity for this item is ' + lowestQty + '.</button></li></ul></div>';
                            if (document.querySelector(".qtyErrorMsg")) {
                                document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));
                            }
                            if (isApparelItem) {
                                document.getElementById('PD_SizeGrid').insertAdjacentHTML('beforebegin', quantityErrorHtml);
                                var apparelQtys = document.querySelectorAll(".txtApparelQty");
                                for (var i = 0; i < apparelQtys.length; i++) {
                                    if (apparelQtys[i].value != '') {
                                        apparelQtys[i].classList.add("input-validation-error");
                                        apparelQtys[i].setAttribute('aria-invalid', 'true');
                                    }
                                }
                                document.getElementById("quantityError").focus();
                                document.getElementById("quantityError").addEventListener("click", function (e) {
                                    e.preventDefault();
                                    apparelQtys[0].focus();
                                });
                            } else {
                                document.querySelector('.glidePanel').insertAdjacentHTML('beforebegin', quantityErrorHtml);
                                document.getElementById('txtQty').classList.add("input-validation-error");
                                document.getElementById('txtQty').setAttribute('aria-invalid', 'true');
                                document.getElementById("quantityError").focus();
                                document.getElementById("quantityError").addEventListener("click", function (e) {
                                    e.preventDefault();
                                    document.getElementById('txtQty').focus();
                                });
                            }
                            processing = false;
                            return false;
                        }
                    }
                    forms.formValidation(document.getElementById("step2"), ajaxActions.AddToCart, e);
                    processing = false;
                }
            });
        }

        if (document.getElementById('hypMoreDetails')) {
            document.getElementById('hypMoreDetails').addEventListener("click", function (e) {
                e.preventDefault();
                document.getElementsByClassName('prodDetails')[0].scrollIntoView({
                    behavior: "smooth"
                });
            });
        }

        window.addEventListener("resize", clearFloat);
    }

    function pricingHandlers() {
        function checkSizeInput(e) {
            var el = e.currentTarget;
            var allInputs = [].slice.call(document.getElementsByClassName("txtApparelQty"));
            allInputs.forEach(function (el, index, array) {
                el.classList.remove("input-validation-error");
                el.removeAttribute('aria-invalid');
            });
            if (IsNumeric(el.value)) {
                var thisQty = 0;
                allInputs.forEach(function (el, index, array) {
                    if (el.value != '') {
                        if (IsNumeric(el.value)) {
                            thisQty += parseInt(el.value);
                        }
                    }
                });
                var updateDelay = (thisQty < lowestQty) ? 750 : 600;
                txtTimer = setTimeout(function () {
                    if (document.getElementById("GFeedPanel")) {
                        document.getElementById("GFeedPanel").style.display = "none";
                    }
                    var hiddenInput = document.getElementById('txtQty').parentNode.parentNode.getElementsByTagName('input')[0];
                    if (hiddenInput) hiddenInput.parentNode.removeChild(hiddenInput);
                    document.getElementById("pricingarea").classList.remove("hide");
                    CalcPrice();
                }, updateDelay);
            } else {
                el.value = '';
                el.focus();
                return false;
            }
            return true;
        }

        var sizeInputs = [].slice.call(document.getElementsByClassName("txtApparelQty"));
        sizeInputs.forEach(function (el, index, array) {
            el.addEventListener("keyup", checkSizeInput);
            el.addEventListener("focusout", checkSizeInput);
        });
    }

    function OmniLogCartAdd(newCart) {
        if (typeof s != "undefined") {
            s.events = (newCart) ? 'scOpen, scAdd' : 'scAdd';
            /************* DO NOT ALTER ANYTHING BELOW THIS LINE ! **************/
            var s_code = s.t();
            if (s_code) document.write(s_code);
        }
    }


    var ImageZoom = (function () {
        var zoomImages = [].slice.call(document.querySelectorAll(".prodImage")),
            productImages = [].slice.call(document.querySelectorAll(".DetailsProdImg")),
            increment = 40,
            zoomSliderHTML,
            dialogTriggerEl,
            init = function () {
                zoomImages.forEach(function (el, index, array) {
                    el.removeEventListener("mousemove", zoomThis);
                    el.removeEventListener("mouseleave", removeZoom);
                    el.addEventListener("mousemove", zoomThis);
                    el.addEventListener("mouseleave", removeZoom);
                });

                document.getElementById("zoomOutMain").removeEventListener("click", zoomOut);
                document.getElementById("zoomOutMain").addEventListener("click", zoomOut);
                document.getElementById("zoomInMain").removeEventListener("click", zoomIn);
                document.getElementById("zoomInMain").addEventListener("click", zoomIn);

                /* temporary until zoom dialog is approved on desktop */
                document.getElementById("panLeftMain").removeEventListener("click", moveZoomLeft);
                document.getElementById("panLeftMain").addEventListener("click", moveZoomLeft);
                document.getElementById("panRightMain").removeEventListener("click", moveZoomRight);
                document.getElementById("panRightMain").addEventListener("click", moveZoomRight);
                document.getElementById("panUpMain").removeEventListener("click", moveZoomUp);
                document.getElementById("panUpMain").addEventListener("click", moveZoomUp);
                document.getElementById("panDownMain").removeEventListener("click", moveZoomDown);
                document.getElementById("panDownMain").addEventListener("click", moveZoomDown);

                mainImgSlider.events.on('transitionStart', function () {
                    if (document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").hasAttribute("style")) {
                        removeZoom();
                    }
                    if (document.getElementById("zoomInMain").classList.contains("hide")) {
                        document.getElementById("zoomOutMain").click();
                    }
                });

                if(window.innerWidth <= 800){
                    // initiate zoom dialog on mobile & tablet since mouse events may not be registered
                    productImages.forEach(function(el, index, array){
                        el.removeEventListener("click", openZoomDialog);
                        el.addEventListener("click", openZoomDialog);
                        el.setAttribute("aria-haspopup", "true");
                        el.setAttribute("aria-expanded", "false");
                        el.setAttribute("aria-describedby", "tapDescription");
                    });
                    zoomDialog.init(document.getElementById("zoomDialog"));
                }else{  /* temporary until zoom dialog is approved on desktop */
                    productImages.forEach(function(el, index, array){
                        el.removeAttribute("aria-haspopup");
                        el.removeAttribute("aria-expanded");
                        el.removeAttribute("aria-describedby");
                    });
                }
            },
            zoomThis = function (e) {
                var el = document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").querySelector(".DetailsProdImg"); // img parent div
                el.getElementsByTagName("img")[0].style.opacity = "0";
                if (el.style.backgroundImage == "") { // no need to assign this with every move of mouse
                    el.style.backgroundImage = "url(" + el.getAttribute("href") + ")";
                }
                var offsetX = e.offsetX;
                var offsetY = e.offsetY;

                var x = offsetX / el.offsetWidth * 100;
                var y = offsetY / el.offsetHeight * 100;
                el.style.backgroundPositionX = x + '%';
                el.style.backgroundPositionY = y + '%';
                el.style.backgroundRepeat = "no-repeat";
            },
            removeZoom = function (e) {
                var el = document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").querySelector(".DetailsProdImg"); // img parent div
                el.removeAttribute("style"); // remove background styles
                el.getElementsByTagName("img")[0].removeAttribute("style"); // remove 0 opacity
            },
            zoomOut = function (e) {
                e.preventDefault();
                var zoomImg = document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").querySelector(".DetailsProdImg");
                removeZoom();
                document.querySelector(".moreGestures").classList.remove("show");
                document.querySelector(".moreGestures").classList.add("hide");
                if (document.querySelector(".otherImagesJS")) { // if arrows are showing in the first place
                    document.getElementById("leftArrowClick").style.display = "block";
                    document.getElementById("rightArrowClick").style.display = "block";
                }
                document.getElementById("zoomInMain").classList.remove("hide");
                document.getElementById("zoomInMain").classList.add("show");
                document.getElementById("zoomInMain").setAttribute("aria-expanded", "false");
                if(document.getElementById("zoomLiveRegion")) document.getElementById("zoomLiveRegion").textContent = "";
                document.getElementById("zoomInMain").focus();
                zoomImg.removeEventListener("mouseleave", closeZoom);
            },
            zoomIn = function (e) {
                e.preventDefault();
                var zoomImg = document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").querySelector(".DetailsProdImg");
                zoomImg.getElementsByTagName("img")[0].style.opacity = 0;
                zoomImg.style.backgroundImage = "url(" + zoomImg.getAttribute("href") + ")";
                zoomImg.style.backgroundPositionY = "-200px";
                zoomImg.style.backgroundPositionX = "-200px";
                zoomImg.style.backgroundRepeat = "no-repeat";
                document.querySelector(".moreGestures").classList.remove("hide");
                document.querySelector(".moreGestures").classList.add("show");
                document.getElementById("zoomInMain").classList.remove("show");
                document.getElementById("zoomInMain").classList.add("hide");
                document.getElementById("zoomInMain").setAttribute("aria-expanded", "true");
                if (document.querySelector(".otherImagesJS")) { // if arrows are showing in the first place
                    document.getElementById("leftArrowClick").style.display = "none";
                    document.getElementById("rightArrowClick").style.display = "none";
                }
                document.getElementById("zoomOutMain").focus();
                zoomImg.addEventListener("mouseleave", closeZoom);
            },
            closeZoom = function () {
                document.getElementById("zoomOutMain").click();
            },
            moveZoomRight = function (e) {
                e.preventDefault();
                var zoomImg = document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").querySelector(".DetailsProdImg");
                var left = zoomImg.style.backgroundPositionX;
                if (left.length > 2) {
                    var leftNum = +left.substring(0, left.length - 2);
                    if (leftNum > -321) {
                        leftNum = leftNum - increment;
                        if (leftNum < -321) {
                            leftNum = -321;
                        }
                    }
                    zoomImg.style.backgroundPositionX = leftNum + 'px';
                    if(document.getElementById("zoomLiveRegion")) {
                    		document.getElementById("zoomLiveRegion").textContent = "";
                    		document.getElementById("zoomLiveRegion").textContent = "Zoom image moved right";
                    }
                }
            },
            moveZoomLeft = function (e) {
                e.preventDefault();
                var zoomImg = document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").querySelector(".DetailsProdImg");
                var left = zoomImg.style.backgroundPositionX;
                if (left.length > 2) {
                    var leftNum = +left.substring(0, left.length - 2);
                    if (leftNum < 0) {
                        leftNum = leftNum + increment;
                        if (leftNum > 0) {
                            leftNum = 0;
                        }
                    }
                    zoomImg.style.backgroundPositionX = leftNum + 'px';
                    if(document.getElementById("zoomLiveRegion")) {
                    		document.getElementById("zoomLiveRegion").textContent = "";
                    		document.getElementById("zoomLiveRegion").textContent = "Zoom image moved left";
                    	}
                }
            },
            moveZoomUp = function (e) {
                e.preventDefault();
                var zoomImg = document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").querySelector(".DetailsProdImg");
                var top = zoomImg.style.backgroundPositionY;
                if (top.length > 2) {
                    var topNum = +top.substring(0, top.length - 2);
                    if (topNum < 0) {
                        topNum = topNum + increment;
                        if (topNum > 0) {
                            topNum = 0;
                        }
                    }
                    zoomImg.style.backgroundPositionY = topNum + 'px';
                    if(document.getElementById("zoomLiveRegion")) {
                    		document.getElementById("zoomLiveRegion").textContent = "";
                    		document.getElementById("zoomLiveRegion").textContent = "Zoom image moved up";
                    	}
                }
            },
            moveZoomDown = function (e) {
                e.preventDefault();
                var zoomImg = document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").querySelector(".DetailsProdImg");
                var top = zoomImg.style.backgroundPositionY;
                if (top.length > 2) {
                    var topNum = +top.substring(0, top.length - 2);
                    if (topNum > -401) {
                        topNum = topNum - increment;
                        if (topNum < -401) {
                            topNum = -401;
                        }
                    }
                    zoomImg.style.backgroundPositionY = topNum + 'px';
                    if(document.getElementById("zoomLiveRegion")) {
                    		document.getElementById("zoomLiveRegion").textContent = "";
                    		document.getElementById("zoomLiveRegion").textContent = "Zoom image moved down";
                    	}
                }
            },
            setUpZoomDialogScroller = function(){
                var mainImgSrc = document.querySelector(".mainProdImg").getAttribute("data-src").replace("/300/", "/700/");
                zoomSliderHTML =
                    '<div class="posRelative" aria-describedby="tapDescription">' +
                    '<button class="zoomDialog-prev slider-prev" aria-label="Previous Image"><svg class="textDarkestGray rotate270" height="20px" width="20px"> <use xlink:href="#svgIcon-arrowLine"></use> </svg></button>' +
                    '<div class="Scroller zoomDialogSlider marginTop20 floatLeft c-xs-quarter-2">' +
                    '<div class="textCenter" data-zoom="' + mainImgSrc + '">' +
                    '<img class="responsiveImg tns-lazy-img" data-src="' + mainImgSrc + '" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt="Large Product Photo" />' +
                    '</div>';

                var extras = [].slice.call(document.querySelectorAll(".extraProdImg"));
                for(var i = 0; i < extras.length; i++){
                    var imageSrc = extras[i].getElementsByTagName("img")[0].getAttribute("data-src").replace("/300/", "/700/");
                    var imageAlt = extras[i].getElementsByTagName("img")[0].getAttribute("alt");
                    zoomSliderHTML += '<div class="textCenter" data-zoom="' + imageSrc + '"><img class="responsiveImg tns-lazy-img" data-src="' + imageSrc + '" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt="' + imageAlt + '" /></div>';
                }

                zoomSliderHTML += '</div>' +
                    '<button class="zoomDialog-next slider-next" aria-label="Next Image"><svg class="textDarkestGray rotate90" height="20px" width="20px"> <use xlink:href="#svgIcon-arrowLine"></use> </svg></button>' +
                    '</div>' +
                    '<p id="tapDescription" class="text16 textCenter marginTop20">Use fingers to zoom</p>';

                return zoomSliderHTML;
            },
            openZoomDialog = function(e){
                e.preventDefault();
                document.getElementById("tapDescription").classList.add("hide");
                dialogTriggerEl = e.currentTarget;
                dialogTriggerEl.setAttribute("aria-expanded", "true");
                document.getElementById("zoomDialog").setAttribute("aria-hidden", "false");
                setUpZoomDialogScroller();
                document.getElementById("zoomWindow").innerHTML = zoomSliderHTML;
                document.getElementById("zoomDialog").querySelector("h2").textContent = "Viewing Larger " + document.querySelector("h1").textContent;

                zoomSlider = new tns({
                    container: document.querySelector('.zoomDialogSlider'),
                    rewind: true,
                    lazyload: true,
                    prevButton: document.querySelector('.zoomDialog-prev'),
                    nextButton: document.querySelector('.zoomDialog-next'),
                    speed: 500,
                    nav: true,
                    touch: false,
                    navPosition: "bottom"
                });
                var info = mainImgSlider.getInfo();
                var currentSlide = info.index;
                zoomSlider.goTo(currentSlide);

                zoomDialog.open();
                bindDialogEvents();

                //prevent vertical scrolling while open - works on desktop but not ios bummer
                document.body.style.overflow = "hidden";
                document.body.style.position = "fixed";

                disableSlideScroll(); //disabling scrolling on touch/drag so zooming with fingers on mobile does not trigger a slide change
            },
            closeZoomDialog = function(e){
                e.preventDefault();
                document.getElementById("tapDescription").classList.remove("hide");
                dialogTriggerEl.setAttribute("aria-expanded", "false");
                document.getElementById("zoomDialog").setAttribute("aria-hidden", "true");
                var info = zoomSlider.getInfo();
                var currentSlide = info.index;
                mainImgSlider.goTo(currentSlide);
                document.getElementById("zoomWindow").innerHTML= "";
                document.querySelector(".tns-nav-active").focus();
                document.body.removeAttribute("style"); //allow scrolling again
            },
            disableSlideScroll = function(){
                var preventDrag = function(){
                    zoomSlider.event.stopPropagation();
                };
                zoomSlider.events.off("dragStart", preventDrag);
                zoomSlider.events.on("dragStart", preventDrag);
            },
            bindDialogEvents = function(){
                zoomSlider.events.on('transitionStart', function(){
                    if(document.getElementById("zoomWindow").querySelector(".tns-slide-active").hasAttribute("style")){
                        removeZoom();
                    }
                });

                document.getElementById("zoomDialog").querySelector(".close4iDialog").removeEventListener("click", closeZoomDialog);
                document.getElementById("zoomDialog").querySelector(".close4iDialog").addEventListener("click", closeZoomDialog);

                document.getElementById("zoomDialog").addEventListener("keydown", function(e){
                    if(e.which == 27){ // escape
                        closeZoomDialog(e);
                        document.getElementById("zoomDialog").removeEventListener("keydown", [0]);
                    }
                });

                var sliderNavBtns = [].slice.call(document.getElementById("zoomDialog").querySelector(".tns-nav").querySelectorAll("button"));
                sliderNavBtns.forEach(function(el, index, array){
                    el.addEventListener("keydown", function(e){
                        if(e.which == 9){
                            document.getElementById("zoomDialog").querySelector(".close4iDialog").focus();
                        }
                    });
                });
            };
        return {
            Init: init
        };
    })(); // end zoom


    function MobileTweaks() {
        if (isMobile) {
            var social = document.querySelectorAll(".SocialMediaButtons"); //need to return a nodelist to work
            var beforeProdDetails = document.querySelectorAll(".prodDetails");
            beforeProdDetails[0].parentNode.insertBefore(social[0], beforeProdDetails[0]);

            var relatedProds = document.querySelectorAll("#relatedProductsContainer");
            var lastElement = document.querySelectorAll(".back-to-top");
            lastElement[0].parentNode.insertBefore(relatedProds[0], lastElement[0]);

            document.getElementsByClassName("PD_Step_1")[0].classList.remove("borderDkGray");
            if (bypassImpConfig) {
                document.getElementsByClassName("bypassImpConfigAddToCart")[0].parentNode.classList.remove("floatRight");
                document.getElementById("addToCart").querySelector(".borderBottomDkGray").classList.remove("borderBottomDkGray");
            }
            if (document.getElementById("btnCustomizeImprint")) {
                document.getElementsByClassName("PD_Step_2")[0].classList.remove("hide");
            } else {
                document.querySelector('.btnAddToCart').classList.remove('disabledBtn');
                document.querySelector('.btnAddToCart').classList.remove('bkgdMdGray');
                document.querySelector('.btnAddToCart').classList.add('bkgdRed');
                document.querySelector('.btnAddToCart').classList.add('whiteLink');
            }
            if (document.querySelector('.glidePanel') !== null) {
                document.getElementsByClassName('glidePanel')[0].classList.add('marginTop10');
                document.getElementsByClassName('glidePanel')[0].classList.remove('marginTop40');
            }
            if (document.getElementById("addToCart").querySelector('.btnLgWrapper')) {
                document.getElementById("addToCart").querySelector('.btnLgWrapper').classList.add('layoutCenter');
                document.getElementById("addToCart").querySelector('.btnLgWrapper').classList.remove('paddingLeft20');
            }
             if (document.getElementsByClassName("extrasResult")[0]) {
                document.getElementsByClassName("extrasResult")[0].innerHTML = formatMoney(parseFloat(document.getElementsByClassName("extrasResult")[0].innerHTML.replace(currencySymbol, '')));
            }
	      var selectedProdColor = "";
		if (document.getElementsByClassName("oneColorOption")[0]) {
		        selectedProdColor = document.getElementsByClassName("oneColorOption")[0].innerHTML;
		} else {
		    selectedProdColor = document.getElementById("selColors").innerHTML;
		}
		if (document.getElementsByClassName("prodColor")[0]) {
		    document.getElementsByClassName("prodColor")[0].innerHTML = selectedProdColor.trim() != "" ? selectedProdColor : document.getElementsByClassName("baseColorName")[0].value;
		}
		if (document.getElementsByClassName("quantitySummary")[0] && !isApparelItem) {
		    document.getElementsByClassName("quantitySummary")[0].innerHTML = GetQty();
              }
        }
    }

    function FixIE11SVG() {
        var isIE11 = !!navigator.userAgent.match(/Trident\/7\./);
        if (isIE11) {
            var svgs = document.getElementsByTagName("svg");
            var i = svgs.length;
            while (i--) {
                svgs[i].setAttribute("focusable", "false");
            }
        }
    }

    function GetQty() {
        if (document.getElementById("txtQty")) {
            if (!isApparelItem) {
                return parseInt(document.getElementById("txtQty").value);
            } else {
                return parseInt(document.getElementById("txtQty").innerHTML);
            }
        }
    }

    function showHideTabs() {
        if (isApparelItem) {
            document.getElementById("fitRatingTS").classList.remove("hide");
        }
        if (localizedJS.showCustomerImages) {
            document.getElementById("customerImagesTS").classList.remove("hide");
        }
        if (!localizedJS.showSuccessStories) {
            document.getElementById("successStoriesTS").classList.add("hide");
        }
    }

    var showColorOptions = function () {
        document.getElementById('colorOptions').style.display = "block";
        document.getElementById('colorOptions').setAttribute('aria-hidden', 'false');
        document.getElementById('selectBaseColor').style.display = "block";
        document.getElementById('selectBaseColor').setAttribute('aria-hidden', 'false');
        document.getElementById('prodColorCountContainer').style.display = "none";
        document.getElementById('prodColorCountContainer').setAttribute('aria-hidden', 'true');
        document.getElementById('productColorScroller').style.display = "none";
        document.getElementById('productColorScroller').setAttribute('aria-hidden', 'true');
        document.getElementById('jumpToColor').style.display = "none";
        document.getElementById('jumpToColor').setAttribute('aria-hidden', 'true');
        tooltips.init(); // color tooltip
    };

    var jumpToColor = function (triggerElement) {
        var chosenColorID = '';
        var elementId;
        if (triggerElement == document.getElementById('removeColorFilter')) {
            chosenColorID = '-1';
        } else if (triggerElement.classList.contains('colorOption')) {
            elementId = triggerElement.id;
            chosenColorID = elementId.substring(11, elementId.indexOf('_')); // color ID is the number after "colorOption" and before the underscore
        } else {
            elementId = triggerElement.parentNode.id;
            chosenColorID = elementId.substring(11, elementId.indexOf('_'));
        }
        ajaxActions.GetJumpToColors(chosenColorID);
    };

    var jumpToTheColor = function (e) {
        e.preventDefault();
        showColorOptions();
        document.getElementById('colorOptions').getElementsByClassName('colorOption')[0].focus();
    };

    var colorOptionClick = function (e) {
        e.preventDefault();
        jumpToColor(this);
        rebuildProdColorSlider();
    };

    var colorOptionsClicksOff = function () {
        if (document.getElementById('jumpToColor')) {
            document.getElementById('jumpToColor').removeEventListener("click", jumpToTheColor);
        }
        var colorOpts = [].slice.call(document.getElementsByClassName('colorOption'));
        colorOpts.forEach(function (el, index, array) {
            el.removeEventListener("click", colorOptionClick);
        });
    };

    var colorOptionsClicks = function () {
        if (document.getElementById('jumpToColor')) {
            document.getElementById('jumpToColor').addEventListener("click", jumpToTheColor);
        }

        var colorOpts = [].slice.call(document.getElementsByClassName('colorOption'));
        colorOpts.forEach(function (el, index, array) {
            el.addEventListener("click", colorOptionClick);
        });

        if (document.getElementById('removeColorFilter')) {
            document.getElementById('removeColorFilter').addEventListener("click", function (e) {
                e.preventDefault();
                jumpToColor(this);
            });
        }
    };

    var isNumeric = function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    };

    function SaveImprintColor(triggerElement) {
        var activeSection = triggerElement.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
        var selectedColor = triggerElement.querySelector('.colorOptionBox').style.backgroundColor;
        var colorTitle = triggerElement.getAttribute('title');
        var imprintLocID = triggerElement.parentNode.querySelector('.imprintLocationID').value;
        var imprintColorID = triggerElement.parentNode.querySelector('.imprintColorID').value;
        var productImprintLocationID = triggerElement.parentNode.querySelector('.productImprintLocationID').value;
        var oneColor = activeSection.querySelectorAll('.imprint-color-section').length - activeSection.querySelectorAll('.imprint-color-section.hide').length == 1;
        var selectColorOptionsElem = triggerElement.parentNode.parentNode.parentNode.parentNode.parentNode;
        var needToGetExtras = false;
        if (selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintColorBox').style.backgroundColor == "" ||
            selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintColorBox').style.backgroundColor == "rgba(0, 0, 0, 0)") {
            needToGetExtras = true;
        }
        var colorLists = [].slice.call(selectColorOptionsElem.querySelectorAll('.colorList'));
        var emptyColorBoxes = [];
        colorLists.forEach(function (el) {
            var rgbColor = el.querySelector('.imprintColorBox').style.backgroundColor;
            if (rgbColor == "rgba(0, 0, 0, 0)" || rgbColor == "transparent" || rgbColor == "") {
                emptyColorBoxes.push(el);
            }
        });
        if (emptyColorBoxes.length > 0 & !oneColor) {
            emptyColorBoxes[0].querySelector('.imprintLocationID').value = imprintLocID;
            emptyColorBoxes[0].querySelector('.imprintColorID').value = imprintColorID;
            emptyColorBoxes[0].querySelector('.productImprintLocationID').value = productImprintLocationID;
            emptyColorBoxes[0].querySelector('.imprintColorBox').style.backgroundColor = selectedColor;
            emptyColorBoxes[0].querySelector('.imprintColorBox').setAttribute('title', colorTitle);
        } else if (colorLists.length > 0) {
            selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintColorBox').style.backgroundColor = selectedColor;
            selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintColorBox').setAttribute('title', colorTitle);
            selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintLocationID').value = imprintLocID;
            selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintColorID').value = imprintColorID;
            selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.productImprintLocationID').value = productImprintLocationID;
        }

        ValidateCustomizeSections();
        if (needToGetExtras) { // don't get extras if they're just changing colors among the same color option
            ajaxActions.GetExtrasAmount();
        }
    }

    var initCustomerImagesPages = function () {
        var pagingLinks = [].slice.call(document.getElementsByClassName('imagespageselect'));
        pagingLinks.forEach(function (el, index, array) {
            el.removeEventListener("click", ajaxActions.GetCustomerImagePage);
            el.addEventListener("click", ajaxActions.GetCustomerImagePage);
        });
    };

    var initQAPages = function () {
        var pagingLinks = [].slice.call(document.getElementsByClassName('qapageselect'));
        pagingLinks.forEach(function (el, index, array) {
            el.removeEventListener("click", ajaxActions.GetQAPage);
            el.addEventListener("click", ajaxActions.GetQAPage);
        });
    };

    var initSuccessPages = function () {
        var pagingLinks = [].slice.call(document.getElementsByClassName('storiespageselect'));
        pagingLinks.forEach(function (el, index, array) {
            el.removeEventListener("click", ajaxActions.GetStoryPage);
            el.addEventListener("click", ajaxActions.GetStoryPage);
        });
    };

    var initReviewPages = function () {
        var pagingLinks = [].slice.call(document.getElementsByClassName('reviewspageselect'));
        pagingLinks.forEach(function (el, index, array) {
            el.removeEventListener("click", ajaxActions.GetReviewPage);
            el.addEventListener("click", ajaxActions.GetReviewPage);
        });
    };

    function SetSummaryImprintColors() {
        var newContent = "";
        if (listSelectedImprintLocationName.length > 0 && listSelectedColorsRGB.length > 0 && totalImprintColors > 0) {
            for (var i = 0; i < listSelectedImprintLocationName.length; i++) {
                newContent += "<div class='clear tinySpace'></div><h5 class='textsemibold'>Imprint Location</h5>" +
                    "<p>" + listSelectedImprintLocationName[i] +
                    "</p><div class='clear tinySpace'></div><h5 class='textsemibold'>Imprint " + localizedJS.ColorCap + "(s)</h5>";
                for (var j = 0; j < listSelectedColorsRGB[i].length; j++) {
                    if (listSelectedColorsRGB[i][j] != "") {
                        newContent += "<div class='imprintColorSummary floatLeft marginTop5 marginBtm20 marginRight5 borderDkGray' style='background-color: " + listSelectedColorsRGB[i][j] + "'></div>";
                    }
                }
            }
        } else if (totalImprintColors == 0) {
            for (var i = 0; i < listSelectedImprintLocationName.length; i++) {
                newContent += "<div class='clear tinySpace'></div><h5 class='c-sm-quarter-2 c-xs-full floatLeft textsemibold'>Imprint Location</h5>" +
                    "<div class='c-sm-quarter-2 c-xs-full floatLeft'><p class='floatRightOnMedium'>" + listSelectedImprintLocationName[i] +
                    "</p></div><div class='clear'></div>";
            }
        }
        var newContentDiv = document.createElement('div');
        newContentDiv.innerHTML = newContent;
        document.querySelector('.imprint-location-summary').insertBefore(newContentDiv, document.querySelector('.imprint-location-summary').firstChild);
    }

    function ValidateCustomizeSections() {
        GetSelectedImprintLocations();
        GetSelectedImprintColors();
        checkForReorderChanges();   // jag added

        var addToCartBtn = document.getElementsByClassName('btnAddToCart')[0];
        if (isMobile) { //because of design decision to show everything at once, need to make sure they've selected a product color
            if (document.getElementById('colorSelected').value == '') {
                addToCartBtn.classList.remove('bkgdRed');
                addToCartBtn.classList.remove('whiteLink');
                addToCartBtn.classList.add('disabledBtn');
                addToCartBtn.classList.add('bkgdMdGray');
                return false;
            }
        }
        var enableBtn = true;
        var displayedColorSections = [].slice.call(document.getElementsByClassName("imprint-color-section"));
        displayedColorSections.forEach(function (el) {
            if (!el.classList.contains("hide") && el.querySelector(".prodColorOptions").classList.contains("txtReq") && !el.querySelector(".prodColorOptions").classList.contains("txtReq")) {
                enableBtn = false;
            }
        });
        if (listImprintLocationIDs.length > 0 && listSelectedColors.length > 0) {
            if ((!document.getElementById("NibOptions").disabled && document.getElementById("NibOptions").options.length > 0 && document.getElementById("NibOptions").selectedIndex == 0) ||
                (!document.getElementById("adhSideOptions").disabled && document.getElementById("adhSideOptions").options.length > 0 && document.getElementById("adhSideOptions").selectedIndex == 0) ||
                (!document.getElementById("inkColorOptions").disabled && document.getElementById("inkColorOptions").options.length > 0 && document.getElementById("inkColorOptions").selectedIndex == 0) ||
                (!document.getElementById("adhOptions").disabled && document.getElementById("adhOptions").options.length > 0 && document.getElementById("adhOptions").selectedIndex == 0)) {
                enableBtn = false;
            }
        } else {
            enableBtn = false;
        }
        if (enableBtn || bypassImpConfig) {
            addToCartBtn.classList.remove('disabledBtn');
            addToCartBtn.classList.remove('bkgdMdGray');
            addToCartBtn.classList.add('bkgdRed');
            addToCartBtn.classList.add('whiteLink');
            addToCartBtn.removeAttribute("tabindex");
            addToCartBtn.removeAttribute("aria-invalid");
        } else {
            addToCartBtn.classList.remove('bkgdRed');
            addToCartBtn.classList.remove('whiteLink');
            addToCartBtn.classList.add('disabledBtn');
            addToCartBtn.classList.add('bkgdMdGray');
        }
    }

    function GetSelectedImprintLocations() {
        listImprintLocationIDs = [];
        listProductImprintLocationIDs = [];
        if (totalImprintColors == 0) {
            listSelectedImprintLocationName = [];
        }

        var locationChexBoxes = [].slice.call(document.getElementsByClassName("selImprintLocation"));
        locationChexBoxes.forEach(function (el, index, array) {
            if (!el.parentNode.parentNode.classList.contains("hide")) {
                var inputImpLocID = el[el.selectedIndex].value;
                var imprintLocationName = el[el.selectedIndex].text;
                var impl = null;
                var prodimploc = null;
                if (totalImprintColors == 0) {
                    listImprintLocationIDs.push(inputImpLocID);
                    listSelectedImprintLocationName.push(imprintLocationName);
                } else {
                    var colorLists = [].slice.call(el.parentNode.parentNode.getElementsByClassName('colorList'));
                    colorLists.forEach(function (el) {
                        var imprintLocationID = el.getElementsByClassName('imprintLocationID')[0].value;
                        var imprintColorID = el.getElementsByClassName('imprintColorID')[0].value;
                        var productImprintLocationID = el.getElementsByClassName('productImprintLocationID')[0].value;
                        if (imprintLocationID != undefined && imprintLocationID != "" && imprintColorID != undefined && productImprintLocationID != undefined && productImprintLocationID != "") {
                            impl = imprintLocationID;
                            prodimploc = productImprintLocationID;
                        }
                    });
                    if (impl != null) {
                        listImprintLocationIDs.push(impl);
                    }
                    if (prodimploc != null) {
                        listProductImprintLocationIDs.push(prodimploc);
                    }
                }
            }
        });
    }

    function GetSelectedSizes() {
        var sizeHash = "";
        if (isApparelItem) {
            var sizeOptions = [].slice.call(document.getElementsByClassName("sizeOptionQty"));
            sizeOptions.forEach(function (el) {
                var sizeQty = el.getElementsByClassName('txtApparelQty')[0].value;
                if (sizeQty != '' && sizeQty != undefined && sizeQty != '0') {
                    var saPID = el.getElementsByClassName('sizeAttrProdID')[0].value;
                    var saID = el.getElementsByClassName('sizeAttrID')[0].value;
                    var qty = el.getElementsByClassName('txtApparelQty')[0].value;
                    sizeHash += saPID + '-' + saID + '-' + qty + '|';
                }
            });
        }
        return sizeHash;
    }

    // jag
    function CountImprintColors(imprintColors) {
        var count = 0;

        imprintColors.forEach(function (colors) {
            count += colors.length;
        });

        return count;
    }

    function formatMoney(x) {
        return parseFloat(x).toFixed(2);
    }

    function AddSelectedExtra(e){
        cb = e.target;
        if (document.getElementsByClassName("GFeedPanel1")[0]) {
            document.getElementsByClassName("GFeedPanel1")[0].parentNode.removeChild(document.getElementsByClassName("GFeedPanel1")[0]);
        }
        var currentselection = document.getElementById('SelectedOptionalExtras'); // this holds all the selected extras in '*11, *33,'
        if (cb.checked && currentselection.value.indexOf('*' + cb.value + ',') == -1) {
            currentselection.value = currentselection.value + '*' + cb.value + ',';;
        } else if (currentselection.value.indexOf('*' + cb.value + ',') != -1) { // remove from if is there
            currentselection.value = currentselection.value.replace('*' + cb.value + ',', '');
        }
        document.getElementById('selectedOptionalExtraResult').style.display = "none";
        GetSelectedImprintColors();
        document.getElementsByClassName("extrasRow")[0].classList.remove("hide");
        ajaxActions.GetExtrasAmount(true); // add to the total
    }

    function SaveProdColor(triggerElement) {
        forms.ClearValidation();
        var selectedImg;
        if (triggerElement.querySelector('img')) {
            selectedImg = triggerElement.querySelector('img').getAttribute('data-src');  // jag - use data-src attribute instead of src do to lazy loading
        } else if (triggerElement.getAttribute('src')) {
            selectedImg = triggerElement.getAttribute('src');
        } else if (triggerElement.getAttribute('data-lazy')) {
            selectedImg = triggerElement.getAttribute('data-lazy');
        } else if (recolorAvailable.value == "True") {
            selectedImg = triggerElement.parentNode.getAttribute('href').replace("rend/700", "rend/300");
        }
        var selectedBaseTrimID = "";
        var selectedColorName = "";
        var trimColorHex = "";
        var baseColorHex = "";
        mainImgSlider.goTo(0);
        var prodColorImgs = [].slice.call(document.querySelectorAll(".imgBox"));
        var newLabel;
        if (recolorAvailable.value == "True") {
            if (document.querySelector('.imgActive')) { // remove previous active image
                //document.querySelector('.imgActive').setAttribute("aria-selected", "false");
                newLabel = document.querySelector('.imgActive').getAttribute("aria-label").replace("Currently Selected", "Select");
                document.querySelector('.imgActive').setAttribute("aria-label", newLabel);
                document.querySelector('.imgActive').classList.remove("imgActive");
            }
            triggerElement.classList.add('imgActive');
            newLabel = triggerElement.getAttribute("aria-label").replace("Select", "Currently Selected");
            triggerElement.setAttribute("aria-label", newLabel);
            //triggerElement.setAttribute("aria-selected", "true");

            if (selectedImg){
                document.getElementById('hypProdImg').querySelector('.mainProdImg').setAttribute("src", selectedImg.replace("rend/60", "rend/300"));
                document.getElementById('hypProdImg').querySelector('.mainProdImg').setAttribute("data-src", selectedImg.replace("rend/60", "rend/300"));
                document.getElementById('hypProdImg').setAttribute("href", selectedImg.replace("rend/60", "rend/700"));
            }

            document.getElementById('colorSelected').value = triggerElement.getAttribute("title");
            selectedBaseTrimID = triggerElement.parentNode.querySelector('.selectedColorID').value;
            document.getElementById('colorSummary').textContent = triggerElement.getAttribute('title');
            selectedColorName = triggerElement.parentNode.querySelector('.selectedColorName').value;
            baseColorHex = triggerElement.parentNode.querySelector('.baseColorHex').value;
            trimColorHex = triggerElement.parentNode.querySelector('.trimColorHex').value;
        } else {
            selectedBaseTrimID = triggerElement.parentNode.querySelector('.selectedColorID').value;
            selectedColorName = triggerElement.parentNode.querySelector(".selectedColorName").value;
            baseColorHex = triggerElement.parentNode.querySelector('.baseColorHex').value;
            trimColorHex = triggerElement.parentNode.querySelector('.trimColorHex').value;
	     var newLabel;
            prodColorImgs.forEach(function (el, index, array) {
                el.querySelector('.selectedImgDesc').classList.add('textDarkestGray');
                el.querySelector('.selectedImgDesc').classList.remove('bkgdBlue');
                newLabel = el.getAttribute("aria-label").replace("Currently Selected", "Select");
                el.setAttribute("arial-label", newLabel);
                //el.setAttribute("aria-selected", "false");
                if (el.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc')) {
                    el.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc').classList.add('textRed');
                    el.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc').classList.remove('textWhite');
                }
            });
            newLabel = triggerElement.getAttribute("aria-label").replace("Select", "Currently Selected");
            triggerElement.setAttribute("aria-label", newLabel);
            //triggerElement.setAttribute("aria-selected", "true");
            triggerElement.querySelector('.selectedImgDesc').classList.add('textWhite');
            triggerElement.querySelector('.selectedImgDesc').classList.add('bkgdBlue');
            triggerElement.querySelector('.selectedImgDesc').classList.remove('textDarkestGray');
            if (triggerElement.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc')) {
                triggerElement.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc').classList.add('textWhite');
                triggerElement.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc').classList.remove('textRed');
            }
        }

        if (document.getElementById('baseSpan')) {
            document.getElementById('baseSpan').style.backgroundColor = '#' + baseColorHex;
            document.getElementById('baseSpan').setAttribute("aria-label", triggerElement.parentNode.querySelector(".baseColorName").value);
        }
        if (document.getElementById('trimSpan')) {
            document.getElementById('trimSpan').style.backgroundColor = '#' + trimColorHex;
            document.getElementById('trimSpan').setAttribute("aria-label", triggerElement.parentNode.querySelector(".trimColorName").value);
        }

        if (selectedBaseTrimID != undefined && selectedBaseTrimID != "") {
            selBaseTrim.value = selectedBaseTrimID;
            document.getElementById('colorSelected').value = selectedColorName;
            document.getElementById('selColors').innerHTML = selectedColorName;
        }

        var selectedProdColor = "";
        if (document.getElementsByClassName("oneColorOption")[0]) {
            selectedProdColor = document.getElementsByClassName("oneColorOption")[0].innerHTML;
        } else {
            selectedProdColor = document.getElementById("selColors").innerHTML;
        }
        if (document.getElementsByClassName("prodColor")[0]) {
            document.getElementsByClassName("prodColor")[0].innerHTML = selectedProdColor.trim() != "" ? selectedProdColor : document.getElementsByClassName("baseColorName")[0].value;
        }
        if (!isApparelItem) {
            if (document.querySelector('.step1')) {
                document.querySelector('.step1').classList.remove('disabledBtn');
                document.querySelector('.step1').classList.add('bkgdBlue');
                document.querySelector('.step1').classList.add('whiteLink');
            } else if (bypassImpConfig) {
                document.querySelector('.btnAddToCart').classList.remove('disabledBtn');
                document.querySelector('.btnAddToCart').classList.remove('bkgdMdGray');
                document.querySelector('.btnAddToCart').classList.add('bkgdRed');
                document.querySelector('.btnAddToCart').classList.add('whiteLink');
            }
            if (document.getElementsByClassName("quantitySummary")[0]) {
                document.getElementsByClassName("quantitySummary")[0].innerHTML = GetQty();
            }
            if (isMobile) {
                if (isGFeed) {
                    CheckQueryString();

                    var gFeedSummary = '<div class="GFeedPanel1 c-md-12">';
                    gFeedSummary += document.getElementById('GFeedPanel').innerHTML + '</div>';
                    document.getElementById('GFeedPanel').innerHTML = "";

                    document.getElementById("PD_OptionalExtra").insertAdjacentHTML('afterend', gFeedSummary);
                }
                ajaxActions.GetExtrasAmount();
                ValidateCustomizeSections();
            }
        }
        if (selectedBaseTrimID != '' && isApparelItem) {
            //Load apparel size grid
            if (document.getElementById('PD_SizeGrid')) {
                document.getElementById('PD_SizeGrid').innerHTML = '';
            }
            if (document.getElementById('PD_SizeGridLoading')) {
                document.getElementById('PD_SizeGridLoading').style.display = "block";
            }
            if (document.querySelector('.PD_QuantityBtnCell')) {
                document.querySelector('.PD_QuantityBtnCell').querySelector('input').disabled = true; // Disables the qty button to keep it from opening multiple windows
                document.querySelector('.PD_QuantityBtnCell').style.opacity = "0.3";
            }
            if (document.querySelector('.PD_SizeChoicePanel')) {
                animate.fadeIn(document.querySelector('.PD_SizeChoicePanel'));
            }

            var hidePricing = document.getElementById('HideAdvertisedPrice').value.toUpperCase() === 'TRUE';
            ajaxActions.LoadSizing(selectedBaseTrimID, hidePricing);
            CheckQueryString();
        }
        ajaxActions.LoadNibInkColor();
        ajaxActions.LoadAdhesiveOptions();
    } //end product color

    function CheckQueryString() {
        if (isGFeed) {
            if (document.getElementsByClassName("imprint-color-section")[0]) {
                updateRemoveColorText(document.getElementsByClassName("imprint-color-section")[0]);
            }
            var txtQty = GetQty();
            selBaseTrim.value = document.getElementsByClassName('selectedColorID')[0].value;
            var glideUnitPrice = 0;
            var glideTotal = 0;
            var glideSubTotal = 0;
            glideUnitPrice = document.getElementById('lblPrice') ? document.getElementById('lblPrice').value : "";
            glideTotal = document.getElementById('lblTotal') ? document.getElementById('lblTotal').innerHTML : "";
            glideSubTotal = document.getElementById('lblSubtotal') ? document.getElementById('lblSubtotal').innerHTML : "";

            if (document.getElementById('GFeedQty') ) {
                //commenting these out as google's scraper sucks but not so much on the UK side
                if(!(ukTaxRate != '0')){
                    document.getElementById('GFeedQty').innerHTML = ''; //txtQty;
                    document.getElementById('GFeedUnitPrice').innerHTML = ''; //glideUnitPrice;
                    document.getElementById('GFeedTotalPrice').innerHTML = ''; //glideTotal;
                }
                if (document.getElementById('gFeedDefaultImprintColor')) {
                    document.querySelector(".input_active").innerHTML = document.getElementById('gFeedDefaultImprintColor').parentNode.querySelector('.spnColorChip').innerHTML;
                    document.querySelector(".input_active").querySelector(".colorOptionText").classList.add("txtToValidate");
                    document.querySelector(".prodColorOptions").classList.remove("txtReq");
                    document.querySelector(".colorOptions").classList.add("hide");
                    document.querySelector(".colorOptions").removeAttribute("style");
                    document.querySelector(".imprintClearColor").classList.remove("hide");
                    SaveImprintColor(document.getElementById('gFeedDefaultImprintColor').parentNode.querySelector('.spnColorChip'));
                }
            }
            getAttributes();
        }
    }

    var cartUrl = '';
    var RestrictedPricing = (function(){
        var open = function(cartID, cartItemID, deleteItemID){
                restrictedPricingDialog.init(document.getElementById('restrictedPricingProduct'));

                var headerLinks = new header4i();
                headerLinks.loadUserLinks();

                fillDialogInfo();

                if (isApparelItem) {
                    document.getElementById('pricingArea').appendChild(document.getElementById('priceTblSizeChoice'));
                    document.getElementById('priceTblSizeChoice').classList.remove("hide");
                    document.getElementById('pricingArea').appendChild(document.getElementById('sizingBox'));
                    document.getElementById('priceTblSizeChoice').classList.add('hide');
                    document.getElementById('pnlFitRating').classList.add('hide');
                } else {
                    document.getElementById('pricingArea').appendChild(document.getElementsByClassName('glide')[0]);
                    document.querySelector(".glideToolTip ").style.display = "none";
                    document.querySelector(".glide").style.padding = "0px 10px";
                }

                document.getElementsByClassName('showp')[0].classList.remove('hide');
                document.getElementsByClassName('showpm')[0].classList.add('hide');
                document.getElementById("restrictedPricingProduct").setAttribute("data-cart-item", cartItemID);
                document.getElementById("restrictedPricingProduct").setAttribute("data-cart-delete", deleteItemID);

                restrictedPricingDialog.open();
                document.getElementById("btnGoToCart").focus();
                document.getElementsByClassName('cartLoadingImg')[0].classList.add('hide');

                var closeRestrictedBtn = [].slice.call(document.getElementById("restrictedPricingProduct").getElementsByClassName("close4iDialog"));
                closeRestrictedBtn.forEach(function (el, index, array) {
                    el.addEventListener("click", function (e) {
                        e.preventDefault();
                        close();
                        document.getElementById("restrictedPricingProduct").setAttribute("data-cart-item", "");
                        document.getElementById("restrictedPricingProduct").setAttribute("data-cart-delete", "");
                        editID = -1;
                    });
                });
                document.getElementById("btnRemoveCart").addEventListener('click', function (e) {
                    e.preventDefault();
                    ajaxActions.DeleteRestrictedCart(cartID);
                });
                document.getElementById("btnGoToCart").addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    editID = document.getElementById("restrictedPricingProduct").getAttribute("data-cart-item"); //temporary fix
                    ajaxActions.AddToCart(e);
                });
            },
            close = function(){
                var headerLinks = new header4i();
                headerLinks.loadUserLinks();
                if (isApparelItem) {
                    document.getElementById('pnlSizing').appendChild(document.getElementById('sizingBox'));
                } else {
                    document.getElementsByClassName('glidePanel')[0].appendChild(document.getElementsByClassName('glide')[0]);
                    document.querySelector(".glideToolTip ").removeAttribute("style");
                    document.querySelector(".glide").removeAttribute("style");
                }
                document.getElementById("imgforrestricted").innerHTML = "";
                if(document.getElementById("gcheck")){
                    document.getElementById("gcheck").parentNode.removeChild(document.getElementById("gcheck"));
                }
                document.getElementsByClassName('showp')[0].classList.add('hide');
                document.getElementsByClassName('showpm')[0].classList.remove('hide');
                document.getElementsByClassName("goToStep1")[0].focus();
            },
            fillDialogInfo = function(){
                var productName = document.getElementsByClassName("prodName")[0].textContent;
                var productNameNoQuote = productName.replace(/'/g, "");
                var newImg = document.createElement('img');
                newImg.setAttribute("id", "restrictedProductImg");
                newImg.setAttribute("src", document.getElementById("hypProdImg").getAttribute("href"));
                newImg.setAttribute("alt", productNameNoQuote);
                newImg.setAttribute("class", 'responsiveImg');
                document.getElementById("imgforrestricted").appendChild(newImg);
                document.querySelector(".prodNameRestricted").textContent = productName;
            };
        return{
            Open: open,
            Close: close
        };
    })();

    var loadingPage = function (container) {
        container.getElementsByClassName('loadingPage')[0].classList.remove('hide');
    };

    var hideLoading = function (container) {
        container.getElementsByClassName('loadingPage')[0].classList.add('hide');
    };

    var initReviewFilters = function () {
        var reviewOpts = [].slice.call(document.getElementsByClassName('reviewOptions'));
        reviewOpts.forEach(function (el, index, array) {
            el.addEventListener('change', ajaxActions.ReviewChange);
        });

        var reviewFilters = [].slice.call(document.getElementsByClassName('reviewFilter'));
        reviewFilters.forEach(function (el, index, array) {
            el.addEventListener("click", function (e) {
                var vals = el.id.split('_');
                var filter = '';
                if (vals.length > 1) {
                    filter = vals[1];
                }
                ajaxActions.ReviewFilterChange(filter);
                return false;
            });
        });
    };

    var initFitRatingPages = function () {
        var fitPaging = [].slice.call(document.getElementsByClassName('fitratingpageselect'));
        fitPaging.forEach(function (el, index, array) {
            el.addEventListener("click", ajaxActions.GetFitRatingPage);
        });
    };

    function CalcPrice() {
        var TotalQty = 0;
        var apparelInputs = [].slice.call(document.querySelectorAll(".txtApparelQty"));
        apparelInputs.forEach(function (el, index, array) {
            if (el.value != '') {
                if (IsNumeric(el.value)) {
                    TotalQty += parseInt(el.value);
                }
            }
        });
        if (document.getElementById('txtQty')) {
            document.getElementById('txtQty').innerHTML = TotalQty;
        }
        if (TotalQty >= lowestQty) {
            if (document.querySelector('.qtyErrorMsg')) {
                document.querySelector('.qtyErrorMsg').parentNode.removeChild(document.querySelector('.qtyErrorMsg'));
            }
            document.getElementById('txtQty').removeAttribute('style');
            if (document.getElementsByClassName("quantitySummary")[0]) {
                document.getElementsByClassName("quantitySummary")[0].innerHTML = GetQty();
            }
            if (selBaseTrim.value != "" && document.querySelector('.step1')) {
                document.querySelector('.step1').classList.remove('disabledBtn');
                document.querySelector('.step1').classList.add('bkgdBlue');
                document.querySelector('.step1').classList.add('whiteLink');
            } else if (selBaseTrim.value != "" && bypassImpConfig) {
                document.querySelector('.btnAddToCart').classList.remove('disabledBtn');
                document.querySelector('.btnAddToCart').classList.add('bkgdRed');
                document.querySelector('.btnAddToCart').classList.add('whiteLink');
            }
            var BreakNumBelow = -1;
            var BreakNumAbove = -1;
            for (var i = 0; i < arrBreak.length; i++) {
                if ((i + 1 >= arrBreak.length || arrBreak[i + 1] < 1) && TotalQty >= arrBreak[i] && arrBreak[i] > 0) {
                    BreakNumBelow = i;
                    BreakNumAbove = i;
                } else {
                    if (TotalQty >= arrBreak[i] && TotalQty < arrBreak[i + 1]) {
                        BreakNumBelow = i;
                        BreakNumAbove = i + 1;
                    }
                }
            }
            var newPrice = glide.GetPriceEstimate(BreakNumBelow, TotalQty, 0);
            if (document.getElementById('lblPrice')) {
                if(document.querySelector(".glidePanel")){ //glide
                    document.getElementById('lblPrice').value = currencySymbol + newPrice.toFixed(2);
                }else{ //apparel
                    document.getElementById('lblPrice').innerHTML = currencySymbol + newPrice.toFixed(2);
                }
            }
            if (document.getElementById('lblTotal')) {
                document.getElementById('lblTotal').innerHTML = currencySymbol + (newPrice * TotalQty).toFixed(2);
            }
            if (document.getElementById('lblSubtotal')) {
                document.getElementById('lblSubtotal').innerHTML = currencySymbol + (newPrice * TotalQty).toFixed(2);
            }
            if (isMobile) {
                ajaxActions.GetExtrasAmount();
            }
        } else {
            if (document.querySelector('.step1')) {
                document.querySelector('.step1').classList.add('disabledBtn');
                document.querySelector('.step1').classList.remove('bkgdBlue');
                document.querySelector('.step1').classList.remove('whiteLink');
            } else if (bypassImpConfig) {
                document.querySelector('.btnAddToCart').classList.add('disabledBtn');
                document.querySelector('.btnAddToCart').classList.remove('bkgdRed');
                document.querySelector('.btnAddToCart').classList.remove('whiteLink');
            }
            if (document.getElementById('lblPrice')) {
                if(document.querySelector(".glidePanel")){ //glide
                    document.getElementById('lblPrice').value = '';
                }else{ //apparel
                    document.getElementById('lblPrice').innerHTML = '';
                }
            }
            if (document.getElementById('lblTotal')) {
                document.getElementById('lblTotal').innerHTML = '';
            }
            if (document.getElementById('lblSubtotal')) {
                document.getElementById('lblSubtotal').innerHTML = '';
            }
        }
    }

    function IsNumeric(strString) {
        var strValidChars = "0123456789";
        var strChar;
        var blnResult = true;

        for (i = 0; i < strString.length && blnResult == true; i++) {
            strChar = strString.charAt(i);
            if (strValidChars.indexOf(strChar) == -1) {
                blnResult = false;
            }
        }
        return blnResult;
    }

    function adhesiveOptionChanged() {
        toggleAvailableAdhesiveSides();

        // Find the selected nib and ink color in the master list and set the id to the hidden input
        var selectedAdhesive = document.getElementById("adhOptions")[document.getElementById("adhOptions").selectedIndex].text;
        var selectedAdhSide = document.getElementById("adhSideOptions")[document.getElementById("adhSideOptions").selectedIndex].text;
        for (var i = 0; i < adhSidesOptions.adhesive.length; i++) {
            if ((selectedAdhSide == adhSidesOptions.adhesive[i].side && selectedAdhesive == adhSidesOptions.adhesive[i].adh) ||
                (typeof selectedAdhSide == 'undefined' && selectedAdhesive == adhSidesOptions.adhesive[i].adh) ||
                (selectedAdhSide == adhSidesOptions.adhesive[i].side && typeof selectedAdhesive == 'undefined')) {
                adhesiveInput.value = adhSidesOptions.adhesive[i].id;
                ValidateCustomizeSections();
                return;
            }
            ValidateCustomizeSections();
        }
    }

    function toggleAvailableAdhesiveSides() {
        // Need to hide ink colors that are not available for the selected nib size
        var selectedAdh = document.getElementById("adhOptions")[document.getElementById("adhOptions").selectedIndex].text;
        
        // Don't bother unless there are nib options and there are ink options set
        if (typeof selectedAdh != "" && adhSidesOptions.adhesive.length > 0) {
            var adhSideOptions = document.getElementById('adhSideOptions').querySelectorAll('option');
            if (adhSideOptions.length > 0) {
                var selectedAdhesiveSides = [];

                // Populate the array with all of the possible ink colors for this nib
                for (var i = 0; i < adhSidesOptions.adhesive.length; i++) {
                    if (selectedAdh == adhSidesOptions.adhesive[i].adh) {
                        selectedAdhesiveSides[selectedAdhesiveSides.length] = adhSidesOptions.adhesive[i];
                    }
                }

                // Toggle the side options
                for (var i = 0; i < selectedAdhesiveSides.length; i++) {
                    var sideFound = false;

                    for (var j = 0; j < adhSideOptions.length; j++) {
                        if (!sideFound && selectedAdhesiveSides[i].value == adhSideOptions[j].adh) {
                            sideFound = true;
                        }
                    }

                    if (sideFound) {
                        adhSideOptions[i].style.display = "block";
                    } else if (adhSideOptions[i].value != "") {
                        adhSideOptions[i].style.display = "none";

                        // If the option being hidden is selected, move the option to the first visible ink option
                        if (adhSideOptions[i].value == document.getElementById("adhSideOptions")[document.getElementById("adhSideOptions").selectedIndex].text) {
                            document.getElementById("adhSideOptions").selectedIndex = 0;
                        }
                    }
                }
            }
        }
    }

    function NibInkOptionChanged() {
        toggleAvailableInkColors();

        var selectedInk = document.getElementById("inkColorOptions")[document.getElementById("inkColorOptions").selectedIndex].text;
        var selectedNib = document.getElementById("NibOptions")[document.getElementById("NibOptions").selectedIndex].text;
        for (var i = 0; i < nibInkOptions.inknib.length; i++) {
            if ((selectedInk == nibInkOptions.inknib[i].ink && selectedNib == nibInkOptions.inknib[i].nib) ||
                (typeof selectedInk == 'undefined' && selectedNib == nibInkOptions.inknib[i].nib) ||
                (selectedInk == nibInkOptions.inknib[i].ink && typeof selectedNib == 'undefined')) {
                nibInkInput.value = nibInkOptions.inknib[i].id;
                //Update the hidden input that holds the value to properly match the nib type selected.
                document.querySelector(".colorName" + nibInkOptions.inknib[i].ink.replace(/\s/g, "")).value = nibInkOptions.inknib[i].id;
                ValidateCustomizeSections();
                return;
            }
            ValidateCustomizeSections();
        }
    }

    function toggleAvailableInkColors() {
        // Need to hide ink colors that are not available for the selected nib size
        var selectedNib = document.getElementById("NibOptions")[document.getElementById("NibOptions").selectedIndex].text;
        // Don't bother unless there are nib options and there are ink options set
        if (typeof selectedNib != 'undefined' && nibInkOptions.inknib.length > 0) {
            var inkOptions = document.getElementById('inkColorOptions').querySelectorAll('option');
            if (inkOptions.length > 0) {
                var nibInkColors = [];

                // Populate the array with all of the possible ink colors for this nib
                for (var i = 0; i < nibInkOptions.inknib.length; i++) {
                    if (selectedNib == nibInkOptions.inknib[i].nib) {
                        nibInkColors[nibInkColors.length] = nibInkOptions.inknib[i];
                    }
                }

                // Toggle the ink colors
                for (var i = 0; i < inkOptions.length; i++) {
                    var colorFound = false;

                    for (var j = 0; j < nibInkColors.length; j++) {
                        if (!colorFound && inkOptions[i].value == nibInkColors[j].ink) {
                            colorFound = true;
                        }
                    }

                    if (colorFound) {
                        inkOptions[i].style.display = "block";
                    } else if (inkOptions[i].value != "") {
                        inkOptions[i].style.display = "none"

                        // If the option being hidden is selected, move the option to the first visible ink option
                        if (inkOptions[i].value == document.getElementById("inkColorOptions")[document.getElementById("inkColorOptions").selectedIndex].text) {
                            document.getElementById("inkColorOptions").selectedIndex = 0;
                        }
                    }
                }
            }
        }
    }

    function GetSelectedImprintColors() {
        listSelectedColors = [];
        listSelectedColorsRGB = [];
        listSelectedImprintLocationName = [];
        var colorIDs = [];
        var colorRGBs = [];
        var selImprintLocs = [].slice.call(document.getElementsByClassName("selImprintLocation"));
        selImprintLocs.forEach(function (el) {
            if (!el.parentNode.parentNode.classList.contains("hide")) {
                var colorsLists = [].slice.call(el.parentNode.parentNode.getElementsByClassName('colorList'));
                colorIDs = [];
                colorRGBs = [];
                colorsLists.forEach(function (elem) {
                    var backgroundColor = elem.getElementsByClassName('selectedColor')[0].style.backgroundColor;
                    if (backgroundColor != "rgba(0, 0, 0, 0)" && backgroundColor != 'transparent') {
                        var colorID = elem.getElementsByClassName('imprintColorID')[0].value;
                        if (!(colorID === undefined || colorID == "")) colorIDs.push(colorID);
                        colorRGBs.push(backgroundColor);
                    }
                });
                if (colorIDs.length > 0) {
                    listSelectedColors.push(colorIDs);
                }
                if (colorRGBs.length > 0) {
                    listSelectedColorsRGB.push(colorRGBs);
                    listSelectedImprintLocationName.push(el[el.selectedIndex].text);
                }
            }
        });
    }

    function clearFloat() {
        //add margin to push details down and floatleft
        if (isDesktop) {
            var imageHeight;
            if(document.querySelector('.extraImgsBox')){
                imageHeight = 370 + document.querySelector('.extraImgsBox').offsetHeight;
            }else {
                imageHeight = 370;
            }
            var infoHeight = document.getElementsByClassName('prodInfo')[0].offsetHeight;
            var summaryHeight;
            var ps = document.getElementsByClassName('prodSummary');
            if(ps !== null && ps.length > 0) summaryHeight = ps[0].offsetHeight;
            var infoSummary = infoHeight + summaryHeight;

            if (imageHeight > infoSummary) {
                var H = imageHeight - infoSummary;
                document.getElementsByClassName('prodSummary')[0].style.marginBottom = H;
            }
        } else if (isTabMobile && document.getElementsByClassName('prodSummary')[0]) { //don't add the extra margin
            document.getElementsByClassName('prodSummary')[0].style.marginBottom = '20px';
        }
    }

    var setDetailTabEvents = function () {
        initReviewPages();
        initReviewFilters();
        initFitRatingPages();
        initQAPages();
        if (localizedJS.showCustomerImages) {
            initCustomerImagesPages();
        }
        if (localizedJS.showSuccessStories) {
            initSuccessPages();
        }

        questionEvents();
        reviewEvents();

        var filterTags = [].slice.call(document.getElementsByClassName("filterTag"));
        filterTags.forEach(function (el, index, array) {
            el.addEventListener("click", function (e) {
                e.preventDefault();
                var vals = el.id.split('_');
                var filter = '';
                if (vals.length > 1) {
                    filter = vals[1];
                    document.getElementById('fitratingfilter').style.display = "block";
                    document.getElementById('fitratingfilter').classList.remove('hide');
                } else {
                    document.getElementById('fitratingfilter').style.display = "none";
                    document.getElementById('fitratingfilter').classList.add('hide');
                }
                ajaxActions.FitRatingChange(filter);
                return false;
            });
        });

        document.getElementsByClassName('btnSubmitProdQuestion')[0].addEventListener('click', function (e) {
            e.preventDefault();
            if (document.getElementsByClassName('prodQuestionMsg')[0]) {
                document.getElementsByClassName('prodQuestionMsg')[0].parentNode.removeChild(document.getElementsByClassName('prodQuestionMsg')[0]);
            }
            if (document.getElementById('prodQstn').value.trim().length < 6) {
                document.getElementById('prodQstn').classList.add("input-validation-error");
                document.getElementById('prodQstn').setAttribute('aria-invalid', 'true');
                document.getElementById('prodQstn').parentNode.getElementsByClassName("errorMessage")[0].classList.remove("hide");
                document.getElementById('prodQstn').parentNode.getElementsByClassName("errorMessage")[0].textContent = "Questions need to be longer than 5 characters.";
                document.getElementById('prodQstn').focus();
                return false;
            } else {
                document.getElementById('prodQstn').classList.remove("input-validation-error");
                document.getElementById('prodQstn').removeAttribute('aria-invalid');
                document.getElementById('prodQstn').parentNode.getElementsByClassName("errorMessage")[0].classList.add("hide");
                document.getElementById('prodQstn').parentNode.getElementsByClassName("errorMessage")[0].textContent = "";
            }

            ajaxActions.SubmitQuestion();
        });

        if (document.getElementById("customerImagesTS")) {
            document.getElementById("customerImagesTS").getElementsByTagName("a")[0].addEventListener("click", function (e) {
                lazyloadImages.update();
            });
        }
    };

    var reviewEvents = function () {
        var posReviewBtns = [].slice.call(document.getElementsByClassName('positiveReview'));
        posReviewBtns.forEach(function (el, index, array) {
            el.addEventListener('click', ajaxActions.PositiveReview);
        });

        var negReviewBtns = [].slice.call(document.getElementsByClassName('negativeReview'));
        negReviewBtns.forEach(function (el, index, array) {
            el.addEventListener('click', ajaxActions.NegativeReview);
        });
    };
    var questionEvents = function () {
        var qstTexts = [].slice.call(document.getElementsByClassName("questionText"));
        qstTexts.forEach(function (el, index, array) {
            el.addEventListener("click", function (e) {
                e.preventDefault();
                if (el.parentNode.getElementsByClassName("prodAnswerMsg")[0]) {
                    el.parentNode.getElementsByClassName("prodAnswerMsg")[0].parentNode.removeChild(el.parentNode.getElementsByClassName("prodAnswerMsg")[0]);
                }
                var answerQuestDiv = el.parentNode.getElementsByClassName('answerQuestion')[0];
                if (answerQuestDiv.classList.contains('hide')) {
                    el.setAttribute("aria-expanded", "true");
                    el.querySelector("svg").setAttribute("class", "textDkGray"); // IE 11 does not support classList.remove() on SVG elements
                    answerQuestDiv.getElementsByClassName("prodAnswer")[0].value = "";
                    animate.slideDown(answerQuestDiv);
                    answerQuestDiv.getElementsByClassName("prodAnswer")[0].focus();
                } else {
                    animate.slideUp(answerQuestDiv);
                    el.setAttribute("aria-expanded", "false");
                    el.querySelector("svg").setAttribute("class", "textDkGray rotate180"); // IE 11 does not support classList.add() on SVG elements
                    el.focus();
                }
            });
        });

        var posAnswers = [].slice.call(document.getElementsByClassName('positiveAnswer'));
        posAnswers.forEach(function (el, index, array) {
            el.addEventListener("click", ajaxActions.PositiveAnswer);
        });

        var negAnswers = [].slice.call(document.getElementsByClassName('negativeAnswer'));
        negAnswers.forEach(function (el, index, array) {
            el.addEventListener("click", ajaxActions.NegativeAnswer);
        });

        var submitAnswerBtns = [].slice.call(document.getElementsByClassName('btnSubmitProdAnswer'));
        submitAnswerBtns.forEach(function (el, index, array) {
            el.addEventListener("click", function (e) {
                e.preventDefault();
                var vals = el.id.split('_');
                var question_ID = vals[1];
                var answer = document.getElementById('answerQuestion_' + question_ID);

                if (document.getElementsByClassName("prodAnswerMsg")[0]) {
                    document.getElementsByClassName("prodAnswerMsg")[0].parentNode.removeChild(document.getElementsByClassName("prodAnswerMsg")[0]);
                }
                answer.parentNode.getElementsByClassName("errorMessage")[0].classList.add("hide");
                if (answer.value.trim().length < 2) {
                    answer.classList.add("input-validation-error");
                    answer.setAttribute('aria-invalid', 'true');
                    answer.parentNode.getElementsByClassName("errorMessage")[0].classList.remove("hide");
                    answer.parentNode.getElementsByClassName("errorMessage")[0].textContent = "Answers must be longer than 1 character.";
                    answer.focus();
                    return false;
                } else {
                    answer.classList.remove("input-validation-error");
                    answer.removeAttribute('aria-invalid');
                    answer.parentNode.getElementsByClassName("errorMessage")[0].classList.add("hide");
                    answer.parentNode.getElementsByClassName("errorMessage")[0].textContent = "";
                }
                var data = {
                    productID: prodID,
                    questionID: question_ID,
                    quickAnswer: answer.value
                };
                ajaxActions.SubmitAnswer(el, data);
            });
        });

        if (document.getElementsByClassName('addQuickAnswer')[0]) {
            document.getElementsByClassName('addQuickAnswer')[0].addEventListener('click', function (e) {
                document.getElementsByClassName('quickAnswerContent')[0].style.display = "none";
                document.getElementsByClassName('addQuickAnswer')[0].style.display = "block";
                document.getElementsByClassName('quickAnswSubmitMsg')[0].parentNode.removeChild(document.getElementsByClassName('quickAnswSubmitMsg')[0]);
                document.getElementsByClassName('quickAnswerContent')[0].parentNode.removeChild(document.getElementsByClassName('quickAnswerContent')[0]);
                this.insertAdjacentHTML('afterend', '<div class=\'quickAnswerContent\' ><textarea class=\"newQuickAnswer floatLeft\" col=\'4\', rows=\'5\'></textarea> <input value=\'Submit Answer\' type=\'button\' class=\'clear submitQuickAnswer button-md-thin text14 bkgdBlue whiteLink floatLeft\' />' +
                    '<input value=\'Cancel\' type=\'button\' class=\'cancelQuickAnswer clear button-md-thin button-white-textBlue\' /></div>');
                this.style.display = "none";
                animate.slideDown(document.getElementsByClassName('quickAnswerContent')[0]);
                document.getElementsByClassName("cancelQuickAnswer")[0].addEventListener("click", function (e) {
                    document.getElementsByClassName('quickAnswerContent')[0].style.display = "none";
                    document.getElementsByClassName('quickAnswerContent')[0].parentNode.removeChild(document.getElementsByClassName('quickAnswerContent')[0]);
                    document.getElementsByClassName('addQuickAnswer')[0].style.display = "block";
                });
                document.getElementsByClassName('submitQuickAnswer')[0].addEventListener('click', function (e) {
                    var quickAnswer = this.parentNode.getElementsByClassName('newQuickAnswer')[0].value;
                    var questionID = this.parentNode.parentNode.getElementsByClassName('questionID')[0].value;
                    var data = {
                        productID: prodID,
                        questionID: questionID,
                        quickAnswer: quickAnswer
                    };
                    document.getElementsByClassName('quickAnswSubmitMsg')[0].parentNode.removeChild(document.getElementsByClassName('quickAnswSubmitMsg')[0]);
                    ajaxActions.SubmitQuickAnswer(data);
                });
            });
        }
    };

    function setBkgdBorderAndNextImage(index) {
        var thumbs = [].slice.call(document.getElementsByClassName('thumbSelectImage'));
        thumbs.forEach(function (el, index, array) {
            el.classList.remove('borderDkGray');
            el.classList.add('borderMdGray');
        });
        if (index > 0) { // not first slide that doesn't have a thumbnail
            var newthumb = document.getElementById('thumbSelectImage_' + index);
            newthumb.classList.remove('borderMdGray');
            newthumb.classList.add('borderDkGray');
        }
        var nextSlide = index + 1;
        var lastSlide = mainImgSlider.slideCount;
        if (mainImgSlider.index == 0) {
            document.getElementById('thumbSelectImage_1').classList.remove('borderMdGray');
            document.getElementById('thumbSelectImage_1').classList.add('borderDkGray');
        } else if (mainImgSlider.index != lastSlide) {
            document.getElementById('thumbSelectImage_' + nextSlide).classList.remove('borderMdGray');
            document.getElementById('thumbSelectImage_' + nextSlide).classList.add('borderDkGray');
        }
    }

    var initAppear = function() {
        var options;
        var observer = new IntersectionObserver(callBack, options);

        /* once element is in view - do this */
        function callBack(entries, observer) {
            entries.forEach(function(entry){
                if(entry.intersectionRatio > 0){
                    if(entry.target === document.getElementById('relatedProductsContainer')){
                        ajaxActions.GetRelatedProducts();
                        observer.unobserve(document.getElementById('relatedProductsContainer'));
                    }
                    if(entry.target === document.getElementById('detailTabs')){
                        ajaxActions.GetDetailTabs();
                        observer.unobserve(document.getElementById('detailTabs'));
                    }
                    if(entry.target === document.getElementById('productCats')){
                        ajaxActions.GetItemCategories();
                        observer.unobserve(document.getElementById('productCats'));
                    }
                    if(entry.target === document.getElementById('tabProd')){
                        ajaxActions.GetTabbedScroller();
                        observer.unobserve(document.getElementById('tabProd'));
                    }
                    if(entry.target === document.getElementById('altitemslist')){
                        ajaxActions.GetAlternativeItemsList();
                        observer.unobserve(document.getElementById('altitemslist'));
                    }
                    if(entry.target === document.getElementById('altrelated')){
                        ajaxActions.GetAlternativeItems();
                        observer.unobserve(document.getElementById('altrelated'));
                    }
                }
            });
        }

        /* related product scroller */
        if(document.getElementById('relatedProductsContainer')){
            options = { root: document.getElementById('relatedProductsContainer'), threshold: 1.0 };
            observer.observe(document.getElementById('relatedProductsContainer'));
        }

        /* reviews, stories, photos... tabs */
        if(document.getElementById('detailTabs')){
            options = { root: document.getElementById('detailTabs'), threshold: 1.0 };
            observer.observe(document.getElementById('detailTabs'));
        }

        /* product categories */
        if(document.getElementById('productCats')){
            options = { root: document.getElementById('productCats'), threshold: 1.0 };
            observer.observe(document.getElementById('productCats'));
        }

        /* tabbed scroller */
        if(document.getElementById('tabProd')){
            options = { root: document.getElementById('tabProd'), threshold: 1.0 };
            observer.observe(document.getElementById('tabProd'));
        }

        /* alternate items list */
        if (document.getElementById('altitemslist')) {
            options = { root: document.getElementById('altitemslist'), threshold: 1.0 };
            observer.observe(document.getElementById('altitemslist'));
        }

        /* alternate items */
        if (document.getElementById('altrelated')) {
            options = { root: document.getElementById('altrelated'), threshold: 1.0 };
            observer.observe(document.getElementById('altrelated'));
        }
    };

    var threeSixtyView = function () {
        if (document.getElementById("hyp360View")) {
            var threeSixtyBtns = document.querySelectorAll(".hyp360View"),
                threeSixtyDialogContent = document.getElementsByClassName("three60View")[0],
                threeSixtyImage = document.getElementById('hyp360ViewZOOM'),
                get360Class = function () {
                    var boxWidth = document.querySelector('.flyoutImg').naturalWidth;
                    var boxHeight = document.querySelector('.flyoutImg').naturalHeight;
                    threeSixtyDialogContent.classList.remove('landscape');
                    threeSixtyDialogContent.classList.remove('portrait');
                    if (boxWidth > boxHeight) {
                        threeSixtyDialogContent.classList.add('landscape');
                    } else {
                        threeSixtyDialogContent.classList.add('portrait');
                    }
                    //add in the actual height/width of the image to the image tag
                    document.querySelector(".flyoutImg").height = boxHeight;
                    document.querySelector(".flyoutImg").width = boxWidth;
                },
                get360Map = function () {
                    var mapPos = [];
                    if (mapPos.length == 0) {
                        try {
                            var backgroundPositions = threeSixtyImage.style.backgroundPosition;
                            var backgroundImages = threeSixtyImage.style.backgroundImage;
                            var positions = backgroundPositions.split(',');
                            var images = backgroundImages.split(',');
                            var imagePattern = /\/[0-9][0-9].jpg/;
                            for (var i = 0; i < positions.length; i++) {
                                var matches = imagePattern.exec(images[i]);
                                mapPos.push(+matches[0].substring(1, 3) - 1);
                            }
                        } catch (e) { }
                    }
                    return mapPos;
                },
                determine360Position = function () {
                    try {
                        var backgroundPositions = threeSixtyImage.style.backgroundPosition;
                        var positions = backgroundPositions.split(',');
                        for (var i = 0; i < positions.length; i++) {
                            if (positions[i].trim() == '0px 0px') {
                                return get360Map()[i];
                            }
                        }
                    } catch (e) { }
                },
                set360Position = function (position) {
                    try {
                        var backgroundPositions = threeSixtyImage.style.backgroundPosition;
                        var positions = backgroundPositions.split(',');
                        var pos = (position + positions.length) % positions.length;
                        var bgPositions = [];
                        for (var i = 0; i < positions.length; i++) {
                            if (get360Map()[i] == pos) {
                                bgPositions.push('0px 0px');
                            } else {
                                bgPositions.push('0px -10000px');
                            }
                        }
                        threeSixtyImage.style.backgroundPosition = bgPositions.join(', ');
                    } catch (e) { }
                };

            threeSixtyDialog.init(document.getElementById("PD_360Flyout"));

            var focusBack;
            for(var i = 0; i < threeSixtyBtns.length; i++){
                threeSixtyBtns[i].addEventListener("click", function (e) {
                    e.preventDefault();
                    focusBack = this;
                    this.setAttribute("aria-expanded", "true");
                    get360Class();
                    threeSixtyDialog.open();

                    document.getElementById("PD_360Flyout").addEventListener("keydown", function(e){
                        if(e.which == 27){ //escape
                            focusBack.setAttribute("aria-expanded", "false");
                            focusBack.focus();
                            document.getElementById("PD_360Flyout").removeEventListener("keydown", [0]);
                        }
                    });
                });
            }
            document.getElementById("spanItemRight").addEventListener("click", function (e) {
                e.preventDefault();
                var pos = determine360Position();
                set360Position(pos + 1);
                if(document.getElementById("threeSixtyLive")) {
                	document.getElementById("threeSixtyLive").textContent = "";
                	document.getElementById("threeSixtyLive").textContent = "360 Image spun to the right";
            	  }
            });
            document.getElementById("spanItemRight").addEventListener("keyup", function (e) {
                if(e.which == 13){//enter
                    this.click();
                }
            });
            document.getElementById("spanItemLeft").addEventListener("click", function (e) {
                e.preventDefault();
                var pos = determine360Position();
                set360Position(pos - 1);
                if(document.getElementById("threeSixtyLive")) {
                	document.getElementById("threeSixtyLive").textContent = "";
                	document.getElementById("threeSixtyLive").textContent = "360 Image spun to the left";
                }
            });
            document.getElementById("spanItemLeft").addEventListener("keyup", function (e) {
                if(e.which == 13){//enter
                    this.click();
                }
            });
            document.getElementById("PD_360Flyout").getElementsByClassName("close4iDialog")[0].addEventListener("click", function () {
                if(document.getElementById("threeSixtyLive")) document.getElementById("threeSixtyLive").textContent = "";
                focusBack.focus();
                focusBack.setAttribute("aria-expanded", "false");
            });
        }
    }; // end 360 view

    // 360 guarantee
    var initGuaranteeDialog = function () {
        if (document.getElementById('div360dialog')) {
            guaranteeDialog.init(document.getElementById('div360dialog'), document.getElementsByClassName('the360link'));
           
            if (document.getElementsByClassName("the360link").length > 0) {
                document.getElementsByClassName("the360link")[0].addEventListener("click", function (e) {
                    e.preventDefault();
                    lazyloadImages.update();
                });
            }
        }
    };

    var initArtDialog = function () {
        // How to send my artwork
        if (document.getElementById('divArtInstdialog')) {
            artInstDialog.init(document.getElementById('divArtInstdialog'), document.getElementsByClassName('artInstLink'));
            
            if (document.getElementsByClassName("artInstLink").length > 0) {
                document.getElementsByClassName("artInstLink")[0].addEventListener("click", function (e) {
                    e.preventDefault();
                    lazyloadImages.update();
                });
            }
        }
    };

    function goToNextStep(e) {
        if (e.type == 'keyup' && (e.keyCode != 13)) return;
        if (document.querySelectorAll('.errorMsgPanel')[0]) {
            var errorMsgs = [].slice.call(document.querySelectorAll('.errorMsgPanel'));
            errorMsgs.forEach(function (el, index, array) {
                if (el.parentNode) {
                    el.parentNode.removeChild(el);
                }
            });
        }
        var colorSelected = document.getElementById('colorSelected').value;
        var selectedColorID = selBaseTrim.value;
        var qty = GetQty();
        var previousQty = qty;
        var priceEach = "";
        if(document.getElementById("lblPrice")){
            if(document.querySelector(".glidePanel")){ //glide
                priceEach = document.getElementById("lblPrice").value;
            }else{ //apparel
                priceEach = document.getElementById("lblPrice").innerHTML;
            }
        }
        var grandTotal = document.getElementById('lblTotal') ? document.getElementById('lblTotal').innerHTML : "";
        
        if (this.classList.contains('step1')) {
            
            if (isApparelItem && document.getElementById('SizingGrid').innerHTML.length > 0) {
                CalcPrice();
            }
            if (selectedColorID == undefined || selectedColorID == "") {
                if (recolorAvailable.value == 'True') {
                    document.querySelector('#productColorScroller').insertAdjacentHTML('beforebegin', errorMessageBox);
                    document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<button id="colorScrollerError" class="btnToHyp text16 underline textLeft">Please select a product ' + localizedJS.Color + '.</button>';
                    document.getElementById("colorScrollerError").focus();
                    document.getElementById("colorScrollerError").addEventListener("click", function(e){
                        e.preventDefault();
                        document.getElementById('productColorScroller').querySelectorAll('.imgBox')[0].focus();
                    });
                } else {
                    document.querySelector('.PD_ColorList').insertAdjacentHTML('beforebegin', errorMessageBox);
                    document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<button id="colorListError" class="btnToHyp text16 underline textLeft">Please select a product ' + localizedJS.Color + '.</button>';
                    document.getElementById("colorListError").focus();
                    document.getElementById("colorListError").addEventListener("click", function(e){
                        e.preventDefault();
                        document.getElementById('listView').querySelectorAll('.selectedImgDesc')[0].focus();
                    });
                }
                return false;
            }

            var quantityErrorHtml = '<div id="ErrorBox" class="qtyErrorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>' +
                '<ul id="ErrorMsgBox"><li><button id="quantityError" class="btnToHyp text16 underline textLeft">Minimum quantity for this item is ' + lowestQty + '.</button></li></ul></div>';

            if (qty == isNaN || qty == undefined || qty == '0' || !IsNumeric(qty)) {
                if (document.querySelector(".qtyErrorMsg")) document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));

                if (isApparelItem && document.getElementById('PD_SizeGrid')) {
                    document.getElementById('PD_SizeGrid').insertAdjacentHTML('beforebegin', quantityErrorHtml);
                    
                    var allQtyInputs = document.getElementsByClassName("txtApparelQty");
                    for (var x = 0; x < allQtyInputs.length; x++) {
                        allQtyInputs[x].classList.add("input-validation-error");
                        allQtyInputs[x].setAttribute('aria-invalid', 'true');
                    }
                    document.getElementById("quantityError").focus();
                    document.getElementById("quantityError").addEventListener("click", function(e){
                        e.preventDefault();
                        allQtyInputs[0].focus();
                    });

                } else if (document.querySelector('.glidePanel')) {
                    document.querySelector('.glidePanel').insertAdjacentHTML('beforebegin', quantityErrorHtml);
                    document.getElementById('txtQty').classList.add("input-validation-error");
                    document.getElementById('txtQty').setAttribute('aria-invalid', 'true');
                    document.getElementById("quantityError").focus();
                    document.getElementById("quantityError").addEventListener("click", function(e){
                        e.preventDefault();
                        document.getElementById('txtQty').focus();
                    });
                }

                return false;
            }
            if (qty < lowestQty) {
                if (document.querySelector(".qtyErrorMsg")) document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));
                
                if (isApparelItem) {
                    document.getElementById('PD_SizeGrid').insertAdjacentHTML('beforebegin', quantityErrorHtml);
                    var apparelInputs = document.getElementsByClassName("txtApparelQty");
                    for (var y = 0; y < apparelInputs.length; y++) {
                        if (apparelInputs[y].value != '') {
                            apparelInputs[y].classList.add("input-validation-error");
                            apparelInputs[y].setAttribute('aria-invalid', 'true');
                            document.getElementById("quantityError").focus();
                            document.getElementById("quantityError").addEventListener("click", function(e){
                                e.preventDefault();
                                apparelInputs[0].focus();
                            });
                        }
                    }
                } else {
                    document.querySelector('.glidePanel').insertAdjacentHTML('afterend', quantityErrorHtml);
                    document.getElementById('txtQty').classList.add("input-validation-error");
                    document.getElementById('txtQty').setAttribute('aria-invalid', 'true');
                    document.getElementById("quantityError").focus();
                    document.getElementById("quantityError").addEventListener("click", function(e){
                        e.preventDefault();
                        document.getElementById('txtQty').focus();
                    });
                }
                return false;
            }
            if (qty >= lowestQty && selectedColorID != "") {
                if (document.querySelector(".qtyErrorMsg")) document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));
                document.getElementById('txtQty').classList.remove('input-validation-error');
                document.getElementById('txtQty').removeAttribute('aria-invalid');
                animate.fadeOut(document.querySelectorAll(".PD_Step_1")[0], 200);
                animate.fadeOut(document.querySelectorAll(".PD_Step_1")[1], 200);
                setTimeout(function () { // give fade out time to do its thing before fading in
                    animate.fadeIn(document.querySelector(".PD_Step_2"), 200);
                }, 200);
                setTimeout(function () { // once step 2 is visible
                    if (document.getElementsByClassName('ErrorMsgPanel')[0]) {
                        document.getElementsByClassName('ErrorMsgPanel')[0].parentNode.removeChild(document.getElementsByClassName('ErrorMsgPanel')[0]);
                    }
                    var selectedProdColor = "";
                    if (document.getElementsByClassName("oneColorOption")[0]) {
                        selectedProdColor = document.getElementsByClassName("oneColorOption")[0].innerHTML;
                    } else {
                        selectedProdColor = document.getElementById("selColors").innerHTML;
                    }
                    document.getElementsByClassName("prodColor")[0].innerHTML = selectedProdColor.trim() != "" ? selectedProdColor : document.getElementsByClassName("baseColorName")[0].value;
                    if (isGFeed) {
                        CheckQueryString();
                        var gFeedSummary = '<div class="GFeedPanel1 c-md-12">';
                        gFeedSummary += document.getElementById('GFeedPanel').innerHTML + '</div>';
                        document.getElementById('GFeedPanel').innerHTML = '';
                        document.getElementById("PD_OptionalExtra").insertAdjacentHTML("afterend", gFeedSummary);
                        tooltips.init(); //gfeed tooltip
                    }
                    if (document.getElementsByClassName("imprintConfiguration")[0] && parseInt(document.getElementById("BaseExtra").value) != 0 && prevQty != qty) {
                        prevQty = GetQty();
                        ajaxActions.GetExtrasAmount(true);
                    }
                    document.getElementsByClassName("quantitySummary")[0].innerHTML = GetQty();
                    getAttributes();
                    step2ScrollBehavior(document, false);
                }, 200);
            }
        } else if (this.classList.contains('goToStep1')) {
            if (document.getElementById('GFeedPanel')) {
                document.getElementById('GFeedPanel').classList.add("hide");
                document.getElementById('GFeedPanel').style.display = "block";
                document.querySelector('.GFeedPanel1').parentNode.removeChild(document.querySelector('.GFeedPanel1'));
            }
            animate.fadeOut(document.querySelector(".PD_Step_2"), 200);
            setTimeout(function () { // give fade out time to do its thing before fading in
                animate.fadeIn(document.querySelectorAll(".PD_Step_1")[0], 200);
                animate.fadeIn(document.querySelectorAll(".PD_Step_1")[1], 200);
            }, 200);
            setTimeout(function () { // once step 1 is visible
                if (!isApparelItem) {
                    document.getElementById("litGlideTotal").classList.remove("hide");
                    document.getElementById("lblQuantityTxtCaption").classList.remove("hide");
                    document.getElementsByClassName("glide")[0].lastElementChild.classList.remove("hide"); //unit price
                    sliderGlide.UpdateToolTip(); // added to update the tooltip position espeically with restricted pricing items
                }
                if (document.getElementById("pricingarea")) {
                    document.getElementById("pricingarea").classList.remove("hide");
                }
                var selectedProdColor = "";
                if (document.getElementsByClassName("oneColorOption")[0]) {
                    selectedProdColor = document.getElementsByClassName("oneColorOption")[0].innerHTML;
                } else {
                    selectedProdColor = document.getElementById("selColors").innerHTML;
                }
                document.getElementsByClassName("prodColor")[0].innerHTML = selectedProdColor.trim() != "" ? selectedProdColor : document.getElementsByClassName("baseColorName")[0].value;
                document.getElementsByClassName("quantitySummary")[0].innerHTML = GetQty();

                document.getElementsByClassName('PD_Step_1')[0].scrollIntoView({
                    behavior: "smooth"
                });
                if (document.getElementById("jumpToColor")) {
                    document.getElementById("jumpToColor").focus();
                } else if (document.querySelector('.PD_Step_1').getElementsByTagName('a')[0]) {
                    document.querySelector('.PD_Step_1').getElementsByTagName('a')[0].focus();
                } else {
                    document.querySelector('.PD_Step_1').getElementsByTagName('button')[0].focus();
                }
            }, 200);
            e.preventDefault();
        }
    }

    var step2ScrollBehavior = function (selector, scrollBehavior) {
        if (!isMobile && !bypassImpConfig) {
            if (scrollBehavior) {
                document.getElementsByClassName('PD_Step_2')[0].scrollIntoView({
                    behavior: "smooth"
                });
            }
            if (selector.getElementsByClassName("selImprintLocation")[0] && !selector.getElementsByClassName("selImprintLocation")[0].disabled) {
                selector.getElementsByClassName("selImprintLocation")[0].focus();
            } else if (selector.getElementsByClassName("prodColorOptions")[0] && !selector.getElementsByClassName("prodColorOptions")[0].classList.contains("disabledColorSelect")) {
                selector.getElementsByClassName("prodColorOptions")[0].focus();
            } else {
                document.getElementsByClassName("btnAddToCart")[0].focus();
            }
        }
    };

    var initProp65 = function () {
        if (document.getElementById('prop65dialog')) {
            prop65Dialog.init(document.getElementById('prop65dialog'), document.getElementsByClassName('prop65'), document.getElementById('btnProp65OK'));
            document.getElementsByClassName('prop65')[0].addEventListener('click', ajaxActions.GetPropSixtyFive);
        }
    };

    var setUpHashOptions = function () {
        switch (window.location.hash) {
            case '#reviews':
                setTimeout(function () {
                    document.querySelector("#detailTabs").scrollIntoView();
                    //document.getElementById('reviewsTS').click(); //TODO click once appear() is finished
                }, 1200);
                break;
            case '#stories':
                setTimeout(function () {
                    document.querySelector("#detailTabs").scrollIntoView();
                    //document.getElementById('successStoriesTS').click(); //TODO click once appear() is finished
                }, 1200);
                break;
            case '#fit':
                setTimeout(function () {
                    document.querySelector("#detailTabs").scrollIntoView();
                    //document.getElementById('fitRatingTS').click(); //TODO click once appear() is finished
                }, 1200);
                break;
            case '#questions':
                setTimeout(function () {
                    document.querySelector("#detailTabs").scrollIntoView();
                    //document.getElementById('QATS').click(); //TODO click once appear() is finished
                }, 1200);
                break;
            default:
                break;
        }
        if (document.getElementById('InfoType').length > 0) {
            var InfoType = document.getElementById('InfoType').value;
            switch (InfoType) {
                case '1':
                    setTimeout(function () {
                        document.querySelector("#detailTabs").scrollIntoView();
                        //document.getElementById('reviewsTS').click(); //TODO click once appear() is finished
                    }, 1200);
                    break;
                case '2':
                    setTimeout(function () {
                        document.querySelector("#detailTabs").scrollIntoView();
                        //document.getElementById('successStoriesTS').click(); //TODO click once appear() is finished
                    }, 1200);
                    break;
                case '3':
                    setTimeout(function () {
                        document.querySelector("#detailTabs").scrollIntoView();
                        //document.getElementById('fitRatingTS').click(); //TODO click once appear() is finished
                    }, 1200);
                    break;
                case '4':
                    setTimeout(function () {
                        document.querySelector("#detailTabs").scrollIntoView();
                        //document.getElementById('QATS').click(); //TODO click once appear() is finished
                    }, 1200);
                    break;
            }
        }
    };

    var clearGFeedPanel = function () {
        if (document.getElementById('GFeedData')) {
            document.getElementById('GFeedData').style.display = 'none';
        }
    };

    var setUpColorDropDownEventListeners = function () {
        var colorSections = [].slice.call(document.getElementsByClassName("imprint-color-section"));
        colorSections.forEach(function (el) {
            if (el.querySelector(".input_active")) {
                el.querySelector(".input_active").addEventListener("mousedown", function () {
                    bindColorDropDownActiveInput(event, el);
                });
            }
            if (el.querySelector(".prodColorOptions") && el.querySelector(".prodColorOptions").querySelectorAll(".spnColorChip")) {
                var selectColorOptions = [].slice.call(el.querySelector(".prodColorOptions").querySelectorAll(".spnColorChip"));
                selectColorOptions.forEach(function (elem) {
                    elem.addEventListener("mousedown", function () {
                        bindColorDropDown(event, el, elem);
                        event.preventDefault();
                        SaveImprintColor(elem);
                    });
                });
            }
            if (el.querySelector(".prodColorOptions").querySelector(".colorOptions").classList.contains("closedDropDown")) {
                el.querySelector(".prodColorOptions").addEventListener('keydown', function (e) {
                    if ((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) {
                        bindColorDropDownActiveInput(event, el); // opens color dropdown on enter 
                    }
                });
            }
        });
        var selectColorOptions = [].slice.call(document.querySelectorAll(".prodColorOptions"));
        selectColorOptions.forEach(function (el) {
            el.addEventListener('keydown', function (e) {
                if ((e.which && e.which == 27) || (e.keyCode && e.keyCode == 27)) {
                    bindColorDropDownBlur(e, el);
                }
            });
        });
        document.getElementsByTagName("body")[0].addEventListener("click", function (e) {
            var selectColorOptions = [].slice.call(document.querySelectorAll(".prodColorOptions"));
            selectColorOptions.forEach(function (el) {
                if (!el.contains(e.target) && el.querySelector(".colorOptions") && el.querySelector(".colorOptions").classList.contains("openDropDown")) {
                    bindColorDropDownBlur(e, el);
                }
            });
        });
    };

    var setUpImprintConfigEventListeners = function () {
        var addImpColor = [].slice.call(document.getElementsByClassName("addImpColor"));
        addImpColor.forEach(function (el) {
            el.removeEventListener("click", bindAddImpColor);
            el.addEventListener("click", bindAddImpColor);
        });
        var delImpConfigSections = [].slice.call(document.getElementsByClassName("delImpConfigSection"));
        delImpConfigSections.forEach(function (el) {
            el.removeEventListener("click", bindDelImpConfigSection);
            el.addEventListener("click", bindDelImpConfigSection);
        });
        var addimpLocations = [].slice.call(document.getElementsByClassName("addImpLocation"));
        addimpLocations.forEach(function (el) {
            el.removeEventListener("click", bindAddImpLocations);
            el.addEventListener("click", bindAddImpLocations);
        });
        var impLocs = [].slice.call(document.getElementsByClassName("selImprintLocation"));
        impLocs.forEach(function (el) {
            el.removeEventListener("change", bindImpLocDropDowns);
            el.addEventListener("change", bindImpLocDropDowns);
        });
        var clearColor = [].slice.call(document.getElementsByClassName("imprintClearColor"));
        clearColor.forEach(function (el) {
            el.removeEventListener("click", bindClearImprintColor);
            el.addEventListener("click", bindClearImprintColor);
        });
    };

    var colorSelectorKeyboardFunctions = function () { // keyboard accessibility for custom color "dropdown"
        var colorDropDownLabels = [].slice.call(document.querySelectorAll(".impColorSelectLabel"));
        colorDropDownLabels.forEach(function (el) {
            el.addEventListener('click', function (e) {
                el.nextElementSibling.firstElementChild.focus();
            });
        });
        var activeInputFields = [].slice.call(document.querySelectorAll(".prodColorOptions"));
        activeInputFields.forEach(function (el, index) {
            el.addEventListener('keydown', function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (((e.which && e.which == 40) || (e.keyCode && e.keyCode == 40)) && el.querySelector(".input_active").nextElementSibling) {
                    if (!el.querySelector(".input_active").nextElementSibling.firstElementChild.classList.contains("hide")) {
                        if (el.querySelector(".input_active").querySelector(".input_placeholder")) {
                            el.querySelector(".input_active").nextElementSibling.firstElementChild.firstElementChild.focus();
                            el.querySelector(".input_active").nextElementSibling.firstElementChild.firstElementChild.classList.add("mimicHover");
                        } else {
                            var colorID = el.querySelector(".input_active").querySelector(".colorOptionId").innerHTML.trim()
                            el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).firstElementChild.classList.remove("mimicHover");
                            el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).nextElementSibling.firstElementChild.focus();
                            el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).nextElementSibling.firstElementChild.classList.add("mimicHover");
                        }
                    } else {
                        var currentIndex = 10000;
                        for (var i = 0; i < el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer").length; i++) {
                            if (el.querySelector(".input_active").querySelector(".input_placeholder")) {
                                if (el.querySelector(".input_active").nextElementSibling.firstElementChild == el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i]) {
                                    currentIndex = i;
                                }
                                if (i >= currentIndex && !el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i].classList.contains("hide")) {
                                    el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i].firstElementChild.focus();
                                    el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i].firstElementChild.classList.add("mimicHover");
                                    currentIndex = 10000;
                                }
                            } else {
                                colorID = el.querySelector(".input_active").querySelector(".colorOptionId").innerHTML.trim()
                                if (el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID) == el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i]) {
                                    currentIndex = i;
                                }
                                if (i >= currentIndex && !el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i].classList.contains("hide")) {
                                    el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i].firstElementChild.focus();
                                    el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i].firstElementChild.classList.add("mimicHover");
                                    currentIndex = 10000;
                                }
                            }
                        }
                    }
                }
                if (((e.which && e.which == 38) || (e.keyCode && e.keyCode == 38)) && el.querySelector(".input_active").querySelector(".colorOptionId")) {
                    var colorID = el.querySelector(".input_active").querySelector(".colorOptionId").innerHTML.trim();
                    if (!el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).classList.contains("hide")) {
                        el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).firstElementChild.classList.remove("mimicHover");
                        el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).previousElementSibling.firstElementChild.focus();
                        el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).previousElementSibling.firstElementChild.classList.add("mimicHover");
                    } else {
                        var currentIndex = 10000;
                        for (var i = 0; i < el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer").length; i++) {
                            if (el.parentNode.previousElementSibling == el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i]) {
                                currentIndex = i;
                            }
                            if (i >= currentIndex && !el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i].previousElementSibling.classList.contains("hide")) {
                                el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i].previousElementSibling.firstElementChild.focus();
                                el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i].previousElementSibling.firstElementChild.classList.add("mimicHover");
                                currentIndex = 10000;
                            }
                        }
                    }
                }
                if (((e.which && e.which == 9) || (e.keyCode && e.keyCode == 9)) && !e.shiftKey) {
                    if (!el.nextElementSibling.classList.contains("hide")) {
                        el.nextElementSibling.focus();
                    } else if (el.nextElementSibling.classList.contains("hide")) {
                        if (!el.parentNode.parentNode.parentNode.parentNode.querySelector(".addImpColor").classList.contains("hide")) {
                            el.parentNode.parentNode.parentNode.parentNode.querySelector(".addImpColor").focus();
                        } else if (!document.getElementsByClassName("addImpLocation")[0].classList.contains("hide")) {
                            document.getElementsByClassName("addImpLocation")[0].focus();
                        } else if (document.getElementById("NibOptions") && !document.getElementById("NibOptions").disabled) {
                            document.getElementById("NibOptions").focus();
                        } else if (document.getElementById("inkColorOptions") && !document.getElementById("inkColorOptions").disabled) {
                            document.getElementById("inkColorOptions").focus();
                        } else if (document.getElementById("adhOptions") && !document.getElementById("adhOptions").disabled) {
                            document.getElementById("adhOptions").focus();
                        } else if (document.getElementById("adhSideOptions") && !document.getElementById("adhSideOptions").disabled) {
                            document.getElementById("adhSideOptions").focus();
                        } else {
                            document.getElementsByClassName("btnAddToCart")[0].focus();
                        }
                    }

                } else if (((e.which && e.which == 9) || (e.keyCode && e.keyCode == 9)) && e.shiftKey) {
                    if (el.parentNode.parentNode.parentNode.previousElementSibling.previousElementSibling.classList.contains("imprint-color-section") && document.getElementsByClassName("imprintClearColor")[index - 1] && !document.getElementsByClassName("imprintClearColor")[index - 1].parentNode.parentNode.parentNode.classList.contains("hide")) {
                        document.getElementsByClassName("imprintClearColor")[index - 1].focus();
                    } else if (el.parentNode.parentNode.parentNode.parentNode.querySelector(".selImprintLocation").disabled == false) {
                        el.parentNode.parentNode.parentNode.parentNode.querySelector(".selImprintLocation").focus();
                    } else if (!el.parentNode.parentNode.parentNode.parentNode.querySelector(".delImpConfigSection").parentNode.classList.contains("hide") && el.parentNode.parentNode.parentNode.parentNode.querySelector(".delImpConfigSection")) {
                        el.parentNode.parentNode.parentNode.parentNode.querySelector(".delImpConfigSection").focus();
                    } else {
                        document.getElementsByClassName("goToStep1")[0].focus();
                    }
                }
            });
        });
        var impColorBtns = [].slice.call(document.querySelectorAll(".spnColorChip"));
        impColorBtns.forEach(function (el) {
            el.addEventListener('keydown', function (e) {
                e.preventDefault();
                e.stopPropagation();
                if ((e.which && e.which == 27) || (e.keyCode && e.keyCode == 27)) {
                    bindColorDropDownBlur(event, el.parentNode.parentNode.parentNode);
                    el.parentNode.parentNode.parentNode.focus();
                }
                if (((e.which && e.which == 38) || (e.keyCode && e.keyCode == 38)) && el.parentNode.previousElementSibling) {
                    el.classList.remove("mimicHover");
                    if (!el.parentNode.previousElementSibling.classList.contains("hide")) {
                        el.parentNode.previousElementSibling.firstElementChild.focus();
                        el.parentNode.previousElementSibling.firstElementChild.classList.add("mimicHover");
                    } else {
                        var currentIndex = 10000;
                        for (var i = 0; i < el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer").length; i++) {
                            if (el.parentNode.previousElementSibling == el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i]) {
                                currentIndex = i;
                            }
                            if (i >= currentIndex && el.parentNode.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i].previousElementSibling && !el.parentNode.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i].previousElementSibling.classList.contains("hide")) {
                                el.parentNode.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i].previousElementSibling.firstElementChild.focus();
                                el.parentNode.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i].previousElementSibling.firstElementChild.classList.add("mimicHover");
                                currentIndex = 10000;
                            }
                        }
                    }
                }
                if (((e.which && e.which == 40) || (e.keyCode && e.keyCode == 40)) && el.parentNode.nextElementSibling) {
                    el.classList.remove("mimicHover");
                    if (!el.parentNode.nextElementSibling.classList.contains("hide")) {
                        el.parentNode.nextElementSibling.firstElementChild.focus();
                        el.parentNode.nextElementSibling.firstElementChild.classList.add("mimicHover");
                    } else {
                        var currentIndex = 10000;
                        for (var i = 0; i < el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer").length; i++) {
                            if (el.parentNode.nextElementSibling == el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i]) {
                                currentIndex = i;
                            }
                            if (i >= currentIndex && !el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i].classList.contains("hide")) {
                                el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i].firstElementChild.focus();
                                el.parentNode.parentNode.querySelectorAll(".colorOptionsContainer")[i].firstElementChild.classList.add("mimicHover");
                                currentIndex = 10000;
                            }
                        }
                    }
                }
                if (((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) && el.parentNode.parentNode.parentNode.querySelector(".colorOptions").classList.contains("openDropDown")) {
                    bindColorDropDown(event, el.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode, el);
                    SaveImprintColor(el);
                    el.parentNode.parentNode.parentNode.focus();
                    el.parentNode.parentNode.parentNode.setAttribute("aria-expanded", "false");
                }
            });
        });
    };

    var bindAddImpLocations = function (e) {
        clearGFeedPanel();
        e.preventDefault();
        forms.ClearValidation();
        if (document.getElementsByClassName('ErrorMsgPanel')[0]) {
            document.getElementsByClassName('ErrorMsgPanel')[0].parentNode.removeChild(document.getElementsByClassName('ErrorMsgPanel')[0]);
        }
        var nextColorSection = e.target.parentNode.parentNode.querySelector('.imprint-color-section.hide');
        var numColorSections = e.target.parentNode.parentNode.querySelectorAll(".imprint-color-section").length - e.target.parentNode.parentNode.querySelectorAll('.imprint-color-section.hide').length;
        var currentColorSection = e.target.parentNode.parentNode.getElementsByClassName("imprint-color-section")[numColorSections - 1];
        if (currentColorSection != undefined) {
            var titleText = "Please select a product imprint " + localizedJS.Color + " for the " + getLocationCountText(document.getElementsByClassName("imprintConfiguration").length - 1).toLowerCase() + " location.";
            currentColorSection.querySelector(".prodColorOptions").setAttribute("title", titleText);
            currentColorSection.querySelector(".input_active").setAttribute("title", titleText);
        }
        if (currentColorSection != null && currentColorSection.querySelector(".input_active").querySelector(".input_placeholder")) {
            document.querySelector('.formHeading').insertAdjacentHTML('afterend', errorMessageBox);
            var elemToValidate = currentColorSection.querySelector(".txtReq");
            document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<a href="#' + elemToValidate.id + '" tabindex="0" class="errorItem">' + elemToValidate.getAttribute("title") + '</a>';
            document.querySelector(".errorItem").focus();
            currentColorSection.querySelector(".txtReq").classList.add("input-validation-error");
            currentColorSection.querySelector(".txtReq").setAttribute("aria-invalid", "true");
            currentColorSection.querySelector(".txtReq").parentNode.querySelector(".errorMessage").classList.remove("hide");
            currentColorSection.querySelector(".txtReq").parentNode.querySelector(".errorMessage").innerHTML = currentColorSection.querySelector(".txtReq").getAttribute("title");
        } else {
            GetSelectedImprintLocations();
            e.target.classList.add("hide");
            ajaxActions.GetAddlImpConfigPage(listImprintLocationIDs);
        }
    };

    var bindColorDropDownActiveInput = function (e, selector) {
        selector.querySelector(".colorOptions").classList.remove("hide");
        selector.querySelector(".colorOptions").setAttribute("aria-hidden", "false");
        var newHeight = (parseInt(selector.getElementsByClassName("prodColorOptions")[0].querySelectorAll('.spnColorChip').length) + 1) * 26;
        selector.querySelector(".colorOptions").style.height = newHeight < 200 ? newHeight + "px" : "200px";
        selector.querySelector(".colorOptions").style.overflowY = "scroll";
        selector.querySelector(".colorOptions").style.overflowX = "hidden";
        selector.querySelector(".colorOptions").style.display = "block";
        selector.querySelector(".colorOptions").style.paddingBottom = "3px";
        selector.querySelector(".colorOptions").classList.add("openDropDown");
        selector.querySelector(".prodColorOptions").setAttribute("aria-expanded", "true");
        selector.querySelector(".colorOptions").classList.remove("closedDropDown");
        if (selector.querySelector(".imprintClearColor")) {
            selector.querySelector(".imprintClearColor").classList.add("hide");
        }
        if (selector.querySelector(".input_active").querySelector(".colorOptionId")) { // moves selected dropdown option to first in visual field 
            var colorID = selector.querySelector(".input_active").querySelector(".colorOptionId").innerHTML;
            selector.querySelector(".colorOptions").querySelector(".colorId_" + colorID).firstElementChild.classList.add("mimicHover");
            var topPos = selector.querySelector(".colorOptions").querySelector(".colorId_" + colorID).firstElementChild.offsetTop;
            selector.querySelector(".colorOptions").scrollTop = topPos - 40;
        }
        colorSelectorKeyboardFunctions();
    };

    var bindDelImpConfigSection = function (e) {
        var el = e.target;
        forms.ClearValidation();
        var selectedOption = el.parentNode.parentNode.getElementsByClassName("selImprintLocation")[0][el.parentNode.parentNode.getElementsByClassName("selImprintLocation")[0].selectedIndex];
        el.parentNode.parentNode.parentNode.removeChild(el.parentNode.parentNode);
        var impConfigSections = document.getElementsByClassName("imprintConfiguration");
        var numSections = impConfigSections.length;
        impConfigSections[numSections - 1].getElementsByClassName("addImpLocation")[0].classList.remove("hide");
        impConfigSections[numSections - 1].getElementsByClassName("addImpLocation")[0].focus();
        for (i = 0; i < numSections; i++) {
            var selectBox = impConfigSections[i].getElementsByClassName("selImprintLocation")[0];
            if (i != 0) {
                var impLocCounts = [].slice.call(impConfigSections[i].getElementsByClassName("impLocCount"));
                impLocCounts.forEach(function (el, index, array) {
                    el.innerHTML = getLocationCountText(i);
                });
                if (numSections - 1 >= 1) {
                    impConfigSections[numSections - 1].getElementsByClassName("impLocationCountHeader")[0].classList.remove("hide");
                }
                setLocationCounts();
                var selectedIndex = selectBox.selectedIndex;
                var optionExists = false;
                for (var j = 0; j < selectBox.length; j++) {
                    if (selectBox.options[j].value === selectedOption.value) {
                        optionExists = true;
                    }
                }
                if (!optionExists) {
                    var option = document.createElement("option");
                    option.text = selectedOption.text;
                    option.value = selectedOption.value;
                    selectBox.add(option);
                    selectBox.selectedIndex = selectedIndex;
                    if (selectBox.disabled && selectBox.options.length > 1) {
                        selectBox.removeAttribute("disabled");
                    }
                }
            }
        }
        if (listSelectedColors.length > 0 || document.getElementsByClassName("imprint-color-section").length == 0) {
            ajaxActions.GetExtrasAmount(); // add to the total
        }
    };

    var bindColorDropDownBlur = function (e, el) {
        e.preventDefault();
        e.stopPropagation();
        el.setAttribute("aria-expanded", "false");
        if (el.parentNode.querySelector(".imprintClearColor") && (!el.querySelector(".input_placeholder") || el.querySelector(".input_placeholder").innerHTML.indexOf("Additional") != -1)) {
            el.parentNode.querySelector(".imprintClearColor").classList.remove("hide");
        }
        if (el.querySelector(".colorOptions")) {
            el.querySelector(".colorOptions").classList.add("hide");
            el.querySelector(".colorOptions").removeAttribute("style");
            el.querySelector(".colorOptions").setAttribute("aria-hidden", "true");
            el.querySelector(".colorOptions").classList.remove("openDropDown");
            el.querySelector(".colorOptions").classList.add("closedDropDown");
        }
        var colorOptionContainers = [].slice.call(el.querySelectorAll(".spnColorChip"));
        colorOptionContainers.forEach(function (el) {
            el.removeAttribute("style");
            el.classList.remove("mimicHover");
        });
    };

    var bindColorDropDown = function (e, selector, el) {
        var imprintSection = selector.querySelector(".prodColorOptions").parentNode.parentNode.parentNode.parentNode;
        var previouslySelectedColor = selector.getElementsByClassName("input_active")[0];
        var colorOptionId = 0;
        if (selector.getElementsByClassName("input_active")[0].getElementsByClassName("colorOptionId")[0]) {
            colorOptionId = selector.getElementsByClassName("input_active")[0].getElementsByClassName("colorOptionId")[0].innerHTML;
        }
        if ((selector.getElementsByClassName("input_placeholder")[0]) ||
            selector.getElementsByClassName("input_active")[0].querySelector('.colorOptionId') && selector.getElementsByClassName("input_active")[0].querySelector('.colorOptionId').innerHTML != el.querySelector(".colorOptionId").innerHTML) {
            for (var i = 0; i < imprintSection.querySelectorAll(".prodColorOptions").length; i++) {
                if (imprintSection.querySelectorAll(".prodColorOptions")[i] != selector.querySelector(".prodColorOptions")) {
                    var allColors = [].slice.call(imprintSection.querySelectorAll(".prodColorOptions")[i].querySelectorAll('.colorOptionsContainer'));
                    for (var j = 0; j < allColors.length; j++) {
                        if (allColors[j].querySelector('.colorOptionId').innerHTML == el.querySelector(".colorOptionId").innerHTML) {
                            allColors[j].classList.add("hide");
                        }
                    }
                }
            }
            if (!previouslySelectedColor.querySelector(".input_placeholder")) {
                var allProdColors = [].slice.call(imprintSection.querySelectorAll(".prodColorOptions"));
                allProdColors.forEach(function (el) {
                    if (el != selector.querySelector(".prodColorOptions") || (editID > -1)) {
                        el.getElementsByClassName("colorId_" + colorOptionId)[0].classList.remove("hide");
                    }
                });
            }
        }
        el.setAttribute("aria-selected", "true");
        var btns = [].slice.call(selector.querySelectorAll(".spnColorChip"));
        btns.forEach(function (btnElem) {
            if (el != btnElem) {
                btnElem.setAttribute("aria-selected", "false");
            }
        });
        selector.querySelector(".input_active").innerHTML = el.innerHTML;
        updateRemoveColorText(selector);
        selector.querySelector(".input_active").querySelector(".colorOptionText").classList.add("txtToValidate");
        selector.querySelector(".prodColorOptions").classList.remove("txtReq");
        //selector.querySelector(".prodColorOptions").setAttribute("title", selector.querySelector(".input_active").querySelector(".colorOptionDesc").innerHTML);
        selector.querySelector(".colorOptions").classList.add("hide");
        selector.querySelector(".colorOptions").removeAttribute("style");
        if (!selector.querySelector(".prodColorOptions").classList.contains("disabledColorSelect")) {
        	selector.querySelector(".imprintClearColor").classList.remove("hide");
        }
    };

    var bindAddImpColor = function (e) {
        clearGFeedPanel();
        forms.ClearValidation();
        if (document.getElementsByClassName('ErrorMsgPanel')[0]) {
            document.getElementsByClassName('ErrorMsgPanel')[0].parentNode.removeChild(document.getElementsByClassName('ErrorMsgPanel')[0]);
        }
        var el = e.target;
        var nextColorSection = el.parentNode.parentNode.querySelector('.imprint-color-section.hide');
        var currentColorSection;
        if (nextColorSection) {
            var numSections = el.parentNode.parentNode.querySelectorAll(".imprint-color-section").length - el.parentNode.parentNode.querySelectorAll('.imprint-color-section.hide').length;
            currentColorSection = el.parentNode.parentNode.querySelectorAll(".imprint-color-section")[numSections - 1];
        }
        if (currentColorSection != null && currentColorSection.querySelector(".input_active").querySelector(".input_placeholder")) {
            forms.ClearValidation();
            var elemToValidate = currentColorSection.querySelector(".txtReq");
            document.querySelector('.imprintConfiguration').insertAdjacentHTML('beforebegin', errorMessageBox);
            if (listSelectedColors.length == 0) {
                document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<a href="#' + elemToValidate.id + '" tabindex="0" class="errorItem">Please select a product imprint ' + localizedJS.Color + '.</a>';
            } else {
                document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<a href="#' + elemToValidate.id + '" tabindex="0" class="errorItem">Please select a product imprint ' + localizedJS.Color + ' before adding a new one.</a>';
            }
            document.getElementsByClassName("errorItem")[0].focus();
            currentColorSection.querySelector(".txtReq").classList.add("input-validation-error");
            currentColorSection.querySelector(".txtReq").setAttribute("aria-invalid", "true");
            currentColorSection.querySelector(".txtReq").parentNode.querySelector(".errorMessage").classList.remove("hide");
            currentColorSection.querySelector(".txtReq").parentNode.querySelector(".errorMessage").innerHTML = document.getElementsByClassName("errorItem")[0].innerHTML;
        } else {
            if (nextColorSection) {
                nextColorSection.classList.remove("hide");
                nextColorSection.querySelector(".prodColorOptions").classList.add("txtReq");
                nextColorSection.querySelector(".prodColorOptions").focus();
                nextColorSection.getElementsByClassName("imprintClearColor")[0].classList.remove("hide");
            }
            if (el.parentNode.parentNode.querySelector(".imprintColorsCount").innerHTML == el.parentNode.parentNode.querySelectorAll(".imprint-color-section").length - el.parentNode.parentNode.querySelectorAll(".imprint-color-section.hide").length) {
                el.classList.add("hide");
            }
        }
    };

    var bindClearImprintColor = function (e) {
        clearGFeedPanel();
        e.preventDefault();
        var el = e.target;
        el.parentNode.getElementsByClassName('colorList')[0].querySelector('.selectedColor').style.backgroundColor = "rgba(0, 0, 0, 0)";
        el.parentNode.getElementsByClassName('colorList')[0].querySelector('.selectedColor').setAttribute('title', 'Please select a "' + localizedJS.Color + '" from the "' + localizedJS.Color + '" picker');
        el.parentNode.getElementsByClassName('colorList')[0].querySelector('.imprintColorID').value = "";
        var activeSection = el.parentNode.parentNode.parentNode.parentNode;
        var activeSectionNum = activeSection.querySelector(".impLocCount").innerHTML;
        if (!el.previousElementSibling.querySelector(".input_active").querySelector(".input_placeholder")) {
            var colorOptionId = el.previousElementSibling.querySelector(".input_active").querySelector(".colorOptionId").innerHTML;
            var allProdColors = [].slice.call(activeSection.querySelectorAll(".prodColorOptions"));
            allProdColors.forEach(function (elem) {
                elem.getElementsByClassName("colorId_" + colorOptionId)[0].classList.remove("hide");
            });
        }
        var colorSection = el.parentNode.parentNode.parentNode;
        colorSection.getElementsByClassName("colorOptions")[0].classList.add("hide");
        colorSection.getElementsByClassName("colorOptions")[0].removeAttribute("style");
        var maxImpColors = colorSection.querySelector(".imprintColorsCount").innerHTML;
        var newColorSection = colorSection;
        if (activeSection.querySelectorAll('.imprint-color-section').length - activeSection.querySelectorAll('.imprint-color-section.hide').length == 1) { // indicates this is the first color option area
            newColorSection.getElementsByClassName("imprintClearColor")[0].classList.add("hide");
            var locationCountText = activeSection.getElementsByClassName("impLocCount")[0].innerHTML;
            newColorSection.querySelector(".prodColorOptions").classList.add("txtReq");
            if (newColorSection.parentNode == document.getElementsByClassName("imprintConfiguration")[0]) {
                newColorSection.getElementsByClassName("input_active")[0].innerHTML = colorDropdownPlaceholder;
            } else {
                newColorSection.getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + " for " + activeSectionNum + " Location...</span>";
            }
            newColorSection.querySelector(".prodColorOptions").setAttribute("title", "Please select a product imprint " + localizedJS.Color + " for the " + locationCountText.toLowerCase() + " location.");
            if (maxImpColors > 1) {
                activeSection.getElementsByClassName("addImpColor")[0].classList.remove("hide");
            }
            if (listSelectedColors.length == 0 && parseInt(document.getElementById("BaseExtra").value) == 0) {
                document.getElementsByClassName("extrasRow")[0].classList.add("hide");
                document.getElementsByClassName("extrasResult")[0].innerHTML = "0.00";
                document.getElementsByClassName("currencySymbol")[0].classList.remove("hide");
            } else if (listSelectedColors.length == 0 && parseInt(document.getElementById("BaseExtra").value) > 0) {
                document.getElementsByClassName("extrasResult")[0].innerHTML = parseFloat(document.getElementById("BaseExtra").value).toFixed(2);
            }
            newColorSection.querySelector(".prodColorOptions").focus();
        } else { // not the first color option area 
            if (activeSection.querySelectorAll('.imprint-color-section').length - activeSection.querySelectorAll('.imprint-color-section.hide').length > 1 && newColorSection == activeSection.getElementsByClassName("imprint-color-section")[0]) {
                activeSection.getElementsByClassName("imprint-color-section")[1].querySelector(".impColorSelectLabel").innerHTML = "What imprint " + localizedJS.Color + "(s) would you like?<span> (Maximum # imprint colors: <span class='imprintColorsCount'>" + maxImpColors + "</span>)</span>";
                if (activeSection.getElementsByClassName("imprint-color-section")[1].querySelector(".input_placeholder")) {
                    activeSection.getElementsByClassName("imprint-color-section")[1].querySelector(".input_active").innerHTML = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + "...</span>";
                    activeSection.getElementsByClassName("imprint-color-section")[1].querySelector(".imprintClearColor").classList.add("hide");
                }
            } else {
                colorSection.parentNode.removeChild(colorSection);
            }
            newColorSection.getElementsByClassName("impColorSelectLabel")[0].innerHTML = "Select an additional imprint " + localizedJS.Color + "<span> (Maximum # imprint colors: <span class='imprintColorsCount'>" + maxImpColors + "</span>)</span>";
            activeSection.getElementsByClassName('imprint-color-section')[activeSection.getElementsByClassName('imprint-color-section').length - 1].insertAdjacentElement('afterend', newColorSection);
            newColorSection.classList.add("hide");
            if (newColorSection.parentNode == document.getElementsByClassName("imprintConfiguration")[0]) {
                newColorSection.querySelector(".input_active").innerHTML = "<span class='input_placeholder'>Select Additional Imprint " + colorCapitalized + "...</span>";
            } else {
                newColorSection.querySelector(".input_active").innerHTML = "<span class='input_placeholder'>Select Additional Imprint " + colorCapitalized + " for " + activeSectionNum + " Location...</span>";
            }
            var numColorSections = activeSection.querySelectorAll(".imprint-color-section").length - activeSection.querySelectorAll(".imprint-color-section.hide").length;
            el.parentNode.querySelector(".prodColorOptions").classList.remove("txtReq");
            activeSection.getElementsByClassName("addImpColor")[0].classList.remove("hide");
            activeSection.querySelectorAll(".imprint-color-section")[numColorSections - 1].querySelector(".prodColorOptions").focus();
        }
        for (i = 0; i < activeSection.querySelectorAll(".imprint-color-section").length; i++) {
            if (activeSection.querySelectorAll(".imprint-color-section")[i]) {
                updateRemoveColorText(activeSection.querySelectorAll(".imprint-color-section")[i]);
            }
        }
        GetSelectedImprintColors();
        if (listSelectedColors.length > 0) {
            ajaxActions.GetExtrasAmount();
        }
        ValidateCustomizeSections();
    };

    var updateRemoveColorText = function (colorSelector) { //imprint-color-section
        var colorID = colorSelector.querySelector(".input_active") && colorSelector.querySelector(".input_active").querySelector(".colorOptionId") ? colorSelector.querySelector(".input_active").querySelector(".colorOptionId").innerHTML : "";
        var colorName = colorID != "" ? colorSelector.querySelector(".colorId_" + colorID).querySelector(".colorOptionDesc").innerHTML : "";
        if (colorName == "") {
            colorSelector.getElementsByClassName("imprintClearColor")[0].setAttribute("title", "Remove Additional " + colorCapitalized + " from " + colorSelector.parentNode.getElementsByClassName("selImprintLocation")[0][colorSelector.parentNode.getElementsByClassName("selImprintLocation")[0].selectedIndex].text);
        } else {
            colorSelector.getElementsByClassName("imprintClearColor")[0].setAttribute("title", "Remove " + colorCapitalized + " " + colorName.trim() + " from " + colorSelector.parentNode.getElementsByClassName("selImprintLocation")[0][colorSelector.parentNode.getElementsByClassName("selImprintLocation")[0].selectedIndex].text);
        }
    };

    var bindImpLocDropDowns = function (e) {
        clearGFeedPanel();
        var locDropDown = e.target;
        if (locDropDown.parentNode.parentNode.querySelector(".impLocLoadingImg")) {
            locDropDown.parentNode.parentNode.querySelector(".impLocLoadingImg").classList.remove("hide");
            locDropDown.parentNode.parentNode.querySelector(".impLocLoadingOverlay").classList.remove("hide");
        }
        var impConfigSection = locDropDown.parentNode.parentNode;
        var impColorSections = impConfigSection.getElementsByClassName("imprint-color-section");
        for (i = 0; i < impColorSections.length; i++) {
            if (impColorSections[i]) {
                if (i == 0 && !impColorSections[0].querySelector(".prodColorOptions").classList.contains("disabledColorSelect")) {
                    impConfigSection.querySelector(".prodColorOptions").classList.add("txtReq");
                    if (impConfigSection == document.getElementsByClassName("imprintConfiguration")[0]) {
                        impColorSections[i].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + "...</span>";
                    }
                    else {
                        impColorSections[i].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + " for " + getLocationCountText(i+1) + " Location ...</span>";
                    }
                } else {
                     impColorSections[i].classList.add("hide");
                    if (i == impColorSections.length) {
                        impColorSections[i].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Additional Imprint " + colorCapitalized + " for " + getLocationCountText(i) + " Location ...</span>";
                    } else {
                        impColorSections[i].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + " for " + getLocationCountText(i) + " Location ...</span>";
                    }
                }
                impColorSections[i].getElementsByClassName("colorList")[0].getElementsByClassName('imprintColorID')[0].value = '';
                impColorSections[i].getElementsByClassName("imprintClearColor")[0].classList.add("hide");
                updateRemoveColorText(impColorSections[i]);
            }
        }
        locDropDown.id = "impLocation_" + locDropDown.value;
        locDropDown.parentNode.querySelector(".locSelectLabel").setAttribute("for", locDropDown.id);
        var impLocIDs = [].slice.call(impConfigSection.querySelectorAll('.imprintLocationID'));
        impLocIDs.forEach(function (impLocIDsElem) {
            impLocIDsElem.value = locDropDown.value;
        });
        var impLocDropDowns = [].slice.call(document.getElementsByClassName("selImprintLocation"));
        impLocDropDowns.forEach(function (element, index) {
            var duplicate = false;
            if (element[element.selectedIndex].text == locDropDown[locDropDown.selectedIndex].text && element != locDropDown) {
                duplicate = true;
                var allProdColorContainers = [].slice.call(impConfigSection.querySelectorAll(".colorOptionsContainer"));
                allProdColorContainers.forEach(function (elem) {
                    elem.classList.remove("hide");
                });
                locDropDown.parentNode.parentNode.querySelector(".input_active").innerHTML = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + " for " + getLocationCountText(index) + " Location ...</span>";
            }
            if (document.getElementsByClassName("imprintConfiguration").length > 1 && duplicate) {
                element.parentNode.parentNode.parentNode.removeChild(element.parentNode.parentNode);
                var numSections = document.getElementsByClassName("imprintConfiguration").length;
                document.getElementsByClassName("imprintConfiguration")[numSections - 1].getElementsByClassName("addImpLocation")[0].classList.remove("hide");
                for (i = 0; i < numSections; i++) {
                    if (i != 0) {
                        var impLocCounts = [].slice.call(document.getElementsByClassName("imprintConfiguration")[i].getElementsByClassName("impLocCount"));
                        impLocCounts.forEach(function (el, index, array) {
                            el.innerHTML = getLocationCountText(i);
                        });
                        if (numSections - 1 >= 1) {
                            document.getElementsByClassName("imprintConfiguration")[numSections - 1].getElementsByClassName("impLocationCountHeader")[0].classList.remove("hide");
                        }
                    }
                }
            }
            if (duplicate) {
                setLocationCounts();
            }
        });
        setLocationCounts();
        ajaxActions.GetExtrasAmount(true);
        GetSelectedImprintLocations();
        ajaxActions.UpdateLocationDetails(listImprintLocationIDs, locDropDown);
        var locationLabels = [].slice.call(document.querySelectorAll(".impColorSelectLabel"));
        locationLabels.forEach(function (elem, index, array) {
            var colId = elem.nextElementSibling.firstElementChild.firstElementChild.querySelector(".colorOptionId") ? elem.nextElementSibling.firstElementChild.firstElementChild.querySelector(".colorOptionId").innerHTML : "0";
            elem.id = "impLocLbl_" + locDropDown.value + "_Color_" + colId + "_" + index;
            elem.nextElementSibling.firstElementChild.setAttribute("aria-labelledby", elem.id);
        });
        var colorDropDowns = [].slice.call(document.querySelectorAll(".prodColorOptions"));
        colorDropDowns.forEach(function (elem, index, array) {
            var colId = elem.firstElementChild.querySelector(".colorOptionId") ? elem.firstElementChild.querySelector(".colorOptionId").innerHTML : "0";
            elem.id = "impLoc_" + locDropDown.value + "_Color_" + colId + "_" + index;
        });
        ValidateCustomizeSections();
    };

    var initVideo = function () {
        // if video link
        if (document.getElementsByClassName("videoLink")[0]) {
            var videoData = new videos4i();
            videoData.initLinks();
        }
    };

    var checkSetEdit = function () {
        if (editID > 0) {
            var selectedColor = document.getElementById("selectedColorID").value;
            var productColorOptions = [].slice.call(document.getElementsByClassName("selectedColorID"));
            productColorOptions.forEach(function (el, index, array) {
                if (el.value === selectedColor) {
                    setTimeout(function () {
                        if (el.parentNode.getElementsByTagName("button")[0]) {
                            el.parentNode.getElementsByTagName("button")[0].click();
                        }
                        if (el.parentNode.getElementsByTagName("a")[0]) {
                            el.parentNode.getElementsByTagName("a")[0].click();
                        }
                    }, 1200);
                }
            });
            colorSelectorKeyboardFunctions();
            var impLocHdrs = document.getElementsByClassName("impLocationCountHeader").length;
            if (document.getElementsByClassName("impLocationCountHeader")[impLocHdrs - 1] && impLocHdrs > 1) {
                document.getElementsByClassName("impLocationCountHeader")[impLocHdrs - 1].classList.remove("hide");
            }
        }
    };

    var bindDesktopStepLink = function () {
        if (!isMobile) {
            var nextLinks = [].slice.call(document.getElementsByClassName("nextStep"));
            nextLinks.forEach(function (el, index, array) {
                el.addEventListener("click", goToNextStep);
                el.addEventListener("keyup", goToNextStep);
            });
        }
    };

    var selectedColorID = selBaseTrim.value;
    if (selectedColorID != "") {
        var selectedColors = [].slice.call(document.getElementsByClassName('selectedColorID'));
        selectedColors.forEach(function (el, index, array) {
            if (el.value == selectedColorID) {
                setTimeout(function () {
                    el.previousElementSibling.click();
                }, 1200);
            }
        });
    }
    var getAttributes = function () {
        if (optionalExtras == null && hasOptionalExtras) {
            ajaxActions.LoadOptionalExtras();
        }
        if (nibInkOptions == null) {
            ajaxActions.LoadNibInkColor();
        }
        if (adhSidesOptions == null) {
            ajaxActions.LoadAdhesiveOptions();
        }
    };

    var setLocationCounts = function () {
        var impConfigSections = document.getElementsByClassName("imprintConfiguration");
        for (var i = 0; i < impConfigSections.length; i++) {
            var locationCountText = getLocationCountText(i);
            var impLocCounts = [].slice.call(impConfigSections[i].getElementsByClassName("impLocCount"));
            impLocCounts.forEach(function (el, index, array) {
                el.innerHTML = locationCountText;
            });
            if (impConfigSections[i].getElementsByClassName("impLocCount")[0].innerHTML == "First") {
                impConfigSections[i].getElementsByClassName("impLocationCountHeader")[0].classList.add("hide");
            }
            if (impConfigSections[i].getElementsByClassName("imprint-color-section").length > 0) {
                var prodColorOpts = [].slice.call(impConfigSections[i].querySelectorAll(".prodColorOptions"));
                prodColorOpts.forEach(function (el) {
                    el.setAttribute("title", "Please select a product imprint " + localizedJS.Color + " for the " + locationCountText.toLowerCase() + " location.");
                });
                var activeInputs = [].slice.call(impConfigSections[i].querySelectorAll(".input_active"));
                activeInputs.forEach(function (el) {
                    el.setAttribute("title", "Please select a product imprint " + localizedJS.Color + " for the " + locationCountText.toLowerCase() + " location.");
                });
            }
            for (var j = 0; j < impConfigSections[i].querySelectorAll(".prodColorOptions").length; j++) {
                updateRemoveColorText(impConfigSections[i].querySelectorAll(".prodColorOptions")[j].parentNode.parentNode.parentNode);
                if (impConfigSections[i].querySelectorAll(".prodColorOptions")[j].getElementsByClassName("input_active")[0].querySelector(".input_placeholder")) {
                    if (i == 0) {
                        if (j == 0) {         
                            impConfigSections[i].querySelectorAll(".prodColorOptions")[j].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + "...</span>";
                            impConfigSections[i].querySelectorAll(".prodColorOptions")[j].nextElementSibling.classList.add("hide");
                        } else {
                            impConfigSections[i].querySelectorAll(".prodColorOptions")[j].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Additional Imprint " + colorCapitalized + "...</span>";
                        }
                    } else {
                        if (j != 0) {
                            impConfigSections[i].querySelectorAll(".prodColorOptions")[j].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Additional Imprint " + colorCapitalized + " for " + getLocationCountText(i) + " Location ...</span>";
                        } else {
                            impConfigSections[i].querySelectorAll(".prodColorOptions")[j].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + " for " + getLocationCountText(i) + " Location ...</span>";
                        }
                    }
                }
            }
        }
    };

    var getLocationCountText = function (locationCount) {
        var imprintLocationCountText = "";
        switch (locationCount) {
            case 0:
                imprintLocationCountText = "First";
                break;
            case 1:
                imprintLocationCountText = "Second";
                break;
            case 2:
                imprintLocationCountText = "Third";
                break;
            case 3:
                imprintLocationCountText = "Fourth";
                break;
            case 4:
                imprintLocationCountText = "Fifth";
                break;
            case 5:
                imprintLocationCountText = "Sixth";
                break;
            case 6:
                imprintLocationCountText = "Seventh";
                break;
            case 7:
                imprintLocationCountText = "Eighth";
                break;
            case 8:
                imprintLocationCountText = "Ninth";
                break;
            case 9:
                imprintLocationCountText = "Tenth";
                break;
            case 10:
                imprintLocationCountText = "Eleventh";
                break;
            case 11:
                imprintLocationCountText = "Twelfth";
                break;
            case 12:
                imprintLocationCountText = "Thirteenth";
                break;
            case 13:
                imprintLocationCountText = "Fourteenth";
                break;
            case 14:
                imprintLocationCountText = "Fifteenth";
                break;
            default:
                imprintLocationCountText = "";
                break;
        }
        return imprintLocationCountText;
    };

    var extraChargesLoadError = function () {
        if (!bypassImpConfig) {
            document.querySelector('.extraChargesLoading').style.display = "none";
            document.getElementsByClassName('extrasResultLine')[0].insertAdjacentHTML('beforebegin', '<div role="status" class="text16 semibold textDkRed">Sorry, an error has occurred. Please try again.<br/> You can also view item imprint charges in your cart.</div>');
            document.getElementsByClassName('extrasResultLine')[0].classList.add("hide");
            document.getElementsByClassName("setupTooltip")[0].parentNode.classList.add("hide");
            document.getElementsByClassName("setupTooltip")[0].parentNode.classList.remove("inlineTop");
        } else {
            document.getElementById("loading").classList.add("hide");
            document.getElementById('lblBaseExtras').parentNode.innerHTML = '<div role="status" class="text16 semibold textDkRed">Sorry, an error has occurred. Please try again. You can also view item imprint charges in your cart.</div>';
            document.getElementsByClassName("setupTooltip")[0].parentNode.classList.add("hide");
            document.getElementsByClassName("setupTooltip")[0].parentNode.classList.remove("inlineTop");
        }
    };

    var checkForReorderChanges = function () {
        var isReorder = document.getElementById("isReorder").value.toLowerCase() === 'true';
        if (!isReorder || editID < 1) {
            return;
        }
        document.getElementById('reorderAlertBox').classList.add('alertWarning');
        document.getElementById('reorderAlertBoxSummary').classList.add('alertWarning');
        document.getElementById('reorderAlertBox').scrollIntoView({
            behavior: "smooth"
        });
    };

    if (totalProductImages == 1 || editID > 0) {
        if (document.getElementsByClassName("step1")[0]) {
            document.getElementsByClassName("step1")[0].classList.remove("disabledBtn");
            document.getElementsByClassName("step1")[0].classList.add("bkgdBlue");
            document.getElementsByClassName("step1")[0].classList.add("whiteLink");
        }
    }

    if (!isSuspended) {
        sliderGlide.Init();
    }
    if (currencySymbol) {
        currencySymbol = currencySymbol.replace(/\s+/g, '');
    }
    
    if (isGFeed) {
        if(!isApparelItem){
            setTimeout(function () {
                var imgBox = document.querySelector('.imgBox');

                if (imgBox) {
                    imgBox.click();
                }
                if (!isMobile) { CheckQueryString(); }
            }, 1200);

            // per shawn a - glide pricing should be hidden to avoid ad disapprovals
            document.getElementById("litGlideTotal").classList.add("hide");
            document.getElementById("lblQuantityTxtCaption").classList.add("hide");
            document.getElementsByClassName("glide")[0].lastElementChild.classList.add("hide"); //unit price            
            //causes the extras to get added twice on mobile, think this is a good place to not run it twice
        }  else if (totalProductImages > 1) {
            document.getElementById('GFeedPanel').style.display = "none";
            setTimeout(function () {
                document.querySelector('.imgBox').click();
            }, 1200);
        } else if (totalProductImages == 1) {
            document.getElementsByClassName('txtApparelQty')[0].value = lowestQty;
            CalcPrice();
            CheckQueryString();
        }
        var productColorImgs = [].slice.call(document.getElementsByClassName("imgBox"));
        if (productColorImgs.length > 0) {
            setTimeout(function () {
                productColorImgs[0].click();
            }, 1200);
        }
    }

    if (bypassImpConfig) {
        document.querySelector('.btnAddToCart').classList.remove('disabledBtn');
        document.querySelector('.btnAddToCart').classList.remove('bkgdMdGray');
        document.querySelector('.btnAddToCart').classList.add('bkgdRed');
        document.querySelector('.btnAddToCart').classList.add('whiteLink');
    }

    if (recolorAvailable && recolorAvailable.value === "False" && isApparelItem) {
        //used for setting apparel events, specifically for apparel items with only 1 color -- example item: 148213-M
        if (document.getElementsByClassName("addMoreSizes")[0]) {
            addSizesEvent();
        } else if (document.getElementsByClassName('clearAllSizes')[0]) { // occurs when editing
            clearSizesEvent();
        }

        var sizingInputs = [].slice.call(document.getElementsByClassName('txtApparelQty'));
        sizingInputs.forEach(function (el) {
            el.addEventListener("focusout", sizeInputsEvent);
            el.addEventListener("keyup", sizeInputsEvent);
        });
    }

    checkSetEdit();
    bindDesktopStepLink();
    initGuaranteeDialog();
    initArtDialog();
    setUpHashOptions();
    initProductColorScroller();
    tooltips.init();
    ajaxActions.LoadMiniRating();
    initProp65();
    initVideo();
    initHandlers();
    ImageZoom.Init();
    MobileTweaks();
    clearFloat();
    sliderGlide.CheckForSingleQtyBreak();
    initAppear();
    colorOptionsClicks();
    threeSixtyView();
    setTimeout(function () {
        copyTabs.init(document.getElementById("copyTabs"));
    }, 1200);
})();